/* tslint:disable */
/* eslint-disable */
/**
 * ERP
 * Api for staging - v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ApprovalConfig
 */
export interface ApprovalConfig {
    /**
     * 
     * @type {number}
     * @memberof ApprovalConfig
     */
    'level': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApprovalConfig
     */
    'approve': Array<ApprovalConfigApproveEnum>;
    /**
     * 
     * @type {string}
     * @memberof ApprovalConfig
     */
    'recruitmentTypeId': string;
    /**
     * 
     * @type {RecruitmentType}
     * @memberof ApprovalConfig
     */
    'recruitmentType': RecruitmentType;
    /**
     * 
     * @type {string}
     * @memberof ApprovalConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovalConfig
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovalConfig
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovalConfig
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovalConfig
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovalConfig
     */
    'deletedAt': string;
}

export const ApprovalConfigApproveEnum = {
    RequestCheckin: 'REQUEST_CHECKIN',
    RequestCheckout: 'REQUEST_CHECKOUT',
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    RequestTimekeepingEdit: 'REQUEST_TIMEKEEPING_EDIT',
    AnnualLeave: 'ANNUAL_LEAVE',
    CompensatoryLeave: 'COMPENSATORY_LEAVE',
    MakeupWork: 'MAKEUP_WORK',
    WorkOnDayOff: 'WORK_ON_DAY_OFF',
    BusinessTrip: 'BUSINESS_TRIP'
} as const;

export type ApprovalConfigApproveEnum = typeof ApprovalConfigApproveEnum[keyof typeof ApprovalConfigApproveEnum];

/**
 * 
 * @export
 * @interface ApprovalConfigControllerGetAllByRecruitmentTypeId200Response
 */
export interface ApprovalConfigControllerGetAllByRecruitmentTypeId200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ApprovalConfigControllerGetAllByRecruitmentTypeId200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApprovalConfigControllerGetAllByRecruitmentTypeId200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ApprovalConfig>}
     * @memberof ApprovalConfigControllerGetAllByRecruitmentTypeId200Response
     */
    'data'?: Array<ApprovalConfig>;
}
/**
 * 
 * @export
 * @interface ApprovalConfigControllerGetAllByRecruitmentTypeId200ResponseAllOf
 */
export interface ApprovalConfigControllerGetAllByRecruitmentTypeId200ResponseAllOf {
    /**
     * 
     * @type {Array<ApprovalConfig>}
     * @memberof ApprovalConfigControllerGetAllByRecruitmentTypeId200ResponseAllOf
     */
    'data'?: Array<ApprovalConfig>;
}
/**
 * 
 * @export
 * @interface Approver
 */
export interface Approver {
    /**
     * 
     * @type {number}
     * @memberof Approver
     */
    'level': number;
    /**
     * 
     * @type {string}
     * @memberof Approver
     */
    'managerId': string;
    /**
     * 
     * @type {string}
     * @memberof Approver
     */
    'employeeId': string;
    /**
     * 
     * @type {User}
     * @memberof Approver
     */
    'manager': User;
    /**
     * 
     * @type {User}
     * @memberof Approver
     */
    'employee': User;
    /**
     * 
     * @type {string}
     * @memberof Approver
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Approver
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Approver
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Approver
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Approver
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Approver
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface AuthControllerLogin200Response
 */
export interface AuthControllerLogin200Response {
    /**
     * 
     * @type {boolean}
     * @memberof AuthControllerLogin200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthControllerLogin200Response
     */
    'message'?: string;
    /**
     * 
     * @type {LoginDataDto}
     * @memberof AuthControllerLogin200Response
     */
    'data'?: LoginDataDto;
}
/**
 * 
 * @export
 * @interface AuthControllerLogin200ResponseAllOf
 */
export interface AuthControllerLogin200ResponseAllOf {
    /**
     * 
     * @type {LoginDataDto}
     * @memberof AuthControllerLogin200ResponseAllOf
     */
    'data'?: LoginDataDto;
}
/**
 * 
 * @export
 * @interface BatchUpdateConfirmationDto
 */
export interface BatchUpdateConfirmationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchUpdateConfirmationDto
     */
    'ids': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BatchUpdateConfirmationDto
     */
    'status': BatchUpdateConfirmationDtoStatusEnum;
}

export const BatchUpdateConfirmationDtoStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_MINUS_1: -1
} as const;

export type BatchUpdateConfirmationDtoStatusEnum = typeof BatchUpdateConfirmationDtoStatusEnum[keyof typeof BatchUpdateConfirmationDtoStatusEnum];

/**
 * 
 * @export
 * @interface BatchUpsertWorkScheduleDto
 */
export interface BatchUpsertWorkScheduleDto {
    /**
     * 
     * @type {Array<CreateWorkScheduleDto>}
     * @memberof BatchUpsertWorkScheduleDto
     */
    'data': Array<CreateWorkScheduleDto>;
}
/**
 * 
 * @export
 * @interface Booking
 */
export interface Booking {
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'type': BookingTypeEnum;
    /**
     * 
     * @type {Array<BookingTime>}
     * @memberof Booking
     */
    'bookingTimes': Array<BookingTime>;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'deletedAt': string;
}

export const BookingTypeEnum = {
    MeetingRoom: 'MEETING_ROOM',
    Car: 'CAR'
} as const;

export type BookingTypeEnum = typeof BookingTypeEnum[keyof typeof BookingTypeEnum];

/**
 * 
 * @export
 * @interface BookingControllerGetBookingById200Response
 */
export interface BookingControllerGetBookingById200Response {
    /**
     * 
     * @type {boolean}
     * @memberof BookingControllerGetBookingById200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingControllerGetBookingById200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Booking}
     * @memberof BookingControllerGetBookingById200Response
     */
    'data'?: Booking;
}
/**
 * 
 * @export
 * @interface BookingControllerGetBookingById200ResponseAllOf
 */
export interface BookingControllerGetBookingById200ResponseAllOf {
    /**
     * 
     * @type {Booking}
     * @memberof BookingControllerGetBookingById200ResponseAllOf
     */
    'data'?: Booking;
}
/**
 * 
 * @export
 * @interface BookingControllerGetListMeetingRooms200Response
 */
export interface BookingControllerGetListMeetingRooms200Response {
    /**
     * 
     * @type {boolean}
     * @memberof BookingControllerGetListMeetingRooms200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookingControllerGetListMeetingRooms200Response
     */
    'message'?: string;
    /**
     * 
     * @type {BookingControllerGetListMeetingRooms200ResponseAllOfData}
     * @memberof BookingControllerGetListMeetingRooms200Response
     */
    'data'?: BookingControllerGetListMeetingRooms200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface BookingControllerGetListMeetingRooms200ResponseAllOf
 */
export interface BookingControllerGetListMeetingRooms200ResponseAllOf {
    /**
     * 
     * @type {BookingControllerGetListMeetingRooms200ResponseAllOfData}
     * @memberof BookingControllerGetListMeetingRooms200ResponseAllOf
     */
    'data'?: BookingControllerGetListMeetingRooms200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface BookingControllerGetListMeetingRooms200ResponseAllOfData
 */
export interface BookingControllerGetListMeetingRooms200ResponseAllOfData {
    /**
     * 
     * @type {Array<Booking>}
     * @memberof BookingControllerGetListMeetingRooms200ResponseAllOfData
     */
    'content'?: Array<Booking>;
    /**
     * 
     * @type {number}
     * @memberof BookingControllerGetListMeetingRooms200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingControllerGetListMeetingRooms200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingControllerGetListMeetingRooms200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface BookingControllerGetListMeetingRooms200ResponseAllOfDataAllOf
 */
export interface BookingControllerGetListMeetingRooms200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<Booking>}
     * @memberof BookingControllerGetListMeetingRooms200ResponseAllOfDataAllOf
     */
    'content'?: Array<Booking>;
}
/**
 * 
 * @export
 * @interface BookingTime
 */
export interface BookingTime {
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'bookingId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'startDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'endDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'status': BookingTimeStatusEnum;
    /**
     * 
     * @type {User}
     * @memberof BookingTime
     */
    'user': User;
    /**
     * 
     * @type {Booking}
     * @memberof BookingTime
     */
    'booking': Booking;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingTime
     */
    'deletedAt': string;
}

export const BookingTimeStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Refused: 'REFUSED'
} as const;

export type BookingTimeStatusEnum = typeof BookingTimeStatusEnum[keyof typeof BookingTimeStatusEnum];

/**
 * 
 * @export
 * @interface Confirmation
 */
export interface Confirmation {
    /**
     * 
     * @type {number}
     * @memberof Confirmation
     */
    'status': ConfirmationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'type': ConfirmationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Confirmation
     */
    'level': number;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'timekeepingReportId': string;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'managerId': string;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'scheduleId': string;
    /**
     * 
     * @type {TimekeepingReport}
     * @memberof Confirmation
     */
    'timekeepingReport': TimekeepingReport;
    /**
     * 
     * @type {User}
     * @memberof Confirmation
     */
    'manager': User;
    /**
     * 
     * @type {Schedule}
     * @memberof Confirmation
     */
    'schedule': Schedule;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Confirmation
     */
    'deletedAt': string;
}

export const ConfirmationStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_MINUS_1: -1
} as const;

export type ConfirmationStatusEnum = typeof ConfirmationStatusEnum[keyof typeof ConfirmationStatusEnum];
export const ConfirmationTypeEnum = {
    TimekeepingReport: 'TIMEKEEPING_REPORT',
    Schedule: 'SCHEDULE'
} as const;

export type ConfirmationTypeEnum = typeof ConfirmationTypeEnum[keyof typeof ConfirmationTypeEnum];

/**
 * 
 * @export
 * @interface ConfirmationControllerGetListApprove200Response
 */
export interface ConfirmationControllerGetListApprove200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmationControllerGetListApprove200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfirmationControllerGetListApprove200Response
     */
    'message'?: string;
    /**
     * 
     * @type {ConfirmationControllerGetListApprove200ResponseAllOfData}
     * @memberof ConfirmationControllerGetListApprove200Response
     */
    'data'?: ConfirmationControllerGetListApprove200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface ConfirmationControllerGetListApprove200ResponseAllOf
 */
export interface ConfirmationControllerGetListApprove200ResponseAllOf {
    /**
     * 
     * @type {ConfirmationControllerGetListApprove200ResponseAllOfData}
     * @memberof ConfirmationControllerGetListApprove200ResponseAllOf
     */
    'data'?: ConfirmationControllerGetListApprove200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface ConfirmationControllerGetListApprove200ResponseAllOfData
 */
export interface ConfirmationControllerGetListApprove200ResponseAllOfData {
    /**
     * 
     * @type {Array<GetListConfirmationDto>}
     * @memberof ConfirmationControllerGetListApprove200ResponseAllOfData
     */
    'content'?: Array<GetListConfirmationDto>;
    /**
     * 
     * @type {number}
     * @memberof ConfirmationControllerGetListApprove200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfirmationControllerGetListApprove200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfirmationControllerGetListApprove200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface ConfirmationControllerGetListApprove200ResponseAllOfDataAllOf
 */
export interface ConfirmationControllerGetListApprove200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<GetListConfirmationDto>}
     * @memberof ConfirmationControllerGetListApprove200ResponseAllOfDataAllOf
     */
    'content'?: Array<GetListConfirmationDto>;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface ContactControllerCreate200Response
 */
export interface ContactControllerCreate200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ContactControllerCreate200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactControllerCreate200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Contact}
     * @memberof ContactControllerCreate200Response
     */
    'data'?: Contact;
}
/**
 * 
 * @export
 * @interface ContactControllerCreate200ResponseAllOf
 */
export interface ContactControllerCreate200ResponseAllOf {
    /**
     * 
     * @type {Contact}
     * @memberof ContactControllerCreate200ResponseAllOf
     */
    'data'?: Contact;
}
/**
 * 
 * @export
 * @interface ContactControllerFindAll200Response
 */
export interface ContactControllerFindAll200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ContactControllerFindAll200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactControllerFindAll200Response
     */
    'message'?: string;
    /**
     * 
     * @type {ContactControllerFindAll200ResponseAllOfData}
     * @memberof ContactControllerFindAll200Response
     */
    'data'?: ContactControllerFindAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface ContactControllerFindAll200ResponseAllOf
 */
export interface ContactControllerFindAll200ResponseAllOf {
    /**
     * 
     * @type {ContactControllerFindAll200ResponseAllOfData}
     * @memberof ContactControllerFindAll200ResponseAllOf
     */
    'data'?: ContactControllerFindAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface ContactControllerFindAll200ResponseAllOfData
 */
export interface ContactControllerFindAll200ResponseAllOfData {
    /**
     * 
     * @type {Array<Contact>}
     * @memberof ContactControllerFindAll200ResponseAllOfData
     */
    'content'?: Array<Contact>;
    /**
     * 
     * @type {number}
     * @memberof ContactControllerFindAll200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactControllerFindAll200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactControllerFindAll200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface ContactControllerFindAll200ResponseAllOfDataAllOf
 */
export interface ContactControllerFindAll200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<Contact>}
     * @memberof ContactControllerFindAll200ResponseAllOfDataAllOf
     */
    'content'?: Array<Contact>;
}
/**
 * 
 * @export
 * @interface CreateApprovalConfigDto
 */
export interface CreateApprovalConfigDto {
    /**
     * 
     * @type {number}
     * @memberof CreateApprovalConfigDto
     */
    'level': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateApprovalConfigDto
     */
    'approve': Array<CreateApprovalConfigDtoApproveEnum>;
    /**
     * 
     * @type {string}
     * @memberof CreateApprovalConfigDto
     */
    'recruitmentTypeId'?: string;
}

export const CreateApprovalConfigDtoApproveEnum = {
    RequestCheckin: 'REQUEST_CHECKIN',
    RequestCheckout: 'REQUEST_CHECKOUT',
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    RequestTimekeepingEdit: 'REQUEST_TIMEKEEPING_EDIT',
    AnnualLeave: 'ANNUAL_LEAVE',
    CompensatoryLeave: 'COMPENSATORY_LEAVE',
    MakeupWork: 'MAKEUP_WORK',
    WorkOnDayOff: 'WORK_ON_DAY_OFF',
    BusinessTrip: 'BUSINESS_TRIP'
} as const;

export type CreateApprovalConfigDtoApproveEnum = typeof CreateApprovalConfigDtoApproveEnum[keyof typeof CreateApprovalConfigDtoApproveEnum];

/**
 * 
 * @export
 * @interface CreateApproverDto
 */
export interface CreateApproverDto {
    /**
     * 
     * @type {number}
     * @memberof CreateApproverDto
     */
    'level': number;
    /**
     * 
     * @type {string}
     * @memberof CreateApproverDto
     */
    'managerId'?: string;
}
/**
 * 
 * @export
 * @interface CreateBookingDto
 */
export interface CreateBookingDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBookingDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingDto
     */
    'type': CreateBookingDtoTypeEnum;
}

export const CreateBookingDtoTypeEnum = {
    MeetingRoom: 'MEETING_ROOM',
    Car: 'CAR'
} as const;

export type CreateBookingDtoTypeEnum = typeof CreateBookingDtoTypeEnum[keyof typeof CreateBookingDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateBookingTimeDto
 */
export interface CreateBookingTimeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBookingTimeDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingTimeDto
     */
    'bookingId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingTimeDto
     */
    'startDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingTimeDto
     */
    'endDateTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingTimeDto
     */
    'status'?: CreateBookingTimeDtoStatusEnum;
}

export const CreateBookingTimeDtoStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Refused: 'REFUSED'
} as const;

export type CreateBookingTimeDtoStatusEnum = typeof CreateBookingTimeDtoStatusEnum[keyof typeof CreateBookingTimeDtoStatusEnum];

/**
 * 
 * @export
 * @interface CreateContactDto
 */
export interface CreateContactDto {
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactDto
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface CreateDepartmentDto
 */
export interface CreateDepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDepartmentDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateLocationDto
 */
export interface CreateLocationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateManyUserDto
 */
export interface CreateManyUserDto {
    /**
     * 
     * @type {Array<CreateUserDataFromFile>}
     * @memberof CreateManyUserDto
     */
    'data': Array<CreateUserDataFromFile>;
}
/**
 * 
 * @export
 * @interface CreateOptionDto
 */
export interface CreateOptionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOptionDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOptionDto
     */
    'category': CreateOptionDtoCategoryEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOptionDto
     */
    'status'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOptionDto
     */
    'isAnnualLeaveOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOptionDto
     */
    'isCompensatoryLeaveOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOptionDto
     */
    'isRegisteredBusinessOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOptionDto
     */
    'isSuddenBusinessOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOptionDto
     */
    'isRequireAdditionalDetail'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateOptionDto
     */
    'durationOfLeave'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOptionDto
     */
    'isSendLineMessage'?: boolean;
}

export const CreateOptionDtoCategoryEnum = {
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    CheckIn: 'CHECK_IN',
    CheckOut: 'CHECK_OUT',
    Schedule: 'SCHEDULE'
} as const;

export type CreateOptionDtoCategoryEnum = typeof CreateOptionDtoCategoryEnum[keyof typeof CreateOptionDtoCategoryEnum];

/**
 * 
 * @export
 * @interface CreatePositionDto
 */
export interface CreatePositionDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePositionDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateRecruitmentTypeDto
 */
export interface CreateRecruitmentTypeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRecruitmentTypeDto
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface CreateReminderTimeDto
 */
export interface CreateReminderTimeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateReminderTimeDto
     */
    'checkInTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReminderTimeDto
     */
    'checkOutTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReminderTimeDto
     */
    'checkOutTime2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReminderTimeDto
     */
    'summaryTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReminderTimeDto
     */
    'summaryTime2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReminderTimeDto
     */
    'lineGroupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReminderTimeDto
     */
    'recruitmentTypeId': string;
}
/**
 * 
 * @export
 * @interface CreateReportDto
 */
export interface CreateReportDto {
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'option'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'timeStartOutside'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'timeBack'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'timeBackReality'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'timeEstimated'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'type'?: CreateReportDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'optionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'overtimeStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'overtimeEnd'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReportDto
     */
    'durationOfLeave'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'requestTimekeepingStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'requestTimekeepingEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReportDto
     */
    'summary'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReportDto
     */
    'isStandardCheckIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReportDto
     */
    'isStandardCheckOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReportDto
     */
    'isRequestedFromWeb'?: boolean;
}

export const CreateReportDtoTypeEnum = {
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    RequestTimekeepingEdit: 'REQUEST_TIMEKEEPING_EDIT',
    RequestCheckin: 'REQUEST_CHECKIN',
    RequestCheckout: 'REQUEST_CHECKOUT'
} as const;

export type CreateReportDtoTypeEnum = typeof CreateReportDtoTypeEnum[keyof typeof CreateReportDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateScheduleDto
 */
export interface CreateScheduleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'scheduleSettingId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'destination'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'transport'?: CreateScheduleDtoTransportEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'transportTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'transportContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'purpose'?: CreateScheduleDtoPurposeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'purposeTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'purposeContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleDto
     */
    'receipt'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateScheduleDto
     */
    'status'?: CreateScheduleDtoStatusEnum;
}

export const CreateScheduleDtoTransportEnum = {
    PublicTransport: 'PUBLIC_TRANSPORT',
    CompanyCar: 'COMPANY_CAR',
    PersonalCar: 'PERSONAL_CAR',
    Other: 'OTHER'
} as const;

export type CreateScheduleDtoTransportEnum = typeof CreateScheduleDtoTransportEnum[keyof typeof CreateScheduleDtoTransportEnum];
export const CreateScheduleDtoPurposeEnum = {
    Negotiation: 'NEGOTIATION',
    Meeting: 'MEETING',
    Delivery: 'DELIVERY',
    ConstructionRepair: 'CONSTRUCTION_REPAIR',
    Other: 'OTHER'
} as const;

export type CreateScheduleDtoPurposeEnum = typeof CreateScheduleDtoPurposeEnum[keyof typeof CreateScheduleDtoPurposeEnum];
export const CreateScheduleDtoStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_MINUS_1: -1
} as const;

export type CreateScheduleDtoStatusEnum = typeof CreateScheduleDtoStatusEnum[keyof typeof CreateScheduleDtoStatusEnum];

/**
 * 
 * @export
 * @interface CreateScheduleSettingDto
 */
export interface CreateScheduleSettingDto {
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleSettingDto
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleSettingDto
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface CreateUserDataEmployeeApprovals
 */
export interface CreateUserDataEmployeeApprovals {
    /**
     * 
     * @type {number}
     * @memberof CreateUserDataEmployeeApprovals
     */
    'level': number;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataEmployeeApprovals
     */
    'employeeCode': string;
}
/**
 * 
 * @export
 * @interface CreateUserDataFromFile
 */
export interface CreateUserDataFromFile {
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'furiganaName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'employeeCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'dateOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'displayPassword': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'officialWorkingDay': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'recruitmentType': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'position': string;
    /**
     * 
     * @type {Array<CreateUserDataEmployeeApprovals>}
     * @memberof CreateUserDataFromFile
     */
    'employeeApprovals': Array<CreateUserDataEmployeeApprovals>;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'approver1': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDataFromFile
     */
    'approver2': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserDataFromFile
     */
    'annualLeaveDaysRemaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUserDataFromFile
     */
    'compensatoryLeaveDaysRemaining'?: number;
}
/**
 * 
 * @export
 * @interface CreateUserDto
 */
export interface CreateUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'employeeCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'furiganaName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'gender'?: CreateUserDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'departmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'positionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'recruitmentTypeId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserDto
     */
    'annualLeaveDaysRemaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUserDto
     */
    'compensatoryLeaveDaysRemaining'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'googleCalendarId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'role'?: CreateUserDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'address'?: string;
    /**
     * 
     * @type {Array<CreateApproverDto>}
     * @memberof CreateUserDto
     */
    'employeeApprovals'?: Array<CreateApproverDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'officialWorkingDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'displayPassword'?: string;
}

export const CreateUserDtoGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Other: 'OTHER'
} as const;

export type CreateUserDtoGenderEnum = typeof CreateUserDtoGenderEnum[keyof typeof CreateUserDtoGenderEnum];
export const CreateUserDtoRoleEnum = {
    SuperAdmin: 'SUPER_ADMIN',
    Employee: 'EMPLOYEE',
    Manager: 'MANAGER'
} as const;

export type CreateUserDtoRoleEnum = typeof CreateUserDtoRoleEnum[keyof typeof CreateUserDtoRoleEnum];

/**
 * 
 * @export
 * @interface CreateWorkHoursDto
 */
export interface CreateWorkHoursDto {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkHoursDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkHoursDto
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkHoursDto
     */
    'type': CreateWorkHoursDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkHoursDto
     */
    'index': number;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkHoursDto
     */
    'recruitmentTypeId': string;
}

export const CreateWorkHoursDtoTypeEnum = {
    WorkHours: 'WORK_HOURS',
    BreakHours: 'BREAK_HOURS'
} as const;

export type CreateWorkHoursDtoTypeEnum = typeof CreateWorkHoursDtoTypeEnum[keyof typeof CreateWorkHoursDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateWorkScheduleDto
 */
export interface CreateWorkScheduleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkScheduleDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkScheduleDto
     */
    'type': CreateWorkScheduleDtoTypeEnum;
}

export const CreateWorkScheduleDtoTypeEnum = {
    WorkingDays: 'WORKING_DAYS',
    RegulatedDaysOff: 'REGULATED_DAYS_OFF',
    LegalDaysOff: 'LEGAL_DAYS_OFF'
} as const;

export type CreateWorkScheduleDtoTypeEnum = typeof CreateWorkScheduleDtoTypeEnum[keyof typeof CreateWorkScheduleDtoTypeEnum];

/**
 * 
 * @export
 * @interface DataTimeGrantDto
 */
export interface DataTimeGrantDto {
    /**
     * 
     * @type {number}
     * @memberof DataTimeGrantDto
     */
    'dayPerWeek': number;
    /**
     * 
     * @type {number}
     * @memberof DataTimeGrantDto
     */
    'dayPerYear': number;
    /**
     * 
     * @type {number}
     * @memberof DataTimeGrantDto
     */
    'half1stYear': number;
    /**
     * 
     * @type {number}
     * @memberof DataTimeGrantDto
     */
    'half2ndYear': number;
    /**
     * 
     * @type {number}
     * @memberof DataTimeGrantDto
     */
    'half3rdYear': number;
    /**
     * 
     * @type {number}
     * @memberof DataTimeGrantDto
     */
    'half4thYear': number;
    /**
     * 
     * @type {number}
     * @memberof DataTimeGrantDto
     */
    'half5thYear': number;
    /**
     * 
     * @type {number}
     * @memberof DataTimeGrantDto
     */
    'half6thYear': number;
    /**
     * 
     * @type {number}
     * @memberof DataTimeGrantDto
     */
    'aboveHalf7thYear': number;
}
/**
 * 
 * @export
 * @interface Department
 */
export interface Department {
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'name': string;
    /**
     * 
     * @type {Array<User>}
     * @memberof Department
     */
    'users': Array<User>;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface DepartmentControllerCreate200Response
 */
export interface DepartmentControllerCreate200Response {
    /**
     * 
     * @type {boolean}
     * @memberof DepartmentControllerCreate200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DepartmentControllerCreate200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Department}
     * @memberof DepartmentControllerCreate200Response
     */
    'data'?: Department;
}
/**
 * 
 * @export
 * @interface DepartmentControllerCreate200ResponseAllOf
 */
export interface DepartmentControllerCreate200ResponseAllOf {
    /**
     * 
     * @type {Department}
     * @memberof DepartmentControllerCreate200ResponseAllOf
     */
    'data'?: Department;
}
/**
 * 
 * @export
 * @interface DepartmentControllerFindAll200Response
 */
export interface DepartmentControllerFindAll200Response {
    /**
     * 
     * @type {boolean}
     * @memberof DepartmentControllerFindAll200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DepartmentControllerFindAll200Response
     */
    'message'?: string;
    /**
     * 
     * @type {DepartmentControllerFindAll200ResponseAllOfData}
     * @memberof DepartmentControllerFindAll200Response
     */
    'data'?: DepartmentControllerFindAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface DepartmentControllerFindAll200ResponseAllOf
 */
export interface DepartmentControllerFindAll200ResponseAllOf {
    /**
     * 
     * @type {DepartmentControllerFindAll200ResponseAllOfData}
     * @memberof DepartmentControllerFindAll200ResponseAllOf
     */
    'data'?: DepartmentControllerFindAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface DepartmentControllerFindAll200ResponseAllOfData
 */
export interface DepartmentControllerFindAll200ResponseAllOfData {
    /**
     * 
     * @type {Array<Department>}
     * @memberof DepartmentControllerFindAll200ResponseAllOfData
     */
    'content'?: Array<Department>;
    /**
     * 
     * @type {number}
     * @memberof DepartmentControllerFindAll200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof DepartmentControllerFindAll200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof DepartmentControllerFindAll200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface DepartmentControllerFindAll200ResponseAllOfDataAllOf
 */
export interface DepartmentControllerFindAll200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<Department>}
     * @memberof DepartmentControllerFindAll200ResponseAllOfDataAllOf
     */
    'content'?: Array<Department>;
}
/**
 * 
 * @export
 * @interface EmployeeRelatedInformationDto
 */
export interface EmployeeRelatedInformationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeRelatedInformationDto
     */
    'genders': Array<EmployeeRelatedInformationDtoGendersEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeRelatedInformationDto
     */
    'roles': Array<EmployeeRelatedInformationDtoRolesEnum>;
    /**
     * 
     * @type {Array<RecruitmentType>}
     * @memberof EmployeeRelatedInformationDto
     */
    'recruitmentTypes': Array<RecruitmentType>;
    /**
     * 
     * @type {Array<Department>}
     * @memberof EmployeeRelatedInformationDto
     */
    'departments': Array<Department>;
    /**
     * 
     * @type {Array<Position>}
     * @memberof EmployeeRelatedInformationDto
     */
    'positions': Array<Position>;
    /**
     * 
     * @type {Array<User>}
     * @memberof EmployeeRelatedInformationDto
     */
    'managers': Array<User>;
}

export const EmployeeRelatedInformationDtoGendersEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Other: 'OTHER'
} as const;

export type EmployeeRelatedInformationDtoGendersEnum = typeof EmployeeRelatedInformationDtoGendersEnum[keyof typeof EmployeeRelatedInformationDtoGendersEnum];
export const EmployeeRelatedInformationDtoRolesEnum = {
    SuperAdmin: 'SUPER_ADMIN',
    Employee: 'EMPLOYEE',
    Manager: 'MANAGER'
} as const;

export type EmployeeRelatedInformationDtoRolesEnum = typeof EmployeeRelatedInformationDtoRolesEnum[keyof typeof EmployeeRelatedInformationDtoRolesEnum];

/**
 * 
 * @export
 * @interface ExchangeCodeDto
 */
export interface ExchangeCodeDto {
    /**
     * 
     * @type {string}
     * @memberof ExchangeCodeDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface ExportWorkScheduleToCsvDto
 */
export interface ExportWorkScheduleToCsvDto {
    /**
     * 
     * @type {number}
     * @memberof ExportWorkScheduleToCsvDto
     */
    'year': number;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerConfigWorkSchedule200Response
 */
export interface GeneralConfigControllerConfigWorkSchedule200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerConfigWorkSchedule200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerConfigWorkSchedule200Response
     */
    'message'?: string;
    /**
     * 
     * @type {GeneralWorkingScheduleDto}
     * @memberof GeneralConfigControllerConfigWorkSchedule200Response
     */
    'data'?: GeneralWorkingScheduleDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerConfigWorkSchedule200ResponseAllOf
 */
export interface GeneralConfigControllerConfigWorkSchedule200ResponseAllOf {
    /**
     * 
     * @type {GeneralWorkingScheduleDto}
     * @memberof GeneralConfigControllerConfigWorkSchedule200ResponseAllOf
     */
    'data'?: GeneralWorkingScheduleDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerCreateOption200Response
 */
export interface GeneralConfigControllerCreateOption200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerCreateOption200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerCreateOption200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Option}
     * @memberof GeneralConfigControllerCreateOption200Response
     */
    'data'?: Option;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerCreateOption200ResponseAllOf
 */
export interface GeneralConfigControllerCreateOption200ResponseAllOf {
    /**
     * 
     * @type {Option}
     * @memberof GeneralConfigControllerCreateOption200ResponseAllOf
     */
    'data'?: Option;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetDefaultWorkHourByRecruitType200Response
 */
export interface GeneralConfigControllerGetDefaultWorkHourByRecruitType200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetDefaultWorkHourByRecruitType200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetDefaultWorkHourByRecruitType200Response
     */
    'message'?: string;
    /**
     * 
     * @type {object}
     * @memberof GeneralConfigControllerGetDefaultWorkHourByRecruitType200Response
     */
    'data'?: object;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetDefaultWorkHourByRecruitType200ResponseAllOf
 */
export interface GeneralConfigControllerGetDefaultWorkHourByRecruitType200ResponseAllOf {
    /**
     * 
     * @type {object}
     * @memberof GeneralConfigControllerGetDefaultWorkHourByRecruitType200ResponseAllOf
     */
    'data'?: object;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetImportTableData200Response
 */
export interface GeneralConfigControllerGetImportTableData200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetImportTableData200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetImportTableData200Response
     */
    'message'?: string;
    /**
     * 
     * @type {GetImportTableDataResponseDto}
     * @memberof GeneralConfigControllerGetImportTableData200Response
     */
    'data'?: GetImportTableDataResponseDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetImportTableData200ResponseAllOf
 */
export interface GeneralConfigControllerGetImportTableData200ResponseAllOf {
    /**
     * 
     * @type {GetImportTableDataResponseDto}
     * @memberof GeneralConfigControllerGetImportTableData200ResponseAllOf
     */
    'data'?: GetImportTableDataResponseDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetLineGroups200Response
 */
export interface GeneralConfigControllerGetLineGroups200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetLineGroups200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetLineGroups200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<LineGroup>}
     * @memberof GeneralConfigControllerGetLineGroups200Response
     */
    'data'?: Array<LineGroup>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetLineGroups200ResponseAllOf
 */
export interface GeneralConfigControllerGetLineGroups200ResponseAllOf {
    /**
     * 
     * @type {Array<LineGroup>}
     * @memberof GeneralConfigControllerGetLineGroups200ResponseAllOf
     */
    'data'?: Array<LineGroup>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetLineSettings200Response
 */
export interface GeneralConfigControllerGetLineSettings200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetLineSettings200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetLineSettings200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<LineConfigDto>}
     * @memberof GeneralConfigControllerGetLineSettings200Response
     */
    'data'?: Array<LineConfigDto>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetLineSettings200ResponseAllOf
 */
export interface GeneralConfigControllerGetLineSettings200ResponseAllOf {
    /**
     * 
     * @type {Array<LineConfigDto>}
     * @memberof GeneralConfigControllerGetLineSettings200ResponseAllOf
     */
    'data'?: Array<LineConfigDto>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetLogoConfig200Response
 */
export interface GeneralConfigControllerGetLogoConfig200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetLogoConfig200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetLogoConfig200Response
     */
    'message'?: string;
    /**
     * 
     * @type {LogoConfigDto}
     * @memberof GeneralConfigControllerGetLogoConfig200Response
     */
    'data'?: LogoConfigDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetLogoConfig200ResponseAllOf
 */
export interface GeneralConfigControllerGetLogoConfig200ResponseAllOf {
    /**
     * 
     * @type {LogoConfigDto}
     * @memberof GeneralConfigControllerGetLogoConfig200ResponseAllOf
     */
    'data'?: LogoConfigDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetOptionCategories200Response
 */
export interface GeneralConfigControllerGetOptionCategories200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetOptionCategories200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetOptionCategories200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<OptionCategoryDto>}
     * @memberof GeneralConfigControllerGetOptionCategories200Response
     */
    'data'?: Array<OptionCategoryDto>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetOptionCategories200ResponseAllOf
 */
export interface GeneralConfigControllerGetOptionCategories200ResponseAllOf {
    /**
     * 
     * @type {Array<OptionCategoryDto>}
     * @memberof GeneralConfigControllerGetOptionCategories200ResponseAllOf
     */
    'data'?: Array<OptionCategoryDto>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetOptions200Response
 */
export interface GeneralConfigControllerGetOptions200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetOptions200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetOptions200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Option>}
     * @memberof GeneralConfigControllerGetOptions200Response
     */
    'data'?: Array<Option>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetOptions200ResponseAllOf
 */
export interface GeneralConfigControllerGetOptions200ResponseAllOf {
    /**
     * 
     * @type {Array<Option>}
     * @memberof GeneralConfigControllerGetOptions200ResponseAllOf
     */
    'data'?: Array<Option>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetOvertimeRegulationsSettings200Response
 */
export interface GeneralConfigControllerGetOvertimeRegulationsSettings200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetOvertimeRegulationsSettings200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetOvertimeRegulationsSettings200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<OvertimeRegulationSettingsValueDto>}
     * @memberof GeneralConfigControllerGetOvertimeRegulationsSettings200Response
     */
    'data'?: Array<OvertimeRegulationSettingsValueDto>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetOvertimeRegulationsSettings200ResponseAllOf
 */
export interface GeneralConfigControllerGetOvertimeRegulationsSettings200ResponseAllOf {
    /**
     * 
     * @type {Array<OvertimeRegulationSettingsValueDto>}
     * @memberof GeneralConfigControllerGetOvertimeRegulationsSettings200ResponseAllOf
     */
    'data'?: Array<OvertimeRegulationSettingsValueDto>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetThisMonthWorkSchedule200Response
 */
export interface GeneralConfigControllerGetThisMonthWorkSchedule200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetThisMonthWorkSchedule200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetThisMonthWorkSchedule200Response
     */
    'message'?: string;
    /**
     * 
     * @type {GetThisMonthWorkScheduleDto}
     * @memberof GeneralConfigControllerGetThisMonthWorkSchedule200Response
     */
    'data'?: GetThisMonthWorkScheduleDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetThisMonthWorkSchedule200ResponseAllOf
 */
export interface GeneralConfigControllerGetThisMonthWorkSchedule200ResponseAllOf {
    /**
     * 
     * @type {GetThisMonthWorkScheduleDto}
     * @memberof GeneralConfigControllerGetThisMonthWorkSchedule200ResponseAllOf
     */
    'data'?: GetThisMonthWorkScheduleDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetTimeKeepingSettings200Response
 */
export interface GeneralConfigControllerGetTimeKeepingSettings200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetTimeKeepingSettings200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetTimeKeepingSettings200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<TimekeepingSettingsValueDto>}
     * @memberof GeneralConfigControllerGetTimeKeepingSettings200Response
     */
    'data'?: Array<TimekeepingSettingsValueDto>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetTimeKeepingSettings200ResponseAllOf
 */
export interface GeneralConfigControllerGetTimeKeepingSettings200ResponseAllOf {
    /**
     * 
     * @type {Array<TimekeepingSettingsValueDto>}
     * @memberof GeneralConfigControllerGetTimeKeepingSettings200ResponseAllOf
     */
    'data'?: Array<TimekeepingSettingsValueDto>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetWorkHours200Response
 */
export interface GeneralConfigControllerGetWorkHours200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetWorkHours200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetWorkHours200Response
     */
    'message'?: string;
    /**
     * 
     * @type {GetWorkHoursResponseDto}
     * @memberof GeneralConfigControllerGetWorkHours200Response
     */
    'data'?: GetWorkHoursResponseDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetWorkHours200ResponseAllOf
 */
export interface GeneralConfigControllerGetWorkHours200ResponseAllOf {
    /**
     * 
     * @type {GetWorkHoursResponseDto}
     * @memberof GeneralConfigControllerGetWorkHours200ResponseAllOf
     */
    'data'?: GetWorkHoursResponseDto;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetWorkScheduleToday200Response
 */
export interface GeneralConfigControllerGetWorkScheduleToday200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetWorkScheduleToday200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetWorkScheduleToday200Response
     */
    'message'?: string;
    /**
     * 
     * @type {WorkSchedule}
     * @memberof GeneralConfigControllerGetWorkScheduleToday200Response
     */
    'data'?: WorkSchedule;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetWorkScheduleToday200ResponseAllOf
 */
export interface GeneralConfigControllerGetWorkScheduleToday200ResponseAllOf {
    /**
     * 
     * @type {WorkSchedule}
     * @memberof GeneralConfigControllerGetWorkScheduleToday200ResponseAllOf
     */
    'data'?: WorkSchedule;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetWorkingSchedule200Response
 */
export interface GeneralConfigControllerGetWorkingSchedule200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerGetWorkingSchedule200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerGetWorkingSchedule200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<WorkSchedule>}
     * @memberof GeneralConfigControllerGetWorkingSchedule200Response
     */
    'data'?: Array<WorkSchedule>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerGetWorkingSchedule200ResponseAllOf
 */
export interface GeneralConfigControllerGetWorkingSchedule200ResponseAllOf {
    /**
     * 
     * @type {Array<WorkSchedule>}
     * @memberof GeneralConfigControllerGetWorkingSchedule200ResponseAllOf
     */
    'data'?: Array<WorkSchedule>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerSaveWorkHours200Response
 */
export interface GeneralConfigControllerSaveWorkHours200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GeneralConfigControllerSaveWorkHours200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GeneralConfigControllerSaveWorkHours200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<WorkHours>}
     * @memberof GeneralConfigControllerSaveWorkHours200Response
     */
    'data'?: Array<WorkHours>;
}
/**
 * 
 * @export
 * @interface GeneralConfigControllerSaveWorkHours200ResponseAllOf
 */
export interface GeneralConfigControllerSaveWorkHours200ResponseAllOf {
    /**
     * 
     * @type {Array<WorkHours>}
     * @memberof GeneralConfigControllerSaveWorkHours200ResponseAllOf
     */
    'data'?: Array<WorkHours>;
}
/**
 * 
 * @export
 * @interface GeneralWorkingScheduleDto
 */
export interface GeneralWorkingScheduleDto {
    /**
     * 
     * @type {number}
     * @memberof GeneralWorkingScheduleDto
     */
    'dayStartOfMonth': number;
    /**
     * 
     * @type {number}
     * @memberof GeneralWorkingScheduleDto
     */
    'dayEndOfMonth': number;
    /**
     * 
     * @type {number}
     * @memberof GeneralWorkingScheduleDto
     */
    'overtimePeriod': number;
    /**
     * 
     * @type {string}
     * @memberof GeneralWorkingScheduleDto
     */
    'nightOvertimeStart': string;
    /**
     * 
     * @type {string}
     * @memberof GeneralWorkingScheduleDto
     */
    'nightOvertimeEnd': string;
}
/**
 * 
 * @export
 * @interface GetAccessTokenLineDto
 */
export interface GetAccessTokenLineDto {
    /**
     * 
     * @type {string}
     * @memberof GetAccessTokenLineDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface GetEmployeeTimekeepingHistoryDto
 */
export interface GetEmployeeTimekeepingHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'dateType': string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'scheduleType'?: GetEmployeeTimekeepingHistoryDtoScheduleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'workType'?: GetEmployeeTimekeepingHistoryDtoWorkTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'end'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'actualTimeWorking'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'isCheckedOut'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'breakTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'overtimeDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'overtimeNight'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'stackOvertime'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'userId': string;
    /**
     * 
     * @type {object}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'workingTime'?: object;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'totalRestTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'timeLastStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'amountGoingLate'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'amountLeavingSoon'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'allowGoingLate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'allowLeavingSoon'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'requestDayOff'?: GetEmployeeTimekeepingHistoryDtoRequestDayOffEnum;
    /**
     * 
     * @type {number}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'standardWorkingTime'?: number;
    /**
     * 
     * @type {Array<TimekeepingReport>}
     * @memberof GetEmployeeTimekeepingHistoryDto
     */
    'reports'?: Array<TimekeepingReport>;
}

export const GetEmployeeTimekeepingHistoryDtoScheduleTypeEnum = {
    WorkingDays: 'WORKING_DAYS',
    RegulatedDaysOff: 'REGULATED_DAYS_OFF',
    LegalDaysOff: 'LEGAL_DAYS_OFF'
} as const;

export type GetEmployeeTimekeepingHistoryDtoScheduleTypeEnum = typeof GetEmployeeTimekeepingHistoryDtoScheduleTypeEnum[keyof typeof GetEmployeeTimekeepingHistoryDtoScheduleTypeEnum];
export const GetEmployeeTimekeepingHistoryDtoWorkTypeEnum = {
    NormalWork: 'NORMAL_WORK',
    CompensatoryWork: 'COMPENSATORY_WORK',
    Business: 'BUSINESS'
} as const;

export type GetEmployeeTimekeepingHistoryDtoWorkTypeEnum = typeof GetEmployeeTimekeepingHistoryDtoWorkTypeEnum[keyof typeof GetEmployeeTimekeepingHistoryDtoWorkTypeEnum];
export const GetEmployeeTimekeepingHistoryDtoRequestDayOffEnum = {
    AnnualLeave: 'ANNUAL_LEAVE',
    CompensatoryLeave: 'COMPENSATORY_LEAVE',
    Other: 'OTHER'
} as const;

export type GetEmployeeTimekeepingHistoryDtoRequestDayOffEnum = typeof GetEmployeeTimekeepingHistoryDtoRequestDayOffEnum[keyof typeof GetEmployeeTimekeepingHistoryDtoRequestDayOffEnum];

/**
 * 
 * @export
 * @interface GetImportTableDataResponseDto
 */
export interface GetImportTableDataResponseDto {
    /**
     * 
     * @type {Array<ImportTableColumns>}
     * @memberof GetImportTableDataResponseDto
     */
    'columns': Array<ImportTableColumns>;
    /**
     * 
     * @type {object}
     * @memberof GetImportTableDataResponseDto
     */
    'keyMapping': object;
}
/**
 * 
 * @export
 * @interface GetListConfirmationDto
 */
export interface GetListConfirmationDto {
    /**
     * 
     * @type {string}
     * @memberof GetListConfirmationDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetListConfirmationDto
     */
    'type': GetListConfirmationDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetListConfirmationDto
     */
    'title': string;
    /**
     * 
     * @type {User}
     * @memberof GetListConfirmationDto
     */
    'user': User;
    /**
     * 
     * @type {string}
     * @memberof GetListConfirmationDto
     */
    'timeRequest': string;
    /**
     * 
     * @type {string}
     * @memberof GetListConfirmationDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GetListConfirmationDto
     */
    'createdOnDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetListConfirmationDto
     */
    'status': GetListConfirmationDtoStatusEnum;
    /**
     * 
     * @type {TimekeepingReport}
     * @memberof GetListConfirmationDto
     */
    'timekeepingReport'?: TimekeepingReport;
    /**
     * 
     * @type {Schedule}
     * @memberof GetListConfirmationDto
     */
    'schedule'?: Schedule;
    /**
     * 
     * @type {string}
     * @memberof GetListConfirmationDto
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof GetListConfirmationDto
     */
    'date': string;
}

export const GetListConfirmationDtoTypeEnum = {
    TimekeepingReport: 'TIMEKEEPING_REPORT',
    Schedule: 'SCHEDULE'
} as const;

export type GetListConfirmationDtoTypeEnum = typeof GetListConfirmationDtoTypeEnum[keyof typeof GetListConfirmationDtoTypeEnum];
export const GetListConfirmationDtoStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_MINUS_1: -1
} as const;

export type GetListConfirmationDtoStatusEnum = typeof GetListConfirmationDtoStatusEnum[keyof typeof GetListConfirmationDtoStatusEnum];

/**
 * 
 * @export
 * @interface GetThisMonthWorkScheduleDto
 */
export interface GetThisMonthWorkScheduleDto {
    /**
     * 
     * @type {string}
     * @memberof GetThisMonthWorkScheduleDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetThisMonthWorkScheduleDto
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface GetTimekeepingHistoryStatisticDto
 */
export interface GetTimekeepingHistoryStatisticDto {
    /**
     * 
     * @type {string}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'employeeCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'employeeName': string;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfWorkDays': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersWorkDays': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersRegularWorkDays': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersAbsenceDays': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersGoingLateAndLeaveSoonDays': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersWorkDaysOnDayOff': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersAnnualLeaveDays': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersCompensatoryLeaveDays': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersOtherLeaveDaysOther': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersOtherLeaveDaysHourly': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfUsersOtherLeaveDaysMonthly': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfUsersOutsidePrivately': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfOvertimeInDay': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfOvertimeInNight': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfOvertimeRegulatedDaysOff': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfOvertimeLegalDaysOff': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'numberOfLeaveDayRemaining': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfOvertimeInNightLegalDaysOff': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfOvertimeLegalDaysOffAbove60Hours': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfOvertimeInDayRegulatedDaysOff': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfOvertimeInDayLegalDaysOff': number;
    /**
     * 
     * @type {number}
     * @memberof GetTimekeepingHistoryStatisticDto
     */
    'amountOfTotalTimeWorking': number;
}
/**
 * 
 * @export
 * @interface GetWorkHoursResponseDto
 */
export interface GetWorkHoursResponseDto {
    /**
     * 
     * @type {Array<WorkHoursResponseDto>}
     * @memberof GetWorkHoursResponseDto
     */
    'workHours': Array<WorkHoursResponseDto>;
    /**
     * 
     * @type {GeneralWorkingScheduleDto}
     * @memberof GetWorkHoursResponseDto
     */
    'general': GeneralWorkingScheduleDto;
}
/**
 * 
 * @export
 * @interface GoogleAccount
 */
export interface GoogleAccount {
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'photo': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'googleProfileId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'refreshToken': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'idToken': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'expiryDate': string;
    /**
     * 
     * @type {object}
     * @memberof GoogleAccount
     */
    'credentials': object | null;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAccount
     */
    'isAdmin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAccount
     */
    'isDefault': boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'userId': string;
    /**
     * 
     * @type {User}
     * @memberof GoogleAccount
     */
    'user': User;
    /**
     * 
     * @type {Array<GoogleCalendarChannel>}
     * @memberof GoogleAccount
     */
    'googleCalendarChannels': Array<GoogleCalendarChannel>;
    /**
     * 
     * @type {Array<GoogleCalendar>}
     * @memberof GoogleAccount
     */
    'googleCalendars': Array<GoogleCalendar>;
    /**
     * 
     * @type {Array<GoogleCalendarSyncTask>}
     * @memberof GoogleAccount
     */
    'currentGoogleCalendarSyncTasks': Array<GoogleCalendarSyncTask>;
    /**
     * 
     * @type {Array<GoogleCalendarSyncTask>}
     * @memberof GoogleAccount
     */
    'targetGoogleCalendarSyncTasks': Array<GoogleCalendarSyncTask>;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccount
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetAuthUrl200Response
 */
export interface GoogleAccountControllerGetAuthUrl200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAccountControllerGetAuthUrl200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccountControllerGetAuthUrl200Response
     */
    'message'?: string;
    /**
     * 
     * @type {UrlDto}
     * @memberof GoogleAccountControllerGetAuthUrl200Response
     */
    'data'?: UrlDto;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetAuthUrl200ResponseAllOf
 */
export interface GoogleAccountControllerGetAuthUrl200ResponseAllOf {
    /**
     * 
     * @type {UrlDto}
     * @memberof GoogleAccountControllerGetAuthUrl200ResponseAllOf
     */
    'data'?: UrlDto;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetEmployees200Response
 */
export interface GoogleAccountControllerGetEmployees200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAccountControllerGetEmployees200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccountControllerGetEmployees200Response
     */
    'message'?: string;
    /**
     * 
     * @type {GoogleAccountControllerGetEmployees200ResponseAllOfData}
     * @memberof GoogleAccountControllerGetEmployees200Response
     */
    'data'?: GoogleAccountControllerGetEmployees200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetEmployees200ResponseAllOf
 */
export interface GoogleAccountControllerGetEmployees200ResponseAllOf {
    /**
     * 
     * @type {GoogleAccountControllerGetEmployees200ResponseAllOfData}
     * @memberof GoogleAccountControllerGetEmployees200ResponseAllOf
     */
    'data'?: GoogleAccountControllerGetEmployees200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetEmployees200ResponseAllOfData
 */
export interface GoogleAccountControllerGetEmployees200ResponseAllOfData {
    /**
     * 
     * @type {Array<User>}
     * @memberof GoogleAccountControllerGetEmployees200ResponseAllOfData
     */
    'content'?: Array<User>;
    /**
     * 
     * @type {number}
     * @memberof GoogleAccountControllerGetEmployees200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleAccountControllerGetEmployees200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleAccountControllerGetEmployees200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetEmployees200ResponseAllOfDataAllOf
 */
export interface GoogleAccountControllerGetEmployees200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<User>}
     * @memberof GoogleAccountControllerGetEmployees200ResponseAllOfDataAllOf
     */
    'content'?: Array<User>;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetGoogleCalendarSyncTasks200Response
 */
export interface GoogleAccountControllerGetGoogleCalendarSyncTasks200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAccountControllerGetGoogleCalendarSyncTasks200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccountControllerGetGoogleCalendarSyncTasks200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<GoogleCalendarSyncTask>}
     * @memberof GoogleAccountControllerGetGoogleCalendarSyncTasks200Response
     */
    'data'?: Array<GoogleCalendarSyncTask>;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetGoogleCalendarSyncTasks200ResponseAllOf
 */
export interface GoogleAccountControllerGetGoogleCalendarSyncTasks200ResponseAllOf {
    /**
     * 
     * @type {Array<GoogleCalendarSyncTask>}
     * @memberof GoogleAccountControllerGetGoogleCalendarSyncTasks200ResponseAllOf
     */
    'data'?: Array<GoogleCalendarSyncTask>;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetInfoGoogleAccount200Response
 */
export interface GoogleAccountControllerGetInfoGoogleAccount200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAccountControllerGetInfoGoogleAccount200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccountControllerGetInfoGoogleAccount200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<GoogleAccount>}
     * @memberof GoogleAccountControllerGetInfoGoogleAccount200Response
     */
    'data'?: Array<GoogleAccount>;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetInfoGoogleAccount200ResponseAllOf
 */
export interface GoogleAccountControllerGetInfoGoogleAccount200ResponseAllOf {
    /**
     * 
     * @type {Array<GoogleAccount>}
     * @memberof GoogleAccountControllerGetInfoGoogleAccount200ResponseAllOf
     */
    'data'?: Array<GoogleAccount>;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetListAdminGoogleAccount200Response
 */
export interface GoogleAccountControllerGetListAdminGoogleAccount200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAccountControllerGetListAdminGoogleAccount200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccountControllerGetListAdminGoogleAccount200Response
     */
    'message'?: string;
    /**
     * 
     * @type {GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData}
     * @memberof GoogleAccountControllerGetListAdminGoogleAccount200Response
     */
    'data'?: GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOf
 */
export interface GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOf {
    /**
     * 
     * @type {GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData}
     * @memberof GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOf
     */
    'data'?: GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData
 */
export interface GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData {
    /**
     * 
     * @type {Array<GoogleAccount>}
     * @memberof GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData
     */
    'content'?: Array<GoogleAccount>;
    /**
     * 
     * @type {number}
     * @memberof GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfDataAllOf
 */
export interface GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<GoogleAccount>}
     * @memberof GoogleAccountControllerGetListAdminGoogleAccount200ResponseAllOfDataAllOf
     */
    'content'?: Array<GoogleAccount>;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerLinkAccount200Response
 */
export interface GoogleAccountControllerLinkAccount200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAccountControllerLinkAccount200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAccountControllerLinkAccount200Response
     */
    'message'?: string;
    /**
     * 
     * @type {GoogleAccount}
     * @memberof GoogleAccountControllerLinkAccount200Response
     */
    'data'?: GoogleAccount;
}
/**
 * 
 * @export
 * @interface GoogleAccountControllerLinkAccount200ResponseAllOf
 */
export interface GoogleAccountControllerLinkAccount200ResponseAllOf {
    /**
     * 
     * @type {GoogleAccount}
     * @memberof GoogleAccountControllerLinkAccount200ResponseAllOf
     */
    'data'?: GoogleAccount;
}
/**
 * 
 * @export
 * @interface GoogleCalendar
 */
export interface GoogleCalendar {
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'googleCalendarId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'timeZone': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'googleAccountId': string;
    /**
     * 
     * @type {GoogleAccount}
     * @memberof GoogleCalendar
     */
    'googleAccount': GoogleAccount;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendar
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface GoogleCalendarChannel
 */
export interface GoogleCalendarChannel {
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'expiryDate': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'resourceUri': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'type': GoogleCalendarChannelTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'googleAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'googleCalendarId': string;
    /**
     * 
     * @type {GoogleAccount}
     * @memberof GoogleCalendarChannel
     */
    'googleAccount': GoogleAccount;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarChannel
     */
    'deletedAt': string;
}

export const GoogleCalendarChannelTypeEnum = {
    CalendarList: 'CALENDAR_LIST',
    Events: 'EVENTS'
} as const;

export type GoogleCalendarChannelTypeEnum = typeof GoogleCalendarChannelTypeEnum[keyof typeof GoogleCalendarChannelTypeEnum];

/**
 * 
 * @export
 * @interface GoogleCalendarSyncTask
 */
export interface GoogleCalendarSyncTask {
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarSyncTask
     */
    'currentGoogleAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarSyncTask
     */
    'targetGoogleAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GoogleCalendarSyncTask
     */
    'totalOfCalendars': number;
    /**
     * 
     * @type {number}
     * @memberof GoogleCalendarSyncTask
     */
    'numberOfSuccessCalendars': number;
    /**
     * 
     * @type {number}
     * @memberof GoogleCalendarSyncTask
     */
    'numberOfFailedCalendars': number;
    /**
     * 
     * @type {object}
     * @memberof GoogleCalendarSyncTask
     */
    'data': object;
    /**
     * 
     * @type {GoogleAccount}
     * @memberof GoogleCalendarSyncTask
     */
    'currentGoogleAccount': GoogleAccount;
    /**
     * 
     * @type {GoogleAccount}
     * @memberof GoogleCalendarSyncTask
     */
    'targetGoogleAccount': GoogleAccount;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarSyncTask
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarSyncTask
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarSyncTask
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarSyncTask
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarSyncTask
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarSyncTask
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface IActualCheckTimes
 */
export interface IActualCheckTimes {
    /**
     * 
     * @type {string}
     * @memberof IActualCheckTimes
     */
    'checkIn'?: string;
    /**
     * 
     * @type {string}
     * @memberof IActualCheckTimes
     */
    'checkOut'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IActualCheckTimes
     */
    'isStandardCheckIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IActualCheckTimes
     */
    'isStandardCheckOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IActualCheckTimes
     */
    'isRequestedFromWeb'?: boolean;
}
/**
 * 
 * @export
 * @interface ImportTableColumns
 */
export interface ImportTableColumns {
    /**
     * 
     * @type {string}
     * @memberof ImportTableColumns
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ImportTableColumns
     */
    'dataIndex': string;
    /**
     * 
     * @type {string}
     * @memberof ImportTableColumns
     */
    'key': string;
    /**
     * 
     * @type {number}
     * @memberof ImportTableColumns
     */
    'minWidth'?: number;
}
/**
 * 
 * @export
 * @interface LeaveRegulationConfig
 */
export interface LeaveRegulationConfig {
    /**
     * 
     * @type {string}
     * @memberof LeaveRegulationConfig
     */
    'baseOn': LeaveRegulationConfigBaseOnEnum;
    /**
     * 
     * @type {number}
     * @memberof LeaveRegulationConfig
     */
    'dayPerWeek': number;
    /**
     * 
     * @type {number}
     * @memberof LeaveRegulationConfig
     */
    'firstGrantAfter': number;
    /**
     * 
     * @type {boolean}
     * @memberof LeaveRegulationConfig
     */
    'isSetting2ndBase': boolean;
    /**
     * 
     * @type {number}
     * @memberof LeaveRegulationConfig
     */
    'dayOf2ndBase': number;
    /**
     * 
     * @type {number}
     * @memberof LeaveRegulationConfig
     */
    'monthOf2ndBase': number;
    /**
     * 
     * @type {boolean}
     * @memberof LeaveRegulationConfig
     */
    'isDividedHalfYear': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeaveRegulationConfig
     */
    'isPriority2ndBase': boolean;
    /**
     * 
     * @type {Array<DataTimeGrantDto>}
     * @memberof LeaveRegulationConfig
     */
    'dataTimeGrant': Array<DataTimeGrantDto>;
    /**
     * 
     * @type {string}
     * @memberof LeaveRegulationConfig
     */
    'recruitmentTypeId': string;
    /**
     * 
     * @type {RecruitmentType}
     * @memberof LeaveRegulationConfig
     */
    'recruitmentType': RecruitmentType;
    /**
     * 
     * @type {string}
     * @memberof LeaveRegulationConfig
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LeaveRegulationConfig
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof LeaveRegulationConfig
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof LeaveRegulationConfig
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof LeaveRegulationConfig
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof LeaveRegulationConfig
     */
    'deletedAt': string;
}

export const LeaveRegulationConfigBaseOnEnum = {
    Week: 'week',
    Year: 'year'
} as const;

export type LeaveRegulationConfigBaseOnEnum = typeof LeaveRegulationConfigBaseOnEnum[keyof typeof LeaveRegulationConfigBaseOnEnum];

/**
 * 
 * @export
 * @interface LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200Response
 */
export interface LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200Response {
    /**
     * 
     * @type {boolean}
     * @memberof LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200Response
     */
    'message'?: string;
    /**
     * 
     * @type {LeaveRegulationConfig}
     * @memberof LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200Response
     */
    'data'?: LeaveRegulationConfig;
}
/**
 * 
 * @export
 * @interface LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200ResponseAllOf
 */
export interface LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200ResponseAllOf {
    /**
     * 
     * @type {LeaveRegulationConfig}
     * @memberof LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200ResponseAllOf
     */
    'data'?: LeaveRegulationConfig;
}
/**
 * 
 * @export
 * @interface LineAccount
 */
export interface LineAccount {
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'lineId': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'photo': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'accessToken': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'refreshToken': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'idToken': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'expiryDate': string;
    /**
     * 
     * @type {object}
     * @memberof LineAccount
     */
    'credentials': object | null;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'userId': string;
    /**
     * 
     * @type {User}
     * @memberof LineAccount
     */
    'user': User;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof LineAccount
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface LineConfigDto
 */
export interface LineConfigDto {
    /**
     * 
     * @type {string}
     * @memberof LineConfigDto
     */
    'key': LineConfigDtoKeyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof LineConfigDto
     */
    'value'?: Array<string>;
}

export const LineConfigDtoKeyEnum = {
    Checkin: 'CHECKIN',
    Checkout: 'CHECKOUT',
    RequestCheckin: 'REQUEST_CHECKIN',
    RequestCheckout: 'REQUEST_CHECKOUT',
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    RequestTimekeepingEdit: 'REQUEST_TIMEKEEPING_EDIT',
    AnnualLeave: 'ANNUAL_LEAVE',
    CompensatoryLeave: 'COMPENSATORY_LEAVE',
    MakeupWork: 'MAKEUP_WORK',
    WorkOnDayOff: 'WORK_ON_DAY_OFF',
    BusinessTrip: 'BUSINESS_TRIP'
} as const;

export type LineConfigDtoKeyEnum = typeof LineConfigDtoKeyEnum[keyof typeof LineConfigDtoKeyEnum];

/**
 * 
 * @export
 * @interface LineGroup
 */
export interface LineGroup {
    /**
     * 
     * @type {string}
     * @memberof LineGroup
     */
    'groupId': string;
    /**
     * 
     * @type {string}
     * @memberof LineGroup
     */
    'groupName': string;
    /**
     * 
     * @type {string}
     * @memberof LineGroup
     */
    'pictureUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof LineGroup
     */
    'status': boolean;
    /**
     * 
     * @type {Array<ReminderTime>}
     * @memberof LineGroup
     */
    'reminderTimes': Array<ReminderTime>;
    /**
     * 
     * @type {string}
     * @memberof LineGroup
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LineGroup
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof LineGroup
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof LineGroup
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof LineGroup
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof LineGroup
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface LinkGoogleAccountEmployee
 */
export interface LinkGoogleAccountEmployee {
    /**
     * 
     * @type {string}
     * @memberof LinkGoogleAccountEmployee
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof LinkGoogleAccountEmployee
     */
    'photo': string;
    /**
     * 
     * @type {string}
     * @memberof LinkGoogleAccountEmployee
     */
    'displayName': string;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'name': string;
    /**
     * 
     * @type {Array<User>}
     * @memberof Location
     */
    'users': Array<User>;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface LocationControllerCreate200Response
 */
export interface LocationControllerCreate200Response {
    /**
     * 
     * @type {boolean}
     * @memberof LocationControllerCreate200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LocationControllerCreate200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Location}
     * @memberof LocationControllerCreate200Response
     */
    'data'?: Location;
}
/**
 * 
 * @export
 * @interface LocationControllerCreate200ResponseAllOf
 */
export interface LocationControllerCreate200ResponseAllOf {
    /**
     * 
     * @type {Location}
     * @memberof LocationControllerCreate200ResponseAllOf
     */
    'data'?: Location;
}
/**
 * 
 * @export
 * @interface LocationControllerGetAll200Response
 */
export interface LocationControllerGetAll200Response {
    /**
     * 
     * @type {boolean}
     * @memberof LocationControllerGetAll200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LocationControllerGetAll200Response
     */
    'message'?: string;
    /**
     * 
     * @type {LocationControllerGetAll200ResponseAllOfData}
     * @memberof LocationControllerGetAll200Response
     */
    'data'?: LocationControllerGetAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface LocationControllerGetAll200ResponseAllOf
 */
export interface LocationControllerGetAll200ResponseAllOf {
    /**
     * 
     * @type {LocationControllerGetAll200ResponseAllOfData}
     * @memberof LocationControllerGetAll200ResponseAllOf
     */
    'data'?: LocationControllerGetAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface LocationControllerGetAll200ResponseAllOfData
 */
export interface LocationControllerGetAll200ResponseAllOfData {
    /**
     * 
     * @type {Array<Location>}
     * @memberof LocationControllerGetAll200ResponseAllOfData
     */
    'content'?: Array<Location>;
    /**
     * 
     * @type {number}
     * @memberof LocationControllerGetAll200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationControllerGetAll200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationControllerGetAll200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface LocationControllerGetAll200ResponseAllOfDataAllOf
 */
export interface LocationControllerGetAll200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<Location>}
     * @memberof LocationControllerGetAll200ResponseAllOfDataAllOf
     */
    'content'?: Array<Location>;
}
/**
 * 
 * @export
 * @interface LoginDataDto
 */
export interface LoginDataDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDataDto
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'employeeCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LogoConfigDto
 */
export interface LogoConfigDto {
    /**
     * 
     * @type {string}
     * @memberof LogoConfigDto
     */
    'filePath': string;
    /**
     * 
     * @type {string}
     * @memberof LogoConfigDto
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof LogoConfigDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface Option
 */
export interface Option {
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'category': OptionCategoryEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Option
     */
    'status': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Option
     */
    'isAnnualLeaveOption': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Option
     */
    'isCompensatoryLeaveOption': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Option
     */
    'isRequireAdditionalDetail': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Option
     */
    'isMakeUpWorkOption': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Option
     */
    'isWorkOnDayOffOption': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Option
     */
    'isSendLineMessage': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Option
     */
    'isDefaultOption': boolean;
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'deletedAt': string;
}

export const OptionCategoryEnum = {
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    CheckIn: 'CHECK_IN',
    CheckOut: 'CHECK_OUT',
    Schedule: 'SCHEDULE'
} as const;

export type OptionCategoryEnum = typeof OptionCategoryEnum[keyof typeof OptionCategoryEnum];

/**
 * 
 * @export
 * @interface OptionCategoryDto
 */
export interface OptionCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof OptionCategoryDto
     */
    'code': OptionCategoryDtoCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof OptionCategoryDto
     */
    'title': string;
}

export const OptionCategoryDtoCodeEnum = {
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    CheckIn: 'CHECK_IN',
    CheckOut: 'CHECK_OUT',
    Schedule: 'SCHEDULE'
} as const;

export type OptionCategoryDtoCodeEnum = typeof OptionCategoryDtoCodeEnum[keyof typeof OptionCategoryDtoCodeEnum];

/**
 * 
 * @export
 * @interface OvertimeControllerStatisticsOvertime200Response
 */
export interface OvertimeControllerStatisticsOvertime200Response {
    /**
     * 
     * @type {boolean}
     * @memberof OvertimeControllerStatisticsOvertime200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OvertimeControllerStatisticsOvertime200Response
     */
    'message'?: string;
    /**
     * 
     * @type {StatisticsOvertimeResponse}
     * @memberof OvertimeControllerStatisticsOvertime200Response
     */
    'data'?: StatisticsOvertimeResponse;
}
/**
 * 
 * @export
 * @interface OvertimeControllerStatisticsOvertime200ResponseAllOf
 */
export interface OvertimeControllerStatisticsOvertime200ResponseAllOf {
    /**
     * 
     * @type {StatisticsOvertimeResponse}
     * @memberof OvertimeControllerStatisticsOvertime200ResponseAllOf
     */
    'data'?: StatisticsOvertimeResponse;
}
/**
 * 
 * @export
 * @interface OvertimeRegulationSettingsValueDto
 */
export interface OvertimeRegulationSettingsValueDto {
    /**
     * 
     * @type {number}
     * @memberof OvertimeRegulationSettingsValueDto
     */
    'yearlyOvertimeLimit': number;
    /**
     * 
     * @type {number}
     * @memberof OvertimeRegulationSettingsValueDto
     */
    'avgMonthlyOvertime': number;
    /**
     * 
     * @type {number}
     * @memberof OvertimeRegulationSettingsValueDto
     */
    'singleMonthLimit': number;
    /**
     * 
     * @type {number}
     * @memberof OvertimeRegulationSettingsValueDto
     */
    'overtimeExceed': number;
}
/**
 * 
 * @export
 * @interface PaginationResponse
 */
export interface PaginationResponse {
    /**
     * 
     * @type {object}
     * @memberof PaginationResponse
     */
    'content'?: object;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponse
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponse
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponse
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'name': string;
    /**
     * 
     * @type {Array<User>}
     * @memberof Position
     */
    'users': Array<User>;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface PositionControllerCreate200Response
 */
export interface PositionControllerCreate200Response {
    /**
     * 
     * @type {boolean}
     * @memberof PositionControllerCreate200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PositionControllerCreate200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Position}
     * @memberof PositionControllerCreate200Response
     */
    'data'?: Position;
}
/**
 * 
 * @export
 * @interface PositionControllerCreate200ResponseAllOf
 */
export interface PositionControllerCreate200ResponseAllOf {
    /**
     * 
     * @type {Position}
     * @memberof PositionControllerCreate200ResponseAllOf
     */
    'data'?: Position;
}
/**
 * 
 * @export
 * @interface PositionControllerFindAll200Response
 */
export interface PositionControllerFindAll200Response {
    /**
     * 
     * @type {boolean}
     * @memberof PositionControllerFindAll200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PositionControllerFindAll200Response
     */
    'message'?: string;
    /**
     * 
     * @type {PositionControllerFindAll200ResponseAllOfData}
     * @memberof PositionControllerFindAll200Response
     */
    'data'?: PositionControllerFindAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface PositionControllerFindAll200ResponseAllOf
 */
export interface PositionControllerFindAll200ResponseAllOf {
    /**
     * 
     * @type {PositionControllerFindAll200ResponseAllOfData}
     * @memberof PositionControllerFindAll200ResponseAllOf
     */
    'data'?: PositionControllerFindAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface PositionControllerFindAll200ResponseAllOfData
 */
export interface PositionControllerFindAll200ResponseAllOfData {
    /**
     * 
     * @type {Array<Position>}
     * @memberof PositionControllerFindAll200ResponseAllOfData
     */
    'content'?: Array<Position>;
    /**
     * 
     * @type {number}
     * @memberof PositionControllerFindAll200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionControllerFindAll200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionControllerFindAll200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface PositionControllerFindAll200ResponseAllOfDataAllOf
 */
export interface PositionControllerFindAll200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<Position>}
     * @memberof PositionControllerFindAll200ResponseAllOfDataAllOf
     */
    'content'?: Array<Position>;
}
/**
 * 
 * @export
 * @interface PushMessageLineDto
 */
export interface PushMessageLineDto {
    /**
     * 
     * @type {string}
     * @memberof PushMessageLineDto
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof PushMessageLineDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface RecruitmentType
 */
export interface RecruitmentType {
    /**
     * 
     * @type {string}
     * @memberof RecruitmentType
     */
    'type': string;
    /**
     * 
     * @type {boolean}
     * @memberof RecruitmentType
     */
    'isDefault': boolean;
    /**
     * 
     * @type {Array<User>}
     * @memberof RecruitmentType
     */
    'users': Array<User>;
    /**
     * 
     * @type {Array<WorkHours>}
     * @memberof RecruitmentType
     */
    'workHours': Array<WorkHours>;
    /**
     * 
     * @type {Array<ApprovalConfig>}
     * @memberof RecruitmentType
     */
    'approvalConfigs': Array<ApprovalConfig>;
    /**
     * 
     * @type {Array<LeaveRegulationConfig>}
     * @memberof RecruitmentType
     */
    'leaveRegulationConfigs': Array<LeaveRegulationConfig>;
    /**
     * 
     * @type {ReminderTime}
     * @memberof RecruitmentType
     */
    'reminderTime': ReminderTime;
    /**
     * 
     * @type {string}
     * @memberof RecruitmentType
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RecruitmentType
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof RecruitmentType
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof RecruitmentType
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof RecruitmentType
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof RecruitmentType
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface RecruitmentTypeControllerGetAll200Response
 */
export interface RecruitmentTypeControllerGetAll200Response {
    /**
     * 
     * @type {boolean}
     * @memberof RecruitmentTypeControllerGetAll200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecruitmentTypeControllerGetAll200Response
     */
    'message'?: string;
    /**
     * 
     * @type {RecruitmentTypeControllerGetAll200ResponseAllOfData}
     * @memberof RecruitmentTypeControllerGetAll200Response
     */
    'data'?: RecruitmentTypeControllerGetAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface RecruitmentTypeControllerGetAll200ResponseAllOf
 */
export interface RecruitmentTypeControllerGetAll200ResponseAllOf {
    /**
     * 
     * @type {RecruitmentTypeControllerGetAll200ResponseAllOfData}
     * @memberof RecruitmentTypeControllerGetAll200ResponseAllOf
     */
    'data'?: RecruitmentTypeControllerGetAll200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface RecruitmentTypeControllerGetAll200ResponseAllOfData
 */
export interface RecruitmentTypeControllerGetAll200ResponseAllOfData {
    /**
     * 
     * @type {Array<RecruitmentType>}
     * @memberof RecruitmentTypeControllerGetAll200ResponseAllOfData
     */
    'content'?: Array<RecruitmentType>;
    /**
     * 
     * @type {number}
     * @memberof RecruitmentTypeControllerGetAll200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecruitmentTypeControllerGetAll200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecruitmentTypeControllerGetAll200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface RecruitmentTypeControllerGetAll200ResponseAllOfDataAllOf
 */
export interface RecruitmentTypeControllerGetAll200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<RecruitmentType>}
     * @memberof RecruitmentTypeControllerGetAll200ResponseAllOfDataAllOf
     */
    'content'?: Array<RecruitmentType>;
}
/**
 * 
 * @export
 * @interface RecruitmentTypeControllerUpdate200Response
 */
export interface RecruitmentTypeControllerUpdate200Response {
    /**
     * 
     * @type {boolean}
     * @memberof RecruitmentTypeControllerUpdate200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecruitmentTypeControllerUpdate200Response
     */
    'message'?: string;
    /**
     * 
     * @type {RecruitmentType}
     * @memberof RecruitmentTypeControllerUpdate200Response
     */
    'data'?: RecruitmentType;
}
/**
 * 
 * @export
 * @interface RecruitmentTypeControllerUpdate200ResponseAllOf
 */
export interface RecruitmentTypeControllerUpdate200ResponseAllOf {
    /**
     * 
     * @type {RecruitmentType}
     * @memberof RecruitmentTypeControllerUpdate200ResponseAllOf
     */
    'data'?: RecruitmentType;
}
/**
 * 
 * @export
 * @interface ReminderTime
 */
export interface ReminderTime {
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'checkInTime': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'checkOutTime': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'checkOutTime2': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'summaryTime': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'summaryTime2': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'lineGroupId': string;
    /**
     * 
     * @type {LineGroup}
     * @memberof ReminderTime
     */
    'lineGroup': LineGroup;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'recruitmentTypeId': string;
    /**
     * 
     * @type {RecruitmentType}
     * @memberof ReminderTime
     */
    'recruitmentType': RecruitmentType;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof ReminderTime
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface ReminderTimeControllerFindAll200Response
 */
export interface ReminderTimeControllerFindAll200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ReminderTimeControllerFindAll200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReminderTimeControllerFindAll200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ReminderTime>}
     * @memberof ReminderTimeControllerFindAll200Response
     */
    'data'?: Array<ReminderTime>;
}
/**
 * 
 * @export
 * @interface ReminderTimeControllerFindAll200ResponseAllOf
 */
export interface ReminderTimeControllerFindAll200ResponseAllOf {
    /**
     * 
     * @type {Array<ReminderTime>}
     * @memberof ReminderTimeControllerFindAll200ResponseAllOf
     */
    'data'?: Array<ReminderTime>;
}
/**
 * 
 * @export
 * @interface ReminderTimeControllerSave200Response
 */
export interface ReminderTimeControllerSave200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ReminderTimeControllerSave200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReminderTimeControllerSave200Response
     */
    'message'?: string;
    /**
     * 
     * @type {ReminderTime}
     * @memberof ReminderTimeControllerSave200Response
     */
    'data'?: ReminderTime;
}
/**
 * 
 * @export
 * @interface ReminderTimeControllerSave200ResponseAllOf
 */
export interface ReminderTimeControllerSave200ResponseAllOf {
    /**
     * 
     * @type {ReminderTime}
     * @memberof ReminderTimeControllerSave200ResponseAllOf
     */
    'data'?: ReminderTime;
}
/**
 * 
 * @export
 * @interface ReportControllerGetListReport200Response
 */
export interface ReportControllerGetListReport200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ReportControllerGetListReport200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportControllerGetListReport200Response
     */
    'message'?: string;
    /**
     * 
     * @type {ReportControllerGetListReport200ResponseAllOfData}
     * @memberof ReportControllerGetListReport200Response
     */
    'data'?: ReportControllerGetListReport200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface ReportControllerGetListReport200ResponseAllOf
 */
export interface ReportControllerGetListReport200ResponseAllOf {
    /**
     * 
     * @type {ReportControllerGetListReport200ResponseAllOfData}
     * @memberof ReportControllerGetListReport200ResponseAllOf
     */
    'data'?: ReportControllerGetListReport200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface ReportControllerGetListReport200ResponseAllOfData
 */
export interface ReportControllerGetListReport200ResponseAllOfData {
    /**
     * 
     * @type {Array<TimekeepingReport>}
     * @memberof ReportControllerGetListReport200ResponseAllOfData
     */
    'content'?: Array<TimekeepingReport>;
    /**
     * 
     * @type {number}
     * @memberof ReportControllerGetListReport200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportControllerGetListReport200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportControllerGetListReport200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface ReportControllerGetListReport200ResponseAllOfDataAllOf
 */
export interface ReportControllerGetListReport200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<TimekeepingReport>}
     * @memberof ReportControllerGetListReport200ResponseAllOfDataAllOf
     */
    'content'?: Array<TimekeepingReport>;
}
/**
 * 
 * @export
 * @interface SaveWorkHoursDto
 */
export interface SaveWorkHoursDto {
    /**
     * 
     * @type {Array<CreateWorkHoursDto>}
     * @memberof SaveWorkHoursDto
     */
    'data': Array<CreateWorkHoursDto>;
    /**
     * 
     * @type {UpdateGeneralWorkingScheduleDto}
     * @memberof SaveWorkHoursDto
     */
    'general'?: UpdateGeneralWorkingScheduleDto;
}
/**
 * 
 * @export
 * @interface Schedule
 */
export interface Schedule {
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'scheduleSettingId': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'destination': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'transport': ScheduleTransportEnum;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'transportTitle': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'transportContent': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'purpose': SchedulePurposeEnum;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'purposeTitle': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'purposeContent': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'receipt': string;
    /**
     * 
     * @type {number}
     * @memberof Schedule
     */
    'status': ScheduleStatusEnum;
    /**
     * 
     * @type {User}
     * @memberof Schedule
     */
    'user': User;
    /**
     * 
     * @type {ScheduleSetting}
     * @memberof Schedule
     */
    'scheduleSetting': ScheduleSetting;
    /**
     * 
     * @type {Array<Confirmation>}
     * @memberof Schedule
     */
    'confirmations': Array<Confirmation>;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    'deletedAt': string;
}

export const ScheduleTransportEnum = {
    PublicTransport: 'PUBLIC_TRANSPORT',
    CompanyCar: 'COMPANY_CAR',
    PersonalCar: 'PERSONAL_CAR',
    Other: 'OTHER'
} as const;

export type ScheduleTransportEnum = typeof ScheduleTransportEnum[keyof typeof ScheduleTransportEnum];
export const SchedulePurposeEnum = {
    Negotiation: 'NEGOTIATION',
    Meeting: 'MEETING',
    Delivery: 'DELIVERY',
    ConstructionRepair: 'CONSTRUCTION_REPAIR',
    Other: 'OTHER'
} as const;

export type SchedulePurposeEnum = typeof SchedulePurposeEnum[keyof typeof SchedulePurposeEnum];
export const ScheduleStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_MINUS_1: -1
} as const;

export type ScheduleStatusEnum = typeof ScheduleStatusEnum[keyof typeof ScheduleStatusEnum];

/**
 * 
 * @export
 * @interface ScheduleControllerGetAll200Response
 */
export interface ScheduleControllerGetAll200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleControllerGetAll200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScheduleControllerGetAll200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Schedule>}
     * @memberof ScheduleControllerGetAll200Response
     */
    'data'?: Array<Schedule>;
}
/**
 * 
 * @export
 * @interface ScheduleControllerGetAll200ResponseAllOf
 */
export interface ScheduleControllerGetAll200ResponseAllOf {
    /**
     * 
     * @type {Array<Schedule>}
     * @memberof ScheduleControllerGetAll200ResponseAllOf
     */
    'data'?: Array<Schedule>;
}
/**
 * 
 * @export
 * @interface ScheduleControllerGetListSelect200Response
 */
export interface ScheduleControllerGetListSelect200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleControllerGetListSelect200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScheduleControllerGetListSelect200Response
     */
    'message'?: string;
    /**
     * 
     * @type {ScheduleSelectDto}
     * @memberof ScheduleControllerGetListSelect200Response
     */
    'data'?: ScheduleSelectDto;
}
/**
 * 
 * @export
 * @interface ScheduleControllerGetListSelect200ResponseAllOf
 */
export interface ScheduleControllerGetListSelect200ResponseAllOf {
    /**
     * 
     * @type {ScheduleSelectDto}
     * @memberof ScheduleControllerGetListSelect200ResponseAllOf
     */
    'data'?: ScheduleSelectDto;
}
/**
 * 
 * @export
 * @interface ScheduleSelectDto
 */
export interface ScheduleSelectDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof ScheduleSelectDto
     */
    'transport': Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof ScheduleSelectDto
     */
    'purpose': Array<object>;
}
/**
 * 
 * @export
 * @interface ScheduleSetting
 */
export interface ScheduleSetting {
    /**
     * 
     * @type {string}
     * @memberof ScheduleSetting
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSetting
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSetting
     */
    'type': ScheduleSettingTypeEnum;
    /**
     * 
     * @type {Array<Schedule>}
     * @memberof ScheduleSetting
     */
    'schedules': Array<Schedule>;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSetting
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSetting
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSetting
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSetting
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSetting
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSetting
     */
    'deletedAt': string;
}

export const ScheduleSettingTypeEnum = {
    AnnualLeave: 'ANNUAL_LEAVE',
    CompensatoryLeave: 'COMPENSATORY_LEAVE',
    MakeupWork: 'MAKEUP_WORK',
    WorkOnDayOff: 'WORK_ON_DAY_OFF',
    BusinessTrip: 'BUSINESS_TRIP'
} as const;

export type ScheduleSettingTypeEnum = typeof ScheduleSettingTypeEnum[keyof typeof ScheduleSettingTypeEnum];

/**
 * 
 * @export
 * @interface ScheduleSettingControllerGetById200Response
 */
export interface ScheduleSettingControllerGetById200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleSettingControllerGetById200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingControllerGetById200Response
     */
    'message'?: string;
    /**
     * 
     * @type {ScheduleSetting}
     * @memberof ScheduleSettingControllerGetById200Response
     */
    'data'?: ScheduleSetting;
}
/**
 * 
 * @export
 * @interface ScheduleSettingControllerGetById200ResponseAllOf
 */
export interface ScheduleSettingControllerGetById200ResponseAllOf {
    /**
     * 
     * @type {ScheduleSetting}
     * @memberof ScheduleSettingControllerGetById200ResponseAllOf
     */
    'data'?: ScheduleSetting;
}
/**
 * 
 * @export
 * @interface ScheduleSettingControllerGetList200Response
 */
export interface ScheduleSettingControllerGetList200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleSettingControllerGetList200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingControllerGetList200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ScheduleSettingWithStatus>}
     * @memberof ScheduleSettingControllerGetList200Response
     */
    'data'?: Array<ScheduleSettingWithStatus>;
}
/**
 * 
 * @export
 * @interface ScheduleSettingControllerGetList200ResponseAllOf
 */
export interface ScheduleSettingControllerGetList200ResponseAllOf {
    /**
     * 
     * @type {Array<ScheduleSettingWithStatus>}
     * @memberof ScheduleSettingControllerGetList200ResponseAllOf
     */
    'data'?: Array<ScheduleSettingWithStatus>;
}
/**
 * 
 * @export
 * @interface ScheduleSettingWithStatus
 */
export interface ScheduleSettingWithStatus {
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingWithStatus
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingWithStatus
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingWithStatus
     */
    'type': ScheduleSettingWithStatusTypeEnum;
    /**
     * 
     * @type {Array<Schedule>}
     * @memberof ScheduleSettingWithStatus
     */
    'schedules': Array<Schedule>;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingWithStatus
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingWithStatus
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingWithStatus
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingWithStatus
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingWithStatus
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettingWithStatus
     */
    'deletedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleSettingWithStatus
     */
    'status': boolean;
}

export const ScheduleSettingWithStatusTypeEnum = {
    AnnualLeave: 'ANNUAL_LEAVE',
    CompensatoryLeave: 'COMPENSATORY_LEAVE',
    MakeupWork: 'MAKEUP_WORK',
    WorkOnDayOff: 'WORK_ON_DAY_OFF',
    BusinessTrip: 'BUSINESS_TRIP'
} as const;

export type ScheduleSettingWithStatusTypeEnum = typeof ScheduleSettingWithStatusTypeEnum[keyof typeof ScheduleSettingWithStatusTypeEnum];

/**
 * 
 * @export
 * @interface SetDefaultAdminGoogleAccountDTO
 */
export interface SetDefaultAdminGoogleAccountDTO {
    /**
     * 
     * @type {string}
     * @memberof SetDefaultAdminGoogleAccountDTO
     */
    'googleAccountId': string;
}
/**
 * 
 * @export
 * @interface StatisticsOvertimeDetail
 */
export interface StatisticsOvertimeDetail {
    /**
     * 
     * @type {object}
     * @memberof StatisticsOvertimeDetail
     */
    'month': object;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeDetail
     */
    'weekday': string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeDetail
     */
    'designatedHoliday': string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeDetail
     */
    'weekdayPlusDesignated': string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeDetail
     */
    'legalHoliday': string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeDetail
     */
    'total': string;
}
/**
 * 
 * @export
 * @interface StatisticsOvertimeOverview
 */
export interface StatisticsOvertimeOverview {
    /**
     * 
     * @type {object}
     * @memberof StatisticsOvertimeOverview
     */
    'key': object;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeOverview
     */
    'judgment': StatisticsOvertimeOverviewJudgmentEnum;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeOverview
     */
    'asOfToday': string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeOverview
     */
    'upperLimit': string;
}

export const StatisticsOvertimeOverviewJudgmentEnum = {
    Ok: 'OK',
    Ng: 'NG',
    Notice: 'NOTICE'
} as const;

export type StatisticsOvertimeOverviewJudgmentEnum = typeof StatisticsOvertimeOverviewJudgmentEnum[keyof typeof StatisticsOvertimeOverviewJudgmentEnum];

/**
 * 
 * @export
 * @interface StatisticsOvertimeResponse
 */
export interface StatisticsOvertimeResponse {
    /**
     * 
     * @type {Array<StatisticsOvertimeDetail>}
     * @memberof StatisticsOvertimeResponse
     */
    'detail': Array<StatisticsOvertimeDetail>;
    /**
     * 
     * @type {Array<StatisticsOvertimeOverview>}
     * @memberof StatisticsOvertimeResponse
     */
    'overview': Array<StatisticsOvertimeOverview>;
    /**
     * 
     * @type {OvertimeRegulationSettingsValueDto}
     * @memberof StatisticsOvertimeResponse
     */
    'overtimeSettings': OvertimeRegulationSettingsValueDto;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeResponse
     */
    'startYear': string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsOvertimeResponse
     */
    'endYear': string;
}
/**
 * 
 * @export
 * @interface SuccessResponseDto
 */
export interface SuccessResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof SuccessResponseDto
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponseDto
     */
    'message'?: string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponseDto
     */
    'data'?: object;
}
/**
 * 
 * @export
 * @interface Timekeeping
 */
export interface Timekeeping {
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'description': string;
    /**
     * 
     * @type {object}
     * @memberof Timekeeping
     */
    'location': object;
    /**
     * 
     * @type {boolean}
     * @memberof Timekeeping
     */
    'isCheckedOut': boolean;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'dateType': TimekeepingDateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'workType': TimekeepingWorkTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Timekeeping
     */
    'breakTime': number;
    /**
     * 
     * @type {number}
     * @memberof Timekeeping
     */
    'overtimeDay': number;
    /**
     * 
     * @type {number}
     * @memberof Timekeeping
     */
    'overtimeNight': number;
    /**
     * 
     * @type {number}
     * @memberof Timekeeping
     */
    'standardWorkingTime': number;
    /**
     * 
     * @type {boolean}
     * @memberof Timekeeping
     */
    'isGoingLate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Timekeeping
     */
    'isLeavingSoon': boolean;
    /**
     * 
     * @type {number}
     * @memberof Timekeeping
     */
    'amountGoingLate': number;
    /**
     * 
     * @type {number}
     * @memberof Timekeeping
     */
    'amountLeavingSoon': number;
    /**
     * 
     * @type {boolean}
     * @memberof Timekeeping
     */
    'allowGoingLate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Timekeeping
     */
    'allowLeavingSoon': boolean;
    /**
     * 
     * @type {object}
     * @memberof Timekeeping
     */
    'workingTime': object;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'requestDayOff': TimekeepingRequestDayOffEnum;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'googleCalendarEventId': string;
    /**
     * 
     * @type {IActualCheckTimes}
     * @memberof Timekeeping
     */
    'actualCheckTimes': IActualCheckTimes;
    /**
     * 
     * @type {Timekeeping}
     * @memberof Timekeeping
     */
    'previousTimekeeping': Timekeeping;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'userId': string;
    /**
     * 
     * @type {User}
     * @memberof Timekeeping
     */
    'user': User;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof Timekeeping
     */
    'deletedAt': string;
}

export const TimekeepingDateTypeEnum = {
    WorkingDays: 'WORKING_DAYS',
    RegulatedDaysOff: 'REGULATED_DAYS_OFF',
    LegalDaysOff: 'LEGAL_DAYS_OFF'
} as const;

export type TimekeepingDateTypeEnum = typeof TimekeepingDateTypeEnum[keyof typeof TimekeepingDateTypeEnum];
export const TimekeepingWorkTypeEnum = {
    NormalWork: 'NORMAL_WORK',
    CompensatoryWork: 'COMPENSATORY_WORK',
    Business: 'BUSINESS'
} as const;

export type TimekeepingWorkTypeEnum = typeof TimekeepingWorkTypeEnum[keyof typeof TimekeepingWorkTypeEnum];
export const TimekeepingRequestDayOffEnum = {
    AnnualLeave: 'ANNUAL_LEAVE',
    CompensatoryLeave: 'COMPENSATORY_LEAVE',
    Other: 'OTHER'
} as const;

export type TimekeepingRequestDayOffEnum = typeof TimekeepingRequestDayOffEnum[keyof typeof TimekeepingRequestDayOffEnum];

/**
 * 
 * @export
 * @interface TimekeepingControllerGetEmployeeTimekeepingHistory200Response
 */
export interface TimekeepingControllerGetEmployeeTimekeepingHistory200Response {
    /**
     * 
     * @type {boolean}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistory200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistory200Response
     */
    'message'?: string;
    /**
     * 
     * @type {TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistory200Response
     */
    'data'?: TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOf
 */
export interface TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOf {
    /**
     * 
     * @type {TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOf
     */
    'data'?: TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData;
}
/**
 * 
 * @export
 * @interface TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData
 */
export interface TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData {
    /**
     * 
     * @type {Array<GetEmployeeTimekeepingHistoryDto>}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData
     */
    'content'?: Array<GetEmployeeTimekeepingHistoryDto>;
    /**
     * 
     * @type {number}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfData
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfDataAllOf
 */
export interface TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfDataAllOf {
    /**
     * 
     * @type {Array<GetEmployeeTimekeepingHistoryDto>}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistory200ResponseAllOfDataAllOf
     */
    'content'?: Array<GetEmployeeTimekeepingHistoryDto>;
}
/**
 * 
 * @export
 * @interface TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200Response
 */
export interface TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200Response {
    /**
     * 
     * @type {boolean}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200Response
     */
    'message'?: string;
    /**
     * 
     * @type {GetTimekeepingHistoryStatisticDto}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200Response
     */
    'data'?: GetTimekeepingHistoryStatisticDto;
}
/**
 * 
 * @export
 * @interface TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200ResponseAllOf
 */
export interface TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200ResponseAllOf {
    /**
     * 
     * @type {GetTimekeepingHistoryStatisticDto}
     * @memberof TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200ResponseAllOf
     */
    'data'?: GetTimekeepingHistoryStatisticDto;
}
/**
 * 
 * @export
 * @interface TimekeepingControllerUpdateEmployeeTimekeeping200Response
 */
export interface TimekeepingControllerUpdateEmployeeTimekeeping200Response {
    /**
     * 
     * @type {boolean}
     * @memberof TimekeepingControllerUpdateEmployeeTimekeeping200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingControllerUpdateEmployeeTimekeeping200Response
     */
    'message'?: string;
    /**
     * 
     * @type {GetEmployeeTimekeepingHistoryDto}
     * @memberof TimekeepingControllerUpdateEmployeeTimekeeping200Response
     */
    'data'?: GetEmployeeTimekeepingHistoryDto;
}
/**
 * 
 * @export
 * @interface TimekeepingControllerUpdateEmployeeTimekeeping200ResponseAllOf
 */
export interface TimekeepingControllerUpdateEmployeeTimekeeping200ResponseAllOf {
    /**
     * 
     * @type {GetEmployeeTimekeepingHistoryDto}
     * @memberof TimekeepingControllerUpdateEmployeeTimekeeping200ResponseAllOf
     */
    'data'?: GetEmployeeTimekeepingHistoryDto;
}
/**
 * 
 * @export
 * @interface TimekeepingHistory
 */
export interface TimekeepingHistory {
    /**
     * 
     * @type {Timekeeping}
     * @memberof TimekeepingHistory
     */
    'data': Timekeeping;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingHistory
     */
    'timekeepingId': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingHistory
     */
    'timekeepingReportId': string;
    /**
     * 
     * @type {TimekeepingReport}
     * @memberof TimekeepingHistory
     */
    'timekeepingReport': TimekeepingReport;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingHistory
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingHistory
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingHistory
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingHistory
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingHistory
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingHistory
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface TimekeepingReport
 */
export interface TimekeepingReport {
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'type': TimekeepingReportTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'option': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'timeStartOutside': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'timeBack': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'timeBackReality': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'overtimeStart': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'overtimeEnd': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'requestTimekeepingStart': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'requestTimekeepingEnd': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'timeEstimated': string;
    /**
     * 
     * @type {object}
     * @memberof TimekeepingReport
     */
    'location'?: object;
    /**
     * 
     * @type {IActualCheckTimes}
     * @memberof TimekeepingReport
     */
    'actualCheckTimes': IActualCheckTimes;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'userId': string;
    /**
     * 
     * @type {User}
     * @memberof TimekeepingReport
     */
    'user': User;
    /**
     * 
     * @type {Array<Confirmation>}
     * @memberof TimekeepingReport
     */
    'confirmations': Array<Confirmation>;
    /**
     * 
     * @type {object}
     * @memberof TimekeepingReport
     */
    'data': object;
    /**
     * 
     * @type {number}
     * @memberof TimekeepingReport
     */
    'status': TimekeepingReportStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'lastConfirmedAt': string;
    /**
     * 
     * @type {Array<TimekeepingReportHistory>}
     * @memberof TimekeepingReport
     */
    'timekeepingReportHistories': Array<TimekeepingReportHistory>;
    /**
     * 
     * @type {Array<TimekeepingHistory>}
     * @memberof TimekeepingReport
     */
    'timekeepingHistories': Array<TimekeepingHistory>;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReport
     */
    'deletedAt': string;
}

export const TimekeepingReportTypeEnum = {
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    RequestTimekeepingEdit: 'REQUEST_TIMEKEEPING_EDIT',
    RequestCheckin: 'REQUEST_CHECKIN',
    RequestCheckout: 'REQUEST_CHECKOUT'
} as const;

export type TimekeepingReportTypeEnum = typeof TimekeepingReportTypeEnum[keyof typeof TimekeepingReportTypeEnum];
export const TimekeepingReportStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_MINUS_1: -1
} as const;

export type TimekeepingReportStatusEnum = typeof TimekeepingReportStatusEnum[keyof typeof TimekeepingReportStatusEnum];

/**
 * 
 * @export
 * @interface TimekeepingReportHistory
 */
export interface TimekeepingReportHistory {
    /**
     * 
     * @type {TimekeepingReport}
     * @memberof TimekeepingReportHistory
     */
    'data': TimekeepingReport;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReportHistory
     */
    'timekeepingReportId': string;
    /**
     * 
     * @type {TimekeepingReport}
     * @memberof TimekeepingReportHistory
     */
    'timekeepingReport': TimekeepingReport;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReportHistory
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReportHistory
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReportHistory
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReportHistory
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReportHistory
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof TimekeepingReportHistory
     */
    'deletedAt': string;
}
/**
 * 
 * @export
 * @interface TimekeepingSettingsValueDto
 */
export interface TimekeepingSettingsValueDto {
    /**
     * 
     * @type {number}
     * @memberof TimekeepingSettingsValueDto
     */
    'timeKeepingEditLimit': number;
}
/**
 * 
 * @export
 * @interface TransferEmployeesCalendarDto
 */
export interface TransferEmployeesCalendarDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferEmployeesCalendarDto
     */
    'googleCalendarIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TransferEmployeesCalendarDto
     */
    'currentGoogleAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof TransferEmployeesCalendarDto
     */
    'targetGoogleAccountId': string;
}
/**
 * 
 * @export
 * @interface UnlinkAccountAdminDTO
 */
export interface UnlinkAccountAdminDTO {
    /**
     * 
     * @type {string}
     * @memberof UnlinkAccountAdminDTO
     */
    'googleAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnlinkAccountAdminDTO
     */
    'emailAddress'?: string;
}
/**
 * 
 * @export
 * @interface UpdateBookingDto
 */
export interface UpdateBookingDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBookingDto
     */
    'type'?: UpdateBookingDtoTypeEnum;
}

export const UpdateBookingDtoTypeEnum = {
    MeetingRoom: 'MEETING_ROOM',
    Car: 'CAR'
} as const;

export type UpdateBookingDtoTypeEnum = typeof UpdateBookingDtoTypeEnum[keyof typeof UpdateBookingDtoTypeEnum];

/**
 * 
 * @export
 * @interface UpdateConfirmationDto
 */
export interface UpdateConfirmationDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateConfirmationDto
     */
    'status': UpdateConfirmationDtoStatusEnum;
}

export const UpdateConfirmationDtoStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_MINUS_1: -1
} as const;

export type UpdateConfirmationDtoStatusEnum = typeof UpdateConfirmationDtoStatusEnum[keyof typeof UpdateConfirmationDtoStatusEnum];

/**
 * 
 * @export
 * @interface UpdateDepartmentDto
 */
export interface UpdateDepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDepartmentDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEmployeeTimekeeping
 */
export interface UpdateEmployeeTimekeeping {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeTimekeeping
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeTimekeeping
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeTimekeeping
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeTimekeeping
     */
    'workType'?: UpdateEmployeeTimekeepingWorkTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeTimekeeping
     */
    'optionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeTimekeeping
     */
    'requestDayOff'?: UpdateEmployeeTimekeepingRequestDayOffEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeTimekeeping
     */
    'summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeTimekeeping
     */
    'description'?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateEmployeeTimekeeping
     */
    'location'?: object | null;
    /**
     * 
     * @type {IActualCheckTimes}
     * @memberof UpdateEmployeeTimekeeping
     */
    'actualCheckTimes'?: IActualCheckTimes | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeTimekeeping
     */
    'timekeepingReportType'?: UpdateEmployeeTimekeepingTimekeepingReportTypeEnum;
}

export const UpdateEmployeeTimekeepingWorkTypeEnum = {
    NormalWork: 'NORMAL_WORK',
    CompensatoryWork: 'COMPENSATORY_WORK',
    Business: 'BUSINESS'
} as const;

export type UpdateEmployeeTimekeepingWorkTypeEnum = typeof UpdateEmployeeTimekeepingWorkTypeEnum[keyof typeof UpdateEmployeeTimekeepingWorkTypeEnum];
export const UpdateEmployeeTimekeepingRequestDayOffEnum = {
    AnnualLeave: 'ANNUAL_LEAVE',
    CompensatoryLeave: 'COMPENSATORY_LEAVE',
    Other: 'OTHER'
} as const;

export type UpdateEmployeeTimekeepingRequestDayOffEnum = typeof UpdateEmployeeTimekeepingRequestDayOffEnum[keyof typeof UpdateEmployeeTimekeepingRequestDayOffEnum];
export const UpdateEmployeeTimekeepingTimekeepingReportTypeEnum = {
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    RequestTimekeepingEdit: 'REQUEST_TIMEKEEPING_EDIT',
    RequestCheckin: 'REQUEST_CHECKIN',
    RequestCheckout: 'REQUEST_CHECKOUT'
} as const;

export type UpdateEmployeeTimekeepingTimekeepingReportTypeEnum = typeof UpdateEmployeeTimekeepingTimekeepingReportTypeEnum[keyof typeof UpdateEmployeeTimekeepingTimekeepingReportTypeEnum];

/**
 * 
 * @export
 * @interface UpdateGeneralWorkingScheduleDto
 */
export interface UpdateGeneralWorkingScheduleDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateGeneralWorkingScheduleDto
     */
    'dayStartOfMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateGeneralWorkingScheduleDto
     */
    'dayEndOfMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateGeneralWorkingScheduleDto
     */
    'overtimePeriod'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateGeneralWorkingScheduleDto
     */
    'nightOvertimeStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGeneralWorkingScheduleDto
     */
    'nightOvertimeEnd'?: string;
}
/**
 * 
 * @export
 * @interface UpdateLeaveRegulationConfigDto
 */
export interface UpdateLeaveRegulationConfigDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLeaveRegulationConfigDto
     */
    'baseOn'?: UpdateLeaveRegulationConfigDtoBaseOnEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeaveRegulationConfigDto
     */
    'dayPerWeek'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLeaveRegulationConfigDto
     */
    'isSetting2ndBase'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeaveRegulationConfigDto
     */
    'dayOf2ndBase'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeaveRegulationConfigDto
     */
    'monthOf2ndBase'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLeaveRegulationConfigDto
     */
    'isDividedHalfYear'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLeaveRegulationConfigDto
     */
    'isPriority2ndBase'?: boolean;
    /**
     * 
     * @type {Array<DataTimeGrantDto>}
     * @memberof UpdateLeaveRegulationConfigDto
     */
    'dataTimeGrant'?: Array<DataTimeGrantDto>;
}

export const UpdateLeaveRegulationConfigDtoBaseOnEnum = {
    Week: 'week',
    Year: 'year'
} as const;

export type UpdateLeaveRegulationConfigDtoBaseOnEnum = typeof UpdateLeaveRegulationConfigDtoBaseOnEnum[keyof typeof UpdateLeaveRegulationConfigDtoBaseOnEnum];

/**
 * 
 * @export
 * @interface UpdateLineConfigDto
 */
export interface UpdateLineConfigDto {
    /**
     * 
     * @type {Array<LineConfigDto>}
     * @memberof UpdateLineConfigDto
     */
    'data': Array<LineConfigDto>;
}
/**
 * 
 * @export
 * @interface UpdateLocationDto
 */
export interface UpdateLocationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMultipleApprovalConfigDto
 */
export interface UpdateMultipleApprovalConfigDto {
    /**
     * 
     * @type {Array<CreateApprovalConfigDto>}
     * @memberof UpdateMultipleApprovalConfigDto
     */
    'data'?: Array<CreateApprovalConfigDto>;
}
/**
 * 
 * @export
 * @interface UpdateOptionDto
 */
export interface UpdateOptionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOptionDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOptionDto
     */
    'category'?: UpdateOptionDtoCategoryEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOptionDto
     */
    'status'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOptionDto
     */
    'isAnnualLeaveOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOptionDto
     */
    'isCompensatoryLeaveOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOptionDto
     */
    'isRegisteredBusinessOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOptionDto
     */
    'isSuddenBusinessOption'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOptionDto
     */
    'isRequireAdditionalDetail'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateOptionDto
     */
    'durationOfLeave'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOptionDto
     */
    'isSendLineMessage'?: boolean;
}

export const UpdateOptionDtoCategoryEnum = {
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    CheckIn: 'CHECK_IN',
    CheckOut: 'CHECK_OUT',
    Schedule: 'SCHEDULE'
} as const;

export type UpdateOptionDtoCategoryEnum = typeof UpdateOptionDtoCategoryEnum[keyof typeof UpdateOptionDtoCategoryEnum];

/**
 * 
 * @export
 * @interface UpdatePersonalSettingsCalendarDto
 */
export interface UpdatePersonalSettingsCalendarDto {
    /**
     * 
     * @type {number}
     * @memberof UpdatePersonalSettingsCalendarDto
     */
    'dayStart'?: number;
}
/**
 * 
 * @export
 * @interface UpdatePositionDto
 */
export interface UpdatePositionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePositionDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateReportDto
 */
export interface UpdateReportDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'option'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'timeStartOutside'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'timeBack'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'timeBackReality'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'timeEstimated'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'type'?: UpdateReportDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'optionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'overtimeStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'overtimeEnd'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateReportDto
     */
    'durationOfLeave'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'requestTimekeepingStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'requestTimekeepingEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReportDto
     */
    'summary'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateReportDto
     */
    'isStandardCheckIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateReportDto
     */
    'isStandardCheckOut'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateReportDto
     */
    'isRequestedFromWeb'?: boolean;
}

export const UpdateReportDtoTypeEnum = {
    GoingLate: 'GOING_LATE',
    LeavingSoon: 'LEAVING_SOON',
    Overtime: 'OVERTIME',
    OutsidePrivate: 'OUTSIDE_PRIVATE',
    OutsideBusiness: 'OUTSIDE_BUSINESS',
    RequestDayOff: 'REQUEST_DAY_OFF',
    RequestBusiness: 'REQUEST_BUSINESS',
    RequestTimekeepingEdit: 'REQUEST_TIMEKEEPING_EDIT',
    RequestCheckin: 'REQUEST_CHECKIN',
    RequestCheckout: 'REQUEST_CHECKOUT'
} as const;

export type UpdateReportDtoTypeEnum = typeof UpdateReportDtoTypeEnum[keyof typeof UpdateReportDtoTypeEnum];

/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'employeeCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'furiganaName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'gender'?: UpdateUserDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'departmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'positionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'recruitmentTypeId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserDto
     */
    'annualLeaveDaysRemaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserDto
     */
    'compensatoryLeaveDaysRemaining'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'googleCalendarId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'role'?: UpdateUserDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'address'?: string;
    /**
     * 
     * @type {Array<CreateApproverDto>}
     * @memberof UpdateUserDto
     */
    'employeeApprovals'?: Array<CreateApproverDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'officialWorkingDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'displayPassword'?: string;
}

export const UpdateUserDtoGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Other: 'OTHER'
} as const;

export type UpdateUserDtoGenderEnum = typeof UpdateUserDtoGenderEnum[keyof typeof UpdateUserDtoGenderEnum];
export const UpdateUserDtoRoleEnum = {
    SuperAdmin: 'SUPER_ADMIN',
    Employee: 'EMPLOYEE',
    Manager: 'MANAGER'
} as const;

export type UpdateUserDtoRoleEnum = typeof UpdateUserDtoRoleEnum[keyof typeof UpdateUserDtoRoleEnum];

/**
 * 
 * @export
 * @interface UrlDto
 */
export interface UrlDto {
    /**
     * 
     * @type {string}
     * @memberof UrlDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'employeeCode': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'furiganaName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'gender': UserGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'dateOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phoneNumber': string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'annualLeaveDaysRemaining': number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'compensatoryLeaveDaysRemaining': number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'googleCalendarId': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role': UserRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'officialWorkingDay': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'displayPassword': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'recruitmentTypeId': string;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'personalSettings': object;
    /**
     * 
     * @type {Array<GoogleAccount>}
     * @memberof User
     */
    'googleAccounts': Array<GoogleAccount>;
    /**
     * 
     * @type {Array<LineAccount>}
     * @memberof User
     */
    'lineAccounts': Array<LineAccount>;
    /**
     * 
     * @type {Array<Approver>}
     * @memberof User
     */
    'managerApprovals': Array<Approver>;
    /**
     * 
     * @type {Array<Approver>}
     * @memberof User
     */
    'employeeApprovals': Array<Approver>;
    /**
     * 
     * @type {Array<BookingTime>}
     * @memberof User
     */
    'bookingTimes': Array<BookingTime>;
    /**
     * 
     * @type {Array<Timekeeping>}
     * @memberof User
     */
    'timekeepings': Array<Timekeeping>;
    /**
     * 
     * @type {Array<Schedule>}
     * @memberof User
     */
    'schedules': Array<Schedule>;
    /**
     * 
     * @type {Array<TimekeepingReport>}
     * @memberof User
     */
    'timekeepingReports': Array<TimekeepingReport>;
    /**
     * 
     * @type {Array<Confirmation>}
     * @memberof User
     */
    'confirmations': Array<Confirmation>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'locationId': string;
    /**
     * 
     * @type {Location}
     * @memberof User
     */
    'location': Location;
    /**
     * 
     * @type {RecruitmentType}
     * @memberof User
     */
    'recruitmentType': RecruitmentType;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'departmentId': string;
    /**
     * 
     * @type {Department}
     * @memberof User
     */
    'department': Department;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'positionId': string;
    /**
     * 
     * @type {Position}
     * @memberof User
     */
    'position': Position;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastLeaveGrantDay': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'nextLeaveGrantedDay': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'deletedAt': string;
}

export const UserGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Other: 'OTHER'
} as const;

export type UserGenderEnum = typeof UserGenderEnum[keyof typeof UserGenderEnum];
export const UserRoleEnum = {
    SuperAdmin: 'SUPER_ADMIN',
    Employee: 'EMPLOYEE',
    Manager: 'MANAGER'
} as const;

export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];

/**
 * 
 * @export
 * @interface UserControllerExportUserToCsv200Response
 */
export interface UserControllerExportUserToCsv200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UserControllerExportUserToCsv200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserControllerExportUserToCsv200Response
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserControllerExportUserToCsv200Response
     */
    'data'?: string;
}
/**
 * 
 * @export
 * @interface UserControllerExportUserToCsv200ResponseAllOf
 */
export interface UserControllerExportUserToCsv200ResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof UserControllerExportUserToCsv200ResponseAllOf
     */
    'data'?: string;
}
/**
 * 
 * @export
 * @interface UserControllerGetEmployeeRelatedInformation200Response
 */
export interface UserControllerGetEmployeeRelatedInformation200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UserControllerGetEmployeeRelatedInformation200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserControllerGetEmployeeRelatedInformation200Response
     */
    'message'?: string;
    /**
     * 
     * @type {EmployeeRelatedInformationDto}
     * @memberof UserControllerGetEmployeeRelatedInformation200Response
     */
    'data'?: EmployeeRelatedInformationDto;
}
/**
 * 
 * @export
 * @interface UserControllerGetEmployeeRelatedInformation200ResponseAllOf
 */
export interface UserControllerGetEmployeeRelatedInformation200ResponseAllOf {
    /**
     * 
     * @type {EmployeeRelatedInformationDto}
     * @memberof UserControllerGetEmployeeRelatedInformation200ResponseAllOf
     */
    'data'?: EmployeeRelatedInformationDto;
}
/**
 * 
 * @export
 * @interface UserControllerGetListManager200Response
 */
export interface UserControllerGetListManager200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UserControllerGetListManager200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserControllerGetListManager200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<User>}
     * @memberof UserControllerGetListManager200Response
     */
    'data'?: Array<User>;
}
/**
 * 
 * @export
 * @interface UserControllerGetListManager200ResponseAllOf
 */
export interface UserControllerGetListManager200ResponseAllOf {
    /**
     * 
     * @type {Array<User>}
     * @memberof UserControllerGetListManager200ResponseAllOf
     */
    'data'?: Array<User>;
}
/**
 * 
 * @export
 * @interface UserControllerGetUserById200Response
 */
export interface UserControllerGetUserById200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UserControllerGetUserById200Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserControllerGetUserById200Response
     */
    'message'?: string;
    /**
     * 
     * @type {User}
     * @memberof UserControllerGetUserById200Response
     */
    'data'?: User;
}
/**
 * 
 * @export
 * @interface UserControllerGetUserById200ResponseAllOf
 */
export interface UserControllerGetUserById200ResponseAllOf {
    /**
     * 
     * @type {User}
     * @memberof UserControllerGetUserById200ResponseAllOf
     */
    'data'?: User;
}
/**
 * 
 * @export
 * @interface UserUpdateLocationDto
 */
export interface UserUpdateLocationDto {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateLocationDto
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @interface WorkHours
 */
export interface WorkHours {
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'type': WorkHoursTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WorkHours
     */
    'index': number;
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'recruitmentTypeId': string;
    /**
     * 
     * @type {RecruitmentType}
     * @memberof WorkHours
     */
    'recruitmentType': RecruitmentType;
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkHours
     */
    'deletedAt': string;
}

export const WorkHoursTypeEnum = {
    WorkHours: 'WORK_HOURS',
    BreakHours: 'BREAK_HOURS'
} as const;

export type WorkHoursTypeEnum = typeof WorkHoursTypeEnum[keyof typeof WorkHoursTypeEnum];

/**
 * 
 * @export
 * @interface WorkHoursResponseDto
 */
export interface WorkHoursResponseDto {
    /**
     * 
     * @type {string}
     * @memberof WorkHoursResponseDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof WorkHoursResponseDto
     */
    'type': WorkHoursResponseDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WorkHoursResponseDto
     */
    'index': number;
}

export const WorkHoursResponseDtoTypeEnum = {
    WorkHours: 'WORK_HOURS',
    BreakHours: 'BREAK_HOURS'
} as const;

export type WorkHoursResponseDtoTypeEnum = typeof WorkHoursResponseDtoTypeEnum[keyof typeof WorkHoursResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface WorkSchedule
 */
export interface WorkSchedule {
    /**
     * 
     * @type {string}
     * @memberof WorkSchedule
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof WorkSchedule
     */
    'type': WorkScheduleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkSchedule
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof WorkSchedule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkSchedule
     */
    'createdOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof WorkSchedule
     */
    'createdByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkSchedule
     */
    'lastModifiedOnDate': string;
    /**
     * 
     * @type {string}
     * @memberof WorkSchedule
     */
    'lastModifiedByUserId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkSchedule
     */
    'deletedAt': string;
}

export const WorkScheduleTypeEnum = {
    WorkingDays: 'WORKING_DAYS',
    RegulatedDaysOff: 'REGULATED_DAYS_OFF',
    LegalDaysOff: 'LEGAL_DAYS_OFF'
} as const;

export type WorkScheduleTypeEnum = typeof WorkScheduleTypeEnum[keyof typeof WorkScheduleTypeEnum];


/**
 * ApprovalConfigApi - axios parameter creator
 * @export
 */
export const ApprovalConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get approve config
         * @param {string} recruitmentTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvalConfigControllerGetAllByRecruitmentTypeId: async (recruitmentTypeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recruitmentTypeId' is not null or undefined
            assertParamExists('approvalConfigControllerGetAllByRecruitmentTypeId', 'recruitmentTypeId', recruitmentTypeId)
            const localVarPath = `/approval-config/{recruitmentTypeId}`
                .replace(`{${"recruitmentTypeId"}}`, encodeURIComponent(String(recruitmentTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update approve config
         * @param {string} recruitmentTypeId 
         * @param {UpdateMultipleApprovalConfigDto} updateMultipleApprovalConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvalConfigControllerUpdateApproveConfig: async (recruitmentTypeId: string, updateMultipleApprovalConfigDto: UpdateMultipleApprovalConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recruitmentTypeId' is not null or undefined
            assertParamExists('approvalConfigControllerUpdateApproveConfig', 'recruitmentTypeId', recruitmentTypeId)
            // verify required parameter 'updateMultipleApprovalConfigDto' is not null or undefined
            assertParamExists('approvalConfigControllerUpdateApproveConfig', 'updateMultipleApprovalConfigDto', updateMultipleApprovalConfigDto)
            const localVarPath = `/approval-config/{recruitmentTypeId}`
                .replace(`{${"recruitmentTypeId"}}`, encodeURIComponent(String(recruitmentTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMultipleApprovalConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApprovalConfigApi - functional programming interface
 * @export
 */
export const ApprovalConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApprovalConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get approve config
         * @param {string} recruitmentTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approvalConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApprovalConfigControllerGetAllByRecruitmentTypeId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approvalConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update approve config
         * @param {string} recruitmentTypeId 
         * @param {UpdateMultipleApprovalConfigDto} updateMultipleApprovalConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approvalConfigControllerUpdateApproveConfig(recruitmentTypeId: string, updateMultipleApprovalConfigDto: UpdateMultipleApprovalConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApprovalConfig>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approvalConfigControllerUpdateApproveConfig(recruitmentTypeId, updateMultipleApprovalConfigDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApprovalConfigApi - factory interface
 * @export
 */
export const ApprovalConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApprovalConfigApiFp(configuration)
    return {
        /**
         * 
         * @summary Get approve config
         * @param {string} recruitmentTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvalConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId: string, options?: any): AxiosPromise<ApprovalConfigControllerGetAllByRecruitmentTypeId200Response> {
            return localVarFp.approvalConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update approve config
         * @param {string} recruitmentTypeId 
         * @param {UpdateMultipleApprovalConfigDto} updateMultipleApprovalConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvalConfigControllerUpdateApproveConfig(recruitmentTypeId: string, updateMultipleApprovalConfigDto: UpdateMultipleApprovalConfigDto, options?: any): AxiosPromise<Array<ApprovalConfig>> {
            return localVarFp.approvalConfigControllerUpdateApproveConfig(recruitmentTypeId, updateMultipleApprovalConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApprovalConfigApi - object-oriented interface
 * @export
 * @class ApprovalConfigApi
 * @extends {BaseAPI}
 */
export class ApprovalConfigApi extends BaseAPI {
    /**
     * 
     * @summary Get approve config
     * @param {string} recruitmentTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApprovalConfigApi
     */
    public approvalConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId: string, options?: AxiosRequestConfig) {
        return ApprovalConfigApiFp(this.configuration).approvalConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update approve config
     * @param {string} recruitmentTypeId 
     * @param {UpdateMultipleApprovalConfigDto} updateMultipleApprovalConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApprovalConfigApi
     */
    public approvalConfigControllerUpdateApproveConfig(recruitmentTypeId: string, updateMultipleApprovalConfigDto: UpdateMultipleApprovalConfigDto, options?: AxiosRequestConfig) {
        return ApprovalConfigApiFp(this.configuration).approvalConfigControllerUpdateApproveConfig(recruitmentTypeId, updateMultipleApprovalConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin: async (loginDto: LoginDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('authControllerLogin', 'loginDto', loginDto)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLoginAdmin: async (loginDto: LoginDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('authControllerLoginAdmin', 'loginDto', loginDto)
            const localVarPath = `/auth/admin/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerProfile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogin(loginDto: LoginDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthControllerLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogin(loginDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLoginAdmin(loginDto: LoginDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthControllerLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLoginAdmin(loginDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerProfile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserControllerGetUserById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerProfile(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin(loginDto: LoginDto, options?: any): AxiosPromise<AuthControllerLogin200Response> {
            return localVarFp.authControllerLogin(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLoginAdmin(loginDto: LoginDto, options?: any): AxiosPromise<AuthControllerLogin200Response> {
            return localVarFp.authControllerLoginAdmin(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerProfile(options?: any): AxiosPromise<UserControllerGetUserById200Response> {
            return localVarFp.authControllerProfile(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLogin(loginDto: LoginDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogin(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLoginAdmin(loginDto: LoginDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLoginAdmin(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerProfile(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerProfile(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BookingTimesApi - axios parameter creator
 * @export
 */
export const BookingTimesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBookingTimeDto} createBookingTimeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerCreateBooking: async (createBookingTimeDto: CreateBookingTimeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBookingTimeDto' is not null or undefined
            assertParamExists('bookingTimeControllerCreateBooking', 'createBookingTimeDto', createBookingTimeDto)
            const localVarPath = `/booking-times/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingTimeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerDeleteBookingTime: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bookingTimeControllerDeleteBookingTime', 'id', id)
            const localVarPath = `/booking-times/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yearMonth] 
         * @param {string} [yearMonthDay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerGetListBookingCar: async (yearMonth?: string, yearMonthDay?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/booking-times/get-list-booking-car`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (yearMonthDay !== undefined) {
                localVarQueryParameter['yearMonthDay'] = yearMonthDay;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerGetListBookingCarByUserId: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/booking-times/get-list-booking-car-by-user-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yearMonth] 
         * @param {string} [yearMonthDay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerGetListBookingMeetingRoom: async (yearMonth?: string, yearMonthDay?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/booking-times/get-list-booking-meeting-room`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (yearMonthDay !== undefined) {
                localVarQueryParameter['yearMonthDay'] = yearMonthDay;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerGetListBookingMeetingRoomByUserId: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/booking-times/get-list-booking-meeting-room-by-user-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateBookingTimeDto} createBookingTimeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerUpdateBooking: async (id: string, createBookingTimeDto: CreateBookingTimeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bookingTimeControllerUpdateBooking', 'id', id)
            // verify required parameter 'createBookingTimeDto' is not null or undefined
            assertParamExists('bookingTimeControllerUpdateBooking', 'createBookingTimeDto', createBookingTimeDto)
            const localVarPath = `/booking-times/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingTimeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingTimesApi - functional programming interface
 * @export
 */
export const BookingTimesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingTimesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBookingTimeDto} createBookingTimeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingTimeControllerCreateBooking(createBookingTimeDto: CreateBookingTimeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingTime>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingTimeControllerCreateBooking(createBookingTimeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingTimeControllerDeleteBookingTime(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingTimeControllerDeleteBookingTime(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [yearMonth] 
         * @param {string} [yearMonthDay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingTimeControllerGetListBookingCar(yearMonth?: string, yearMonthDay?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingTimeControllerGetListBookingCar(yearMonth, yearMonthDay, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingTimeControllerGetListBookingCarByUserId(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingTime>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingTimeControllerGetListBookingCarByUserId(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [yearMonth] 
         * @param {string} [yearMonthDay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingTimeControllerGetListBookingMeetingRoom(yearMonth?: string, yearMonthDay?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingTimeControllerGetListBookingMeetingRoom(yearMonth, yearMonthDay, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingTimeControllerGetListBookingMeetingRoomByUserId(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingTime>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingTimeControllerGetListBookingMeetingRoomByUserId(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateBookingTimeDto} createBookingTimeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingTimeControllerUpdateBooking(id: string, createBookingTimeDto: CreateBookingTimeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingTime>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingTimeControllerUpdateBooking(id, createBookingTimeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BookingTimesApi - factory interface
 * @export
 */
export const BookingTimesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingTimesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateBookingTimeDto} createBookingTimeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerCreateBooking(createBookingTimeDto: CreateBookingTimeDto, options?: any): AxiosPromise<BookingTime> {
            return localVarFp.bookingTimeControllerCreateBooking(createBookingTimeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerDeleteBookingTime(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.bookingTimeControllerDeleteBookingTime(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [yearMonth] 
         * @param {string} [yearMonthDay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerGetListBookingCar(yearMonth?: string, yearMonthDay?: string, options?: any): AxiosPromise<object> {
            return localVarFp.bookingTimeControllerGetListBookingCar(yearMonth, yearMonthDay, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerGetListBookingCarByUserId(options?: any): AxiosPromise<Array<BookingTime>> {
            return localVarFp.bookingTimeControllerGetListBookingCarByUserId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [yearMonth] 
         * @param {string} [yearMonthDay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerGetListBookingMeetingRoom(yearMonth?: string, yearMonthDay?: string, options?: any): AxiosPromise<object> {
            return localVarFp.bookingTimeControllerGetListBookingMeetingRoom(yearMonth, yearMonthDay, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerGetListBookingMeetingRoomByUserId(options?: any): AxiosPromise<Array<BookingTime>> {
            return localVarFp.bookingTimeControllerGetListBookingMeetingRoomByUserId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateBookingTimeDto} createBookingTimeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingTimeControllerUpdateBooking(id: string, createBookingTimeDto: CreateBookingTimeDto, options?: any): AxiosPromise<BookingTime> {
            return localVarFp.bookingTimeControllerUpdateBooking(id, createBookingTimeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingTimesApi - object-oriented interface
 * @export
 * @class BookingTimesApi
 * @extends {BaseAPI}
 */
export class BookingTimesApi extends BaseAPI {
    /**
     * 
     * @param {CreateBookingTimeDto} createBookingTimeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTimesApi
     */
    public bookingTimeControllerCreateBooking(createBookingTimeDto: CreateBookingTimeDto, options?: AxiosRequestConfig) {
        return BookingTimesApiFp(this.configuration).bookingTimeControllerCreateBooking(createBookingTimeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTimesApi
     */
    public bookingTimeControllerDeleteBookingTime(id: string, options?: AxiosRequestConfig) {
        return BookingTimesApiFp(this.configuration).bookingTimeControllerDeleteBookingTime(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [yearMonth] 
     * @param {string} [yearMonthDay] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTimesApi
     */
    public bookingTimeControllerGetListBookingCar(yearMonth?: string, yearMonthDay?: string, options?: AxiosRequestConfig) {
        return BookingTimesApiFp(this.configuration).bookingTimeControllerGetListBookingCar(yearMonth, yearMonthDay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTimesApi
     */
    public bookingTimeControllerGetListBookingCarByUserId(options?: AxiosRequestConfig) {
        return BookingTimesApiFp(this.configuration).bookingTimeControllerGetListBookingCarByUserId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [yearMonth] 
     * @param {string} [yearMonthDay] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTimesApi
     */
    public bookingTimeControllerGetListBookingMeetingRoom(yearMonth?: string, yearMonthDay?: string, options?: AxiosRequestConfig) {
        return BookingTimesApiFp(this.configuration).bookingTimeControllerGetListBookingMeetingRoom(yearMonth, yearMonthDay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTimesApi
     */
    public bookingTimeControllerGetListBookingMeetingRoomByUserId(options?: AxiosRequestConfig) {
        return BookingTimesApiFp(this.configuration).bookingTimeControllerGetListBookingMeetingRoomByUserId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateBookingTimeDto} createBookingTimeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTimesApi
     */
    public bookingTimeControllerUpdateBooking(id: string, createBookingTimeDto: CreateBookingTimeDto, options?: AxiosRequestConfig) {
        return BookingTimesApiFp(this.configuration).bookingTimeControllerUpdateBooking(id, createBookingTimeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BookingsApi - axios parameter creator
 * @export
 */
export const BookingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBookingDto} createBookingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerCreateUser: async (createBookingDto: CreateBookingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBookingDto' is not null or undefined
            assertParamExists('bookingControllerCreateUser', 'createBookingDto', createBookingDto)
            const localVarPath = `/bookings/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerDeleteBooking: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bookingControllerDeleteBooking', 'id', id)
            const localVarPath = `/bookings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerGetBookingById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bookingControllerGetBookingById', 'id', id)
            const localVarPath = `/bookings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerGetListCars: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('bookingControllerGetListCars', 'page', page)
            const localVarPath = `/bookings/list-car`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerGetListMeetingRooms: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('bookingControllerGetListMeetingRooms', 'page', page)
            const localVarPath = `/bookings/list-meeting-room`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBookingDto} updateBookingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerUpdateBooking: async (id: string, updateBookingDto: UpdateBookingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bookingControllerUpdateBooking', 'id', id)
            // verify required parameter 'updateBookingDto' is not null or undefined
            assertParamExists('bookingControllerUpdateBooking', 'updateBookingDto', updateBookingDto)
            const localVarPath = `/bookings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBookingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingsApi - functional programming interface
 * @export
 */
export const BookingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBookingDto} createBookingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingControllerCreateUser(createBookingDto: CreateBookingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingControllerGetBookingById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingControllerCreateUser(createBookingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingControllerDeleteBooking(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingControllerDeleteBooking(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingControllerGetBookingById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingControllerGetBookingById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingControllerGetBookingById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingControllerGetListCars(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingControllerGetListMeetingRooms200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingControllerGetListCars(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingControllerGetListMeetingRooms(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingControllerGetListMeetingRooms200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingControllerGetListMeetingRooms(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBookingDto} updateBookingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingControllerUpdateBooking(id: string, updateBookingDto: UpdateBookingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingControllerGetBookingById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingControllerUpdateBooking(id, updateBookingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BookingsApi - factory interface
 * @export
 */
export const BookingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateBookingDto} createBookingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerCreateUser(createBookingDto: CreateBookingDto, options?: any): AxiosPromise<BookingControllerGetBookingById200Response> {
            return localVarFp.bookingControllerCreateUser(createBookingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerDeleteBooking(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.bookingControllerDeleteBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerGetBookingById(id: string, options?: any): AxiosPromise<BookingControllerGetBookingById200Response> {
            return localVarFp.bookingControllerGetBookingById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerGetListCars(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<BookingControllerGetListMeetingRooms200Response> {
            return localVarFp.bookingControllerGetListCars(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerGetListMeetingRooms(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<BookingControllerGetListMeetingRooms200Response> {
            return localVarFp.bookingControllerGetListMeetingRooms(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBookingDto} updateBookingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingControllerUpdateBooking(id: string, updateBookingDto: UpdateBookingDto, options?: any): AxiosPromise<BookingControllerGetBookingById200Response> {
            return localVarFp.bookingControllerUpdateBooking(id, updateBookingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingsApi - object-oriented interface
 * @export
 * @class BookingsApi
 * @extends {BaseAPI}
 */
export class BookingsApi extends BaseAPI {
    /**
     * 
     * @param {CreateBookingDto} createBookingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    public bookingControllerCreateUser(createBookingDto: CreateBookingDto, options?: AxiosRequestConfig) {
        return BookingsApiFp(this.configuration).bookingControllerCreateUser(createBookingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    public bookingControllerDeleteBooking(id: string, options?: AxiosRequestConfig) {
        return BookingsApiFp(this.configuration).bookingControllerDeleteBooking(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    public bookingControllerGetBookingById(id: string, options?: AxiosRequestConfig) {
        return BookingsApiFp(this.configuration).bookingControllerGetBookingById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    public bookingControllerGetListCars(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return BookingsApiFp(this.configuration).bookingControllerGetListCars(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    public bookingControllerGetListMeetingRooms(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return BookingsApiFp(this.configuration).bookingControllerGetListMeetingRooms(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateBookingDto} updateBookingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    public bookingControllerUpdateBooking(id: string, updateBookingDto: UpdateBookingDto, options?: AxiosRequestConfig) {
        return BookingsApiFp(this.configuration).bookingControllerUpdateBooking(id, updateBookingDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConfirmationsApi - axios parameter creator
 * @export
 */
export const ConfirmationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update batch of confirmations for manager
         * @param {BatchUpdateConfirmationDto} batchUpdateConfirmationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationControllerBatchUpdate: async (batchUpdateConfirmationDto: BatchUpdateConfirmationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchUpdateConfirmationDto' is not null or undefined
            assertParamExists('confirmationControllerBatchUpdate', 'batchUpdateConfirmationDto', batchUpdateConfirmationDto)
            const localVarPath = `/confirmations/batch-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUpdateConfirmationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get confirmations of requested manager
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} page 
         * @param {string} [managerId] 
         * @param {string} [employeeId] 
         * @param {boolean} [isGetByMonth] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationControllerGetListApprove: async (startDate: string, endDate: string, page: number, managerId?: string, employeeId?: string, isGetByMonth?: boolean, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('confirmationControllerGetListApprove', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('confirmationControllerGetListApprove', 'endDate', endDate)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('confirmationControllerGetListApprove', 'page', page)
            const localVarPath = `/confirmations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (managerId !== undefined) {
                localVarQueryParameter['managerId'] = managerId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (isGetByMonth !== undefined) {
                localVarQueryParameter['isGetByMonth'] = isGetByMonth;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update confirmation for manager
         * @param {string} id 
         * @param {UpdateConfirmationDto} updateConfirmationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationControllerUpdate: async (id: string, updateConfirmationDto: UpdateConfirmationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('confirmationControllerUpdate', 'id', id)
            // verify required parameter 'updateConfirmationDto' is not null or undefined
            assertParamExists('confirmationControllerUpdate', 'updateConfirmationDto', updateConfirmationDto)
            const localVarPath = `/confirmations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateConfirmationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfirmationsApi - functional programming interface
 * @export
 */
export const ConfirmationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfirmationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update batch of confirmations for manager
         * @param {BatchUpdateConfirmationDto} batchUpdateConfirmationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmationControllerBatchUpdate(batchUpdateConfirmationDto: BatchUpdateConfirmationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Confirmation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmationControllerBatchUpdate(batchUpdateConfirmationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get confirmations of requested manager
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} page 
         * @param {string} [managerId] 
         * @param {string} [employeeId] 
         * @param {boolean} [isGetByMonth] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmationControllerGetListApprove(startDate: string, endDate: string, page: number, managerId?: string, employeeId?: string, isGetByMonth?: boolean, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationControllerGetListApprove200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmationControllerGetListApprove(startDate, endDate, page, managerId, employeeId, isGetByMonth, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update confirmation for manager
         * @param {string} id 
         * @param {UpdateConfirmationDto} updateConfirmationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmationControllerUpdate(id: string, updateConfirmationDto: UpdateConfirmationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Confirmation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmationControllerUpdate(id, updateConfirmationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfirmationsApi - factory interface
 * @export
 */
export const ConfirmationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfirmationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Update batch of confirmations for manager
         * @param {BatchUpdateConfirmationDto} batchUpdateConfirmationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationControllerBatchUpdate(batchUpdateConfirmationDto: BatchUpdateConfirmationDto, options?: any): AxiosPromise<Array<Confirmation>> {
            return localVarFp.confirmationControllerBatchUpdate(batchUpdateConfirmationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get confirmations of requested manager
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} page 
         * @param {string} [managerId] 
         * @param {string} [employeeId] 
         * @param {boolean} [isGetByMonth] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationControllerGetListApprove(startDate: string, endDate: string, page: number, managerId?: string, employeeId?: string, isGetByMonth?: boolean, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<ConfirmationControllerGetListApprove200Response> {
            return localVarFp.confirmationControllerGetListApprove(startDate, endDate, page, managerId, employeeId, isGetByMonth, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update confirmation for manager
         * @param {string} id 
         * @param {UpdateConfirmationDto} updateConfirmationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationControllerUpdate(id: string, updateConfirmationDto: UpdateConfirmationDto, options?: any): AxiosPromise<Confirmation> {
            return localVarFp.confirmationControllerUpdate(id, updateConfirmationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfirmationsApi - object-oriented interface
 * @export
 * @class ConfirmationsApi
 * @extends {BaseAPI}
 */
export class ConfirmationsApi extends BaseAPI {
    /**
     * 
     * @summary Update batch of confirmations for manager
     * @param {BatchUpdateConfirmationDto} batchUpdateConfirmationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfirmationsApi
     */
    public confirmationControllerBatchUpdate(batchUpdateConfirmationDto: BatchUpdateConfirmationDto, options?: AxiosRequestConfig) {
        return ConfirmationsApiFp(this.configuration).confirmationControllerBatchUpdate(batchUpdateConfirmationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get confirmations of requested manager
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {number} page 
     * @param {string} [managerId] 
     * @param {string} [employeeId] 
     * @param {boolean} [isGetByMonth] 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfirmationsApi
     */
    public confirmationControllerGetListApprove(startDate: string, endDate: string, page: number, managerId?: string, employeeId?: string, isGetByMonth?: boolean, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return ConfirmationsApiFp(this.configuration).confirmationControllerGetListApprove(startDate, endDate, page, managerId, employeeId, isGetByMonth, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update confirmation for manager
     * @param {string} id 
     * @param {UpdateConfirmationDto} updateConfirmationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfirmationsApi
     */
    public confirmationControllerUpdate(id: string, updateConfirmationDto: UpdateConfirmationDto, options?: AxiosRequestConfig) {
        return ConfirmationsApiFp(this.configuration).confirmationControllerUpdate(id, updateConfirmationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateContactDto} createContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactControllerCreate: async (createContactDto: CreateContactDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createContactDto' is not null or undefined
            assertParamExists('contactControllerCreate', 'createContactDto', createContactDto)
            const localVarPath = `/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactControllerFindAll: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('contactControllerFindAll', 'page', page)
            const localVarPath = `/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateContactDto} createContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactControllerCreate(createContactDto: CreateContactDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactControllerCreate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactControllerCreate(createContactDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactControllerFindAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactControllerFindAll200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactControllerFindAll(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateContactDto} createContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactControllerCreate(createContactDto: CreateContactDto, options?: any): AxiosPromise<ContactControllerCreate200Response> {
            return localVarFp.contactControllerCreate(createContactDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactControllerFindAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<ContactControllerFindAll200Response> {
            return localVarFp.contactControllerFindAll(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI {
    /**
     * 
     * @param {CreateContactDto} createContactDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public contactControllerCreate(createContactDto: CreateContactDto, options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).contactControllerCreate(createContactDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public contactControllerFindAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).contactControllerFindAll(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DepartmentApi - axios parameter creator
 * @export
 */
export const DepartmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateDepartmentDto} createDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerCreate: async (createDepartmentDto: CreateDepartmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDepartmentDto' is not null or undefined
            assertParamExists('departmentControllerCreate', 'createDepartmentDto', createDepartmentDto)
            const localVarPath = `/department/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepartmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerFindAll: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('departmentControllerFindAll', 'page', page)
            const localVarPath = `/department/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('departmentControllerFindOne', 'id', id)
            const localVarPath = `/department/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('departmentControllerRemove', 'id', id)
            const localVarPath = `/department/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDepartmentDto} updateDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerUpdate: async (id: string, updateDepartmentDto: UpdateDepartmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('departmentControllerUpdate', 'id', id)
            // verify required parameter 'updateDepartmentDto' is not null or undefined
            assertParamExists('departmentControllerUpdate', 'updateDepartmentDto', updateDepartmentDto)
            const localVarPath = `/department/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepartmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentApi - functional programming interface
 * @export
 */
export const DepartmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateDepartmentDto} createDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentControllerCreate(createDepartmentDto: CreateDepartmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentControllerCreate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentControllerCreate(createDepartmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentControllerFindAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentControllerFindAll200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentControllerFindAll(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentControllerCreate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentControllerRemove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDepartmentDto} updateDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departmentControllerUpdate(id: string, updateDepartmentDto: UpdateDepartmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departmentControllerUpdate(id, updateDepartmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DepartmentApi - factory interface
 * @export
 */
export const DepartmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateDepartmentDto} createDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerCreate(createDepartmentDto: CreateDepartmentDto, options?: any): AxiosPromise<DepartmentControllerCreate200Response> {
            return localVarFp.departmentControllerCreate(createDepartmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerFindAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<DepartmentControllerFindAll200Response> {
            return localVarFp.departmentControllerFindAll(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerFindOne(id: string, options?: any): AxiosPromise<DepartmentControllerCreate200Response> {
            return localVarFp.departmentControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerRemove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.departmentControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDepartmentDto} updateDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departmentControllerUpdate(id: string, updateDepartmentDto: UpdateDepartmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.departmentControllerUpdate(id, updateDepartmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentApi - object-oriented interface
 * @export
 * @class DepartmentApi
 * @extends {BaseAPI}
 */
export class DepartmentApi extends BaseAPI {
    /**
     * 
     * @param {CreateDepartmentDto} createDepartmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentControllerCreate(createDepartmentDto: CreateDepartmentDto, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentControllerCreate(createDepartmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentControllerFindAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentControllerFindAll(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentControllerRemove(id: string, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDepartmentDto} updateDepartmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentApi
     */
    public departmentControllerUpdate(id: string, updateDepartmentDto: UpdateDepartmentDto, options?: AxiosRequestConfig) {
        return DepartmentApiFp(this.configuration).departmentControllerUpdate(id, updateDepartmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GeneralConfigApi - axios parameter creator
 * @export
 */
export const GeneralConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Batch upsert working schedule
         * @param {BatchUpsertWorkScheduleDto} batchUpsertWorkScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerBatchUpsertWorkSchedule: async (batchUpsertWorkScheduleDto: BatchUpsertWorkScheduleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchUpsertWorkScheduleDto' is not null or undefined
            assertParamExists('generalConfigControllerBatchUpsertWorkSchedule', 'batchUpsertWorkScheduleDto', batchUpsertWorkScheduleDto)
            const localVarPath = `/general-config/working-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUpsertWorkScheduleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get working schedule config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerConfigWorkSchedule: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/working-schedule/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create option
         * @param {CreateOptionDto} createOptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerCreateOption: async (createOptionDto: CreateOptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOptionDto' is not null or undefined
            assertParamExists('generalConfigControllerCreateOption', 'createOptionDto', createOptionDto)
            const localVarPath = `/general-config/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete option
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerDeleteOptionById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generalConfigControllerDeleteOptionById', 'id', id)
            const localVarPath = `/general-config/options/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export csv working schedule
         * @param {ExportWorkScheduleToCsvDto} exportWorkScheduleToCsvDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerExportWorkScheduleToCsv: async (exportWorkScheduleToCsvDto: ExportWorkScheduleToCsvDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportWorkScheduleToCsvDto' is not null or undefined
            assertParamExists('generalConfigControllerExportWorkScheduleToCsv', 'exportWorkScheduleToCsvDto', exportWorkScheduleToCsvDto)
            const localVarPath = `/general-config/export-working-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportWorkScheduleToCsvDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get default working time by recruiment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetDefaultWorkHourByRecruitType: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/default-work-hour-by-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get import data table
         * @param {'USER' | 'WORKING_HOURS'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetImportTableData: async (type: 'USER' | 'WORKING_HOURS', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('generalConfigControllerGetImportTableData', 'type', type)
            const localVarPath = `/general-config/import-table-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get line groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetLineGroups: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/line/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get line settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetLineSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/line`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetLogoConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetOptionCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/options/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get options
         * @param {string} [category] 
         * @param {string} [name] 
         * @param {string} [date] 
         * @param {string} [userId] 
         * @param {boolean} [isWeb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetOptions: async (category?: string, name?: string, date?: string, userId?: string, isWeb?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (isWeb !== undefined) {
                localVarQueryParameter['isWeb'] = isWeb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get overtime regulations settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetOvertimeRegulationsSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/overtime-regulations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} monthYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetThisMonthWorkSchedule: async (monthYear: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'monthYear' is not null or undefined
            assertParamExists('generalConfigControllerGetThisMonthWorkSchedule', 'monthYear', monthYear)
            const localVarPath = `/general-config/current-work-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (monthYear !== undefined) {
                localVarQueryParameter['monthYear'] = monthYear;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get timekeeping settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetTimeKeepingSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/timekeeping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get work hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetWorkHours: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/work-hours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get working schedule today
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetWorkScheduleToday: async (date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/working-schedule/today`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get working schedule config
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetWorkingSchedule: async (year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('generalConfigControllerGetWorkingSchedule', 'year', year)
            const localVarPath = `/general-config/working-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create working hours
         * @param {SaveWorkHoursDto} saveWorkHoursDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerSaveWorkHours: async (saveWorkHoursDto: SaveWorkHoursDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveWorkHoursDto' is not null or undefined
            assertParamExists('generalConfigControllerSaveWorkHours', 'saveWorkHoursDto', saveWorkHoursDto)
            const localVarPath = `/general-config/work-hours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveWorkHoursDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update line settings
         * @param {UpdateLineConfigDto} updateLineConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpdateLineSettings: async (updateLineConfigDto: UpdateLineConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateLineConfigDto' is not null or undefined
            assertParamExists('generalConfigControllerUpdateLineSettings', 'updateLineConfigDto', updateLineConfigDto)
            const localVarPath = `/general-config/line`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLineConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpdateLogoConfig: async (image?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general-config/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update option
         * @param {string} id 
         * @param {UpdateOptionDto} updateOptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpdateOptionById: async (id: string, updateOptionDto: UpdateOptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generalConfigControllerUpdateOptionById', 'id', id)
            // verify required parameter 'updateOptionDto' is not null or undefined
            assertParamExists('generalConfigControllerUpdateOptionById', 'updateOptionDto', updateOptionDto)
            const localVarPath = `/general-config/options/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upsert overtime regulations settings
         * @param {OvertimeRegulationSettingsValueDto} overtimeRegulationSettingsValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpsertOvertimeRegulationsSettings: async (overtimeRegulationSettingsValueDto: OvertimeRegulationSettingsValueDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'overtimeRegulationSettingsValueDto' is not null or undefined
            assertParamExists('generalConfigControllerUpsertOvertimeRegulationsSettings', 'overtimeRegulationSettingsValueDto', overtimeRegulationSettingsValueDto)
            const localVarPath = `/general-config/overtime-regulations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overtimeRegulationSettingsValueDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upsert timekeeping settings
         * @param {TimekeepingSettingsValueDto} timekeepingSettingsValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpsertTimeKeepingSettings: async (timekeepingSettingsValueDto: TimekeepingSettingsValueDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timekeepingSettingsValueDto' is not null or undefined
            assertParamExists('generalConfigControllerUpsertTimeKeepingSettings', 'timekeepingSettingsValueDto', timekeepingSettingsValueDto)
            const localVarPath = `/general-config/timekeeping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timekeepingSettingsValueDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralConfigApi - functional programming interface
 * @export
 */
export const GeneralConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Batch upsert working schedule
         * @param {BatchUpsertWorkScheduleDto} batchUpsertWorkScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerBatchUpsertWorkSchedule(batchUpsertWorkScheduleDto: BatchUpsertWorkScheduleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetWorkingSchedule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerBatchUpsertWorkSchedule(batchUpsertWorkScheduleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get working schedule config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerConfigWorkSchedule(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerConfigWorkSchedule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerConfigWorkSchedule(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create option
         * @param {CreateOptionDto} createOptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerCreateOption(createOptionDto: CreateOptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerCreateOption200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerCreateOption(createOptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete option
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerDeleteOptionById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Option>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerDeleteOptionById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export csv working schedule
         * @param {ExportWorkScheduleToCsvDto} exportWorkScheduleToCsvDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerExportWorkScheduleToCsv(exportWorkScheduleToCsvDto: ExportWorkScheduleToCsvDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserControllerExportUserToCsv200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerExportWorkScheduleToCsv(exportWorkScheduleToCsvDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get default working time by recruiment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetDefaultWorkHourByRecruitType(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetDefaultWorkHourByRecruitType200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetDefaultWorkHourByRecruitType(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get import data table
         * @param {'USER' | 'WORKING_HOURS'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetImportTableData(type: 'USER' | 'WORKING_HOURS', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetImportTableData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetImportTableData(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get line groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetLineGroups(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetLineGroups200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetLineGroups(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get line settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetLineSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetLineSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetLineSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetLogoConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetLogoConfig200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetLogoConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetOptionCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetOptionCategories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetOptionCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get options
         * @param {string} [category] 
         * @param {string} [name] 
         * @param {string} [date] 
         * @param {string} [userId] 
         * @param {boolean} [isWeb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetOptions(category?: string, name?: string, date?: string, userId?: string, isWeb?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetOptions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetOptions(category, name, date, userId, isWeb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get overtime regulations settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetOvertimeRegulationsSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetOvertimeRegulationsSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetOvertimeRegulationsSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} monthYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetThisMonthWorkSchedule(monthYear: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetThisMonthWorkSchedule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetThisMonthWorkSchedule(monthYear, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get timekeeping settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetTimeKeepingSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetTimeKeepingSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetTimeKeepingSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get work hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetWorkHours(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetWorkHours200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetWorkHours(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get working schedule today
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetWorkScheduleToday(date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetWorkScheduleToday200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetWorkScheduleToday(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get working schedule config
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerGetWorkingSchedule(year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetWorkingSchedule200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerGetWorkingSchedule(year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create working hours
         * @param {SaveWorkHoursDto} saveWorkHoursDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerSaveWorkHours(saveWorkHoursDto: SaveWorkHoursDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerSaveWorkHours200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerSaveWorkHours(saveWorkHoursDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update line settings
         * @param {UpdateLineConfigDto} updateLineConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerUpdateLineSettings(updateLineConfigDto: UpdateLineConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerUpdateLineSettings(updateLineConfigDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerUpdateLogoConfig(image?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerGetLogoConfig200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerUpdateLogoConfig(image, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update option
         * @param {string} id 
         * @param {UpdateOptionDto} updateOptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerUpdateOptionById(id: string, updateOptionDto: UpdateOptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralConfigControllerCreateOption200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerUpdateOptionById(id, updateOptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upsert overtime regulations settings
         * @param {OvertimeRegulationSettingsValueDto} overtimeRegulationSettingsValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerUpsertOvertimeRegulationsSettings(overtimeRegulationSettingsValueDto: OvertimeRegulationSettingsValueDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerUpsertOvertimeRegulationsSettings(overtimeRegulationSettingsValueDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upsert timekeeping settings
         * @param {TimekeepingSettingsValueDto} timekeepingSettingsValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalConfigControllerUpsertTimeKeepingSettings(timekeepingSettingsValueDto: TimekeepingSettingsValueDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalConfigControllerUpsertTimeKeepingSettings(timekeepingSettingsValueDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GeneralConfigApi - factory interface
 * @export
 */
export const GeneralConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralConfigApiFp(configuration)
    return {
        /**
         * 
         * @summary Batch upsert working schedule
         * @param {BatchUpsertWorkScheduleDto} batchUpsertWorkScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerBatchUpsertWorkSchedule(batchUpsertWorkScheduleDto: BatchUpsertWorkScheduleDto, options?: any): AxiosPromise<GeneralConfigControllerGetWorkingSchedule200Response> {
            return localVarFp.generalConfigControllerBatchUpsertWorkSchedule(batchUpsertWorkScheduleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get working schedule config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerConfigWorkSchedule(options?: any): AxiosPromise<GeneralConfigControllerConfigWorkSchedule200Response> {
            return localVarFp.generalConfigControllerConfigWorkSchedule(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create option
         * @param {CreateOptionDto} createOptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerCreateOption(createOptionDto: CreateOptionDto, options?: any): AxiosPromise<GeneralConfigControllerCreateOption200Response> {
            return localVarFp.generalConfigControllerCreateOption(createOptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete option
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerDeleteOptionById(id: string, options?: any): AxiosPromise<Option> {
            return localVarFp.generalConfigControllerDeleteOptionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export csv working schedule
         * @param {ExportWorkScheduleToCsvDto} exportWorkScheduleToCsvDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerExportWorkScheduleToCsv(exportWorkScheduleToCsvDto: ExportWorkScheduleToCsvDto, options?: any): AxiosPromise<UserControllerExportUserToCsv200Response> {
            return localVarFp.generalConfigControllerExportWorkScheduleToCsv(exportWorkScheduleToCsvDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get default working time by recruiment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetDefaultWorkHourByRecruitType(options?: any): AxiosPromise<GeneralConfigControllerGetDefaultWorkHourByRecruitType200Response> {
            return localVarFp.generalConfigControllerGetDefaultWorkHourByRecruitType(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get import data table
         * @param {'USER' | 'WORKING_HOURS'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetImportTableData(type: 'USER' | 'WORKING_HOURS', options?: any): AxiosPromise<GeneralConfigControllerGetImportTableData200Response> {
            return localVarFp.generalConfigControllerGetImportTableData(type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get line groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetLineGroups(options?: any): AxiosPromise<GeneralConfigControllerGetLineGroups200Response> {
            return localVarFp.generalConfigControllerGetLineGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get line settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetLineSettings(options?: any): AxiosPromise<GeneralConfigControllerGetLineSettings200Response> {
            return localVarFp.generalConfigControllerGetLineSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetLogoConfig(options?: any): AxiosPromise<GeneralConfigControllerGetLogoConfig200Response> {
            return localVarFp.generalConfigControllerGetLogoConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetOptionCategories(options?: any): AxiosPromise<GeneralConfigControllerGetOptionCategories200Response> {
            return localVarFp.generalConfigControllerGetOptionCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get options
         * @param {string} [category] 
         * @param {string} [name] 
         * @param {string} [date] 
         * @param {string} [userId] 
         * @param {boolean} [isWeb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetOptions(category?: string, name?: string, date?: string, userId?: string, isWeb?: boolean, options?: any): AxiosPromise<GeneralConfigControllerGetOptions200Response> {
            return localVarFp.generalConfigControllerGetOptions(category, name, date, userId, isWeb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get overtime regulations settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetOvertimeRegulationsSettings(options?: any): AxiosPromise<GeneralConfigControllerGetOvertimeRegulationsSettings200Response> {
            return localVarFp.generalConfigControllerGetOvertimeRegulationsSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} monthYear 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetThisMonthWorkSchedule(monthYear: string, options?: any): AxiosPromise<GeneralConfigControllerGetThisMonthWorkSchedule200Response> {
            return localVarFp.generalConfigControllerGetThisMonthWorkSchedule(monthYear, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get timekeeping settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetTimeKeepingSettings(options?: any): AxiosPromise<GeneralConfigControllerGetTimeKeepingSettings200Response> {
            return localVarFp.generalConfigControllerGetTimeKeepingSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get work hours
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetWorkHours(options?: any): AxiosPromise<GeneralConfigControllerGetWorkHours200Response> {
            return localVarFp.generalConfigControllerGetWorkHours(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get working schedule today
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetWorkScheduleToday(date?: string, options?: any): AxiosPromise<GeneralConfigControllerGetWorkScheduleToday200Response> {
            return localVarFp.generalConfigControllerGetWorkScheduleToday(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get working schedule config
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerGetWorkingSchedule(year: number, options?: any): AxiosPromise<GeneralConfigControllerGetWorkingSchedule200Response> {
            return localVarFp.generalConfigControllerGetWorkingSchedule(year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create working hours
         * @param {SaveWorkHoursDto} saveWorkHoursDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerSaveWorkHours(saveWorkHoursDto: SaveWorkHoursDto, options?: any): AxiosPromise<GeneralConfigControllerSaveWorkHours200Response> {
            return localVarFp.generalConfigControllerSaveWorkHours(saveWorkHoursDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update line settings
         * @param {UpdateLineConfigDto} updateLineConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpdateLineSettings(updateLineConfigDto: UpdateLineConfigDto, options?: any): AxiosPromise<object> {
            return localVarFp.generalConfigControllerUpdateLineSettings(updateLineConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpdateLogoConfig(image?: File, options?: any): AxiosPromise<GeneralConfigControllerGetLogoConfig200Response> {
            return localVarFp.generalConfigControllerUpdateLogoConfig(image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update option
         * @param {string} id 
         * @param {UpdateOptionDto} updateOptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpdateOptionById(id: string, updateOptionDto: UpdateOptionDto, options?: any): AxiosPromise<GeneralConfigControllerCreateOption200Response> {
            return localVarFp.generalConfigControllerUpdateOptionById(id, updateOptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upsert overtime regulations settings
         * @param {OvertimeRegulationSettingsValueDto} overtimeRegulationSettingsValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpsertOvertimeRegulationsSettings(overtimeRegulationSettingsValueDto: OvertimeRegulationSettingsValueDto, options?: any): AxiosPromise<object> {
            return localVarFp.generalConfigControllerUpsertOvertimeRegulationsSettings(overtimeRegulationSettingsValueDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upsert timekeeping settings
         * @param {TimekeepingSettingsValueDto} timekeepingSettingsValueDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalConfigControllerUpsertTimeKeepingSettings(timekeepingSettingsValueDto: TimekeepingSettingsValueDto, options?: any): AxiosPromise<object> {
            return localVarFp.generalConfigControllerUpsertTimeKeepingSettings(timekeepingSettingsValueDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeneralConfigApi - object-oriented interface
 * @export
 * @class GeneralConfigApi
 * @extends {BaseAPI}
 */
export class GeneralConfigApi extends BaseAPI {
    /**
     * 
     * @summary Batch upsert working schedule
     * @param {BatchUpsertWorkScheduleDto} batchUpsertWorkScheduleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerBatchUpsertWorkSchedule(batchUpsertWorkScheduleDto: BatchUpsertWorkScheduleDto, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerBatchUpsertWorkSchedule(batchUpsertWorkScheduleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get working schedule config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerConfigWorkSchedule(options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerConfigWorkSchedule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create option
     * @param {CreateOptionDto} createOptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerCreateOption(createOptionDto: CreateOptionDto, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerCreateOption(createOptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete option
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerDeleteOptionById(id: string, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerDeleteOptionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export csv working schedule
     * @param {ExportWorkScheduleToCsvDto} exportWorkScheduleToCsvDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerExportWorkScheduleToCsv(exportWorkScheduleToCsvDto: ExportWorkScheduleToCsvDto, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerExportWorkScheduleToCsv(exportWorkScheduleToCsvDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get default working time by recruiment type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetDefaultWorkHourByRecruitType(options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetDefaultWorkHourByRecruitType(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get import data table
     * @param {'USER' | 'WORKING_HOURS'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetImportTableData(type: 'USER' | 'WORKING_HOURS', options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetImportTableData(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get line groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetLineGroups(options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetLineGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get line settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetLineSettings(options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetLineSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetLogoConfig(options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetLogoConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetOptionCategories(options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetOptionCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get options
     * @param {string} [category] 
     * @param {string} [name] 
     * @param {string} [date] 
     * @param {string} [userId] 
     * @param {boolean} [isWeb] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetOptions(category?: string, name?: string, date?: string, userId?: string, isWeb?: boolean, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetOptions(category, name, date, userId, isWeb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get overtime regulations settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetOvertimeRegulationsSettings(options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetOvertimeRegulationsSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} monthYear 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetThisMonthWorkSchedule(monthYear: string, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetThisMonthWorkSchedule(monthYear, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get timekeeping settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetTimeKeepingSettings(options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetTimeKeepingSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get work hours
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetWorkHours(options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetWorkHours(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get working schedule today
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetWorkScheduleToday(date?: string, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetWorkScheduleToday(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get working schedule config
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerGetWorkingSchedule(year: number, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerGetWorkingSchedule(year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create working hours
     * @param {SaveWorkHoursDto} saveWorkHoursDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerSaveWorkHours(saveWorkHoursDto: SaveWorkHoursDto, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerSaveWorkHours(saveWorkHoursDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update line settings
     * @param {UpdateLineConfigDto} updateLineConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerUpdateLineSettings(updateLineConfigDto: UpdateLineConfigDto, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerUpdateLineSettings(updateLineConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [image] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerUpdateLogoConfig(image?: File, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerUpdateLogoConfig(image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update option
     * @param {string} id 
     * @param {UpdateOptionDto} updateOptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerUpdateOptionById(id: string, updateOptionDto: UpdateOptionDto, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerUpdateOptionById(id, updateOptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upsert overtime regulations settings
     * @param {OvertimeRegulationSettingsValueDto} overtimeRegulationSettingsValueDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerUpsertOvertimeRegulationsSettings(overtimeRegulationSettingsValueDto: OvertimeRegulationSettingsValueDto, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerUpsertOvertimeRegulationsSettings(overtimeRegulationSettingsValueDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upsert timekeeping settings
     * @param {TimekeepingSettingsValueDto} timekeepingSettingsValueDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeneralConfigApi
     */
    public generalConfigControllerUpsertTimeKeepingSettings(timekeepingSettingsValueDto: TimekeepingSettingsValueDto, options?: AxiosRequestConfig) {
        return GeneralConfigApiFp(this.configuration).generalConfigControllerUpsertTimeKeepingSettings(timekeepingSettingsValueDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GoogleApi - axios parameter creator
 * @export
 */
export const GoogleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetAuthUrl: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/google/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetCallbackAccount: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('googleAccountControllerGetCallbackAccount', 'code', code)
            const localVarPath = `/google/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} googleAccountId 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetEmployees: async (googleAccountId: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleAccountId' is not null or undefined
            assertParamExists('googleAccountControllerGetEmployees', 'googleAccountId', googleAccountId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('googleAccountControllerGetEmployees', 'page', page)
            const localVarPath = `/google/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (googleAccountId !== undefined) {
                localVarQueryParameter['googleAccountId'] = googleAccountId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [taskId] 
         * @param {string} [currentGoogleAccountId] 
         * @param {string} [targetGoogleAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetGoogleCalendarSyncTasks: async (taskId?: string, currentGoogleAccountId?: string, targetGoogleAccountId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/google/sync-tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (taskId !== undefined) {
                localVarQueryParameter['taskId'] = taskId;
            }

            if (currentGoogleAccountId !== undefined) {
                localVarQueryParameter['currentGoogleAccountId'] = currentGoogleAccountId;
            }

            if (targetGoogleAccountId !== undefined) {
                localVarQueryParameter['targetGoogleAccountId'] = targetGoogleAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetInfoGoogleAccount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/google/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [isAdmin] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetListAdminGoogleAccount: async (page: number, isAdmin?: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('googleAccountControllerGetListAdminGoogleAccount', 'page', page)
            const localVarPath = `/google/admin/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isAdmin !== undefined) {
                localVarQueryParameter['isAdmin'] = isAdmin;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGoogleCalendarWebhook: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/google/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LinkGoogleAccountEmployee} linkGoogleAccountEmployee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerLinkAccount: async (linkGoogleAccountEmployee: LinkGoogleAccountEmployee, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkGoogleAccountEmployee' is not null or undefined
            assertParamExists('googleAccountControllerLinkAccount', 'linkGoogleAccountEmployee', linkGoogleAccountEmployee)
            const localVarPath = `/google/link-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkGoogleAccountEmployee, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExchangeCodeDto} exchangeCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerLinkAccountAdmin: async (exchangeCodeDto: ExchangeCodeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeCodeDto' is not null or undefined
            assertParamExists('googleAccountControllerLinkAccountAdmin', 'exchangeCodeDto', exchangeCodeDto)
            const localVarPath = `/google/admin/link-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetDefaultAdminGoogleAccountDTO} setDefaultAdminGoogleAccountDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerSetDefaultAccountAdmin: async (setDefaultAdminGoogleAccountDTO: SetDefaultAdminGoogleAccountDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setDefaultAdminGoogleAccountDTO' is not null or undefined
            assertParamExists('googleAccountControllerSetDefaultAccountAdmin', 'setDefaultAdminGoogleAccountDTO', setDefaultAdminGoogleAccountDTO)
            const localVarPath = `/google/admin/set-default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setDefaultAdminGoogleAccountDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerTest: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/google/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferEmployeesCalendarDto} transferEmployeesCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerTransferEmployeesCalendar: async (transferEmployeesCalendarDto: TransferEmployeesCalendarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferEmployeesCalendarDto' is not null or undefined
            assertParamExists('googleAccountControllerTransferEmployeesCalendar', 'transferEmployeesCalendarDto', transferEmployeesCalendarDto)
            const localVarPath = `/google/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferEmployeesCalendarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerUnlinkAccount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/google/unlink-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnlinkAccountAdminDTO} unlinkAccountAdminDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerUnlinkAccountAdmin: async (unlinkAccountAdminDTO: UnlinkAccountAdminDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unlinkAccountAdminDTO' is not null or undefined
            assertParamExists('googleAccountControllerUnlinkAccountAdmin', 'unlinkAccountAdminDTO', unlinkAccountAdminDTO)
            const localVarPath = `/google/admin/unlink-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unlinkAccountAdminDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GoogleApi - functional programming interface
 * @export
 */
export const GoogleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GoogleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerGetAuthUrl(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerGetAuthUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerGetAuthUrl(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerGetCallbackAccount(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerGetCallbackAccount(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} googleAccountId 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerGetEmployees(googleAccountId: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerGetEmployees200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerGetEmployees(googleAccountId, page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [taskId] 
         * @param {string} [currentGoogleAccountId] 
         * @param {string} [targetGoogleAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerGetGoogleCalendarSyncTasks(taskId?: string, currentGoogleAccountId?: string, targetGoogleAccountId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerGetGoogleCalendarSyncTasks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerGetGoogleCalendarSyncTasks(taskId, currentGoogleAccountId, targetGoogleAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerGetInfoGoogleAccount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerGetInfoGoogleAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerGetInfoGoogleAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [isAdmin] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerGetListAdminGoogleAccount(page: number, isAdmin?: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerGetListAdminGoogleAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerGetListAdminGoogleAccount(page, isAdmin, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerGoogleCalendarWebhook(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerGoogleCalendarWebhook(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LinkGoogleAccountEmployee} linkGoogleAccountEmployee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerLinkAccount(linkGoogleAccountEmployee: LinkGoogleAccountEmployee, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerLinkAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerLinkAccount(linkGoogleAccountEmployee, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ExchangeCodeDto} exchangeCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerLinkAccountAdmin(exchangeCodeDto: ExchangeCodeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerLinkAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerLinkAccountAdmin(exchangeCodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetDefaultAdminGoogleAccountDTO} setDefaultAdminGoogleAccountDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerSetDefaultAccountAdmin(setDefaultAdminGoogleAccountDTO: SetDefaultAdminGoogleAccountDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerLinkAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerSetDefaultAccountAdmin(setDefaultAdminGoogleAccountDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerTest(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerTest(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferEmployeesCalendarDto} transferEmployeesCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerTransferEmployeesCalendar(transferEmployeesCalendarDto: TransferEmployeesCalendarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerTransferEmployeesCalendar(transferEmployeesCalendarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerUnlinkAccount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerLinkAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerUnlinkAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnlinkAccountAdminDTO} unlinkAccountAdminDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAccountControllerUnlinkAccountAdmin(unlinkAccountAdminDTO: UnlinkAccountAdminDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerLinkAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAccountControllerUnlinkAccountAdmin(unlinkAccountAdminDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GoogleApi - factory interface
 * @export
 */
export const GoogleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GoogleApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetAuthUrl(options?: any): AxiosPromise<GoogleAccountControllerGetAuthUrl200Response> {
            return localVarFp.googleAccountControllerGetAuthUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetCallbackAccount(code: string, options?: any): AxiosPromise<void> {
            return localVarFp.googleAccountControllerGetCallbackAccount(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} googleAccountId 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetEmployees(googleAccountId: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<GoogleAccountControllerGetEmployees200Response> {
            return localVarFp.googleAccountControllerGetEmployees(googleAccountId, page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [taskId] 
         * @param {string} [currentGoogleAccountId] 
         * @param {string} [targetGoogleAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetGoogleCalendarSyncTasks(taskId?: string, currentGoogleAccountId?: string, targetGoogleAccountId?: string, options?: any): AxiosPromise<GoogleAccountControllerGetGoogleCalendarSyncTasks200Response> {
            return localVarFp.googleAccountControllerGetGoogleCalendarSyncTasks(taskId, currentGoogleAccountId, targetGoogleAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetInfoGoogleAccount(options?: any): AxiosPromise<GoogleAccountControllerGetInfoGoogleAccount200Response> {
            return localVarFp.googleAccountControllerGetInfoGoogleAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [isAdmin] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGetListAdminGoogleAccount(page: number, isAdmin?: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<GoogleAccountControllerGetListAdminGoogleAccount200Response> {
            return localVarFp.googleAccountControllerGetListAdminGoogleAccount(page, isAdmin, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerGoogleCalendarWebhook(options?: any): AxiosPromise<void> {
            return localVarFp.googleAccountControllerGoogleCalendarWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LinkGoogleAccountEmployee} linkGoogleAccountEmployee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerLinkAccount(linkGoogleAccountEmployee: LinkGoogleAccountEmployee, options?: any): AxiosPromise<GoogleAccountControllerLinkAccount200Response> {
            return localVarFp.googleAccountControllerLinkAccount(linkGoogleAccountEmployee, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExchangeCodeDto} exchangeCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerLinkAccountAdmin(exchangeCodeDto: ExchangeCodeDto, options?: any): AxiosPromise<GoogleAccountControllerLinkAccount200Response> {
            return localVarFp.googleAccountControllerLinkAccountAdmin(exchangeCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetDefaultAdminGoogleAccountDTO} setDefaultAdminGoogleAccountDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerSetDefaultAccountAdmin(setDefaultAdminGoogleAccountDTO: SetDefaultAdminGoogleAccountDTO, options?: any): AxiosPromise<GoogleAccountControllerLinkAccount200Response> {
            return localVarFp.googleAccountControllerSetDefaultAccountAdmin(setDefaultAdminGoogleAccountDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerTest(options?: any): AxiosPromise<void> {
            return localVarFp.googleAccountControllerTest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferEmployeesCalendarDto} transferEmployeesCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerTransferEmployeesCalendar(transferEmployeesCalendarDto: TransferEmployeesCalendarDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.googleAccountControllerTransferEmployeesCalendar(transferEmployeesCalendarDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerUnlinkAccount(options?: any): AxiosPromise<GoogleAccountControllerLinkAccount200Response> {
            return localVarFp.googleAccountControllerUnlinkAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnlinkAccountAdminDTO} unlinkAccountAdminDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAccountControllerUnlinkAccountAdmin(unlinkAccountAdminDTO: UnlinkAccountAdminDTO, options?: any): AxiosPromise<GoogleAccountControllerLinkAccount200Response> {
            return localVarFp.googleAccountControllerUnlinkAccountAdmin(unlinkAccountAdminDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GoogleApi - object-oriented interface
 * @export
 * @class GoogleApi
 * @extends {BaseAPI}
 */
export class GoogleApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerGetAuthUrl(options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerGetAuthUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerGetCallbackAccount(code: string, options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerGetCallbackAccount(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} googleAccountId 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerGetEmployees(googleAccountId: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerGetEmployees(googleAccountId, page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [taskId] 
     * @param {string} [currentGoogleAccountId] 
     * @param {string} [targetGoogleAccountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerGetGoogleCalendarSyncTasks(taskId?: string, currentGoogleAccountId?: string, targetGoogleAccountId?: string, options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerGetGoogleCalendarSyncTasks(taskId, currentGoogleAccountId, targetGoogleAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerGetInfoGoogleAccount(options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerGetInfoGoogleAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [isAdmin] 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerGetListAdminGoogleAccount(page: number, isAdmin?: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerGetListAdminGoogleAccount(page, isAdmin, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerGoogleCalendarWebhook(options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerGoogleCalendarWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LinkGoogleAccountEmployee} linkGoogleAccountEmployee 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerLinkAccount(linkGoogleAccountEmployee: LinkGoogleAccountEmployee, options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerLinkAccount(linkGoogleAccountEmployee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExchangeCodeDto} exchangeCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerLinkAccountAdmin(exchangeCodeDto: ExchangeCodeDto, options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerLinkAccountAdmin(exchangeCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetDefaultAdminGoogleAccountDTO} setDefaultAdminGoogleAccountDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerSetDefaultAccountAdmin(setDefaultAdminGoogleAccountDTO: SetDefaultAdminGoogleAccountDTO, options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerSetDefaultAccountAdmin(setDefaultAdminGoogleAccountDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerTest(options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerTest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferEmployeesCalendarDto} transferEmployeesCalendarDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerTransferEmployeesCalendar(transferEmployeesCalendarDto: TransferEmployeesCalendarDto, options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerTransferEmployeesCalendar(transferEmployeesCalendarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerUnlinkAccount(options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerUnlinkAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnlinkAccountAdminDTO} unlinkAccountAdminDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleApi
     */
    public googleAccountControllerUnlinkAccountAdmin(unlinkAccountAdminDTO: UnlinkAccountAdminDTO, options?: AxiosRequestConfig) {
        return GoogleApiFp(this.configuration).googleAccountControllerUnlinkAccountAdmin(unlinkAccountAdminDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LeaveRegulationConfigApi - axios parameter creator
 * @export
 */
export const LeaveRegulationConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get leave regulations
         * @param {string} recruitmentTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveRegulationConfigControllerGetAllByRecruitmentTypeId: async (recruitmentTypeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recruitmentTypeId' is not null or undefined
            assertParamExists('leaveRegulationConfigControllerGetAllByRecruitmentTypeId', 'recruitmentTypeId', recruitmentTypeId)
            const localVarPath = `/leave-regulation-config/{recruitmentTypeId}`
                .replace(`{${"recruitmentTypeId"}}`, encodeURIComponent(String(recruitmentTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update leave regulations
         * @param {string} recruitmentTypeId 
         * @param {UpdateLeaveRegulationConfigDto} updateLeaveRegulationConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveRegulationConfigControllerUpdateByRecruitmentTypeId: async (recruitmentTypeId: string, updateLeaveRegulationConfigDto: UpdateLeaveRegulationConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recruitmentTypeId' is not null or undefined
            assertParamExists('leaveRegulationConfigControllerUpdateByRecruitmentTypeId', 'recruitmentTypeId', recruitmentTypeId)
            // verify required parameter 'updateLeaveRegulationConfigDto' is not null or undefined
            assertParamExists('leaveRegulationConfigControllerUpdateByRecruitmentTypeId', 'updateLeaveRegulationConfigDto', updateLeaveRegulationConfigDto)
            const localVarPath = `/leave-regulation-config/{recruitmentTypeId}`
                .replace(`{${"recruitmentTypeId"}}`, encodeURIComponent(String(recruitmentTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLeaveRegulationConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeaveRegulationConfigApi - functional programming interface
 * @export
 */
export const LeaveRegulationConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeaveRegulationConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get leave regulations
         * @param {string} recruitmentTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveRegulationConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveRegulationConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update leave regulations
         * @param {string} recruitmentTypeId 
         * @param {UpdateLeaveRegulationConfigDto} updateLeaveRegulationConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveRegulationConfigControllerUpdateByRecruitmentTypeId(recruitmentTypeId: string, updateLeaveRegulationConfigDto: UpdateLeaveRegulationConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveRegulationConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveRegulationConfigControllerUpdateByRecruitmentTypeId(recruitmentTypeId, updateLeaveRegulationConfigDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LeaveRegulationConfigApi - factory interface
 * @export
 */
export const LeaveRegulationConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeaveRegulationConfigApiFp(configuration)
    return {
        /**
         * 
         * @summary Get leave regulations
         * @param {string} recruitmentTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveRegulationConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId: string, options?: any): AxiosPromise<LeaveRegulationConfigControllerGetAllByRecruitmentTypeId200Response> {
            return localVarFp.leaveRegulationConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update leave regulations
         * @param {string} recruitmentTypeId 
         * @param {UpdateLeaveRegulationConfigDto} updateLeaveRegulationConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveRegulationConfigControllerUpdateByRecruitmentTypeId(recruitmentTypeId: string, updateLeaveRegulationConfigDto: UpdateLeaveRegulationConfigDto, options?: any): AxiosPromise<LeaveRegulationConfig> {
            return localVarFp.leaveRegulationConfigControllerUpdateByRecruitmentTypeId(recruitmentTypeId, updateLeaveRegulationConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeaveRegulationConfigApi - object-oriented interface
 * @export
 * @class LeaveRegulationConfigApi
 * @extends {BaseAPI}
 */
export class LeaveRegulationConfigApi extends BaseAPI {
    /**
     * 
     * @summary Get leave regulations
     * @param {string} recruitmentTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveRegulationConfigApi
     */
    public leaveRegulationConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId: string, options?: AxiosRequestConfig) {
        return LeaveRegulationConfigApiFp(this.configuration).leaveRegulationConfigControllerGetAllByRecruitmentTypeId(recruitmentTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update leave regulations
     * @param {string} recruitmentTypeId 
     * @param {UpdateLeaveRegulationConfigDto} updateLeaveRegulationConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveRegulationConfigApi
     */
    public leaveRegulationConfigControllerUpdateByRecruitmentTypeId(recruitmentTypeId: string, updateLeaveRegulationConfigDto: UpdateLeaveRegulationConfigDto, options?: AxiosRequestConfig) {
        return LeaveRegulationConfigApiFp(this.configuration).leaveRegulationConfigControllerUpdateByRecruitmentTypeId(recruitmentTypeId, updateLeaveRegulationConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LineApi - axios parameter creator
 * @export
 */
export const LineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GetAccessTokenLineDto} getAccessTokenLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerGetAccessToken: async (getAccessTokenLineDto: GetAccessTokenLineDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAccessTokenLineDto' is not null or undefined
            assertParamExists('lineControllerGetAccessToken', 'getAccessTokenLineDto', getAccessTokenLineDto)
            const localVarPath = `/line/link-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAccessTokenLineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerGetCallbackAccount: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('lineControllerGetCallbackAccount', 'code', code)
            const localVarPath = `/line/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerHandleLineWebhook: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/line/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'SplashScreen' | 'LoginScreen' | 'SignUpScreen' | 'HomeScreen' | 'ForgotPasswordScreen' | 'LinkingAccountScreen' | 'TimeKeepingScreen' | 'CheckinScreen' | 'PerformedSuccessfullyScreen' | 'ScheduleScreen' | 'GoLateScreen' | 'LineLoginScreen' | 'SeeAllSendingHistoryScreen' | 'SendingDetailHistoryScreen' | 'LeaveEarlyScreen' | 'OverTimeScreen' | 'PlannedVacationScreen' | 'BusinessTripScreen' | 'PrivateOutingScreen' | 'OfficialOutingScreen' | 'SettingScreen' | 'FormBusinessScreen' | 'ScheduleDetailCalendarScreen' | 'BookingScreen' | 'VehicleReservationScreen' | 'MeetingRoomScreen' | 'ReservationHistoryScreen' | 'FaildRequestScreen' | 'SettingCalendarScreen' | 'SettingLinkedAccountScreen' | 'ApprovalScreen' | 'LocationScreen'} appScreen 
         * @param {string} desktopUri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerLaunchAppViaDeepLink: async (appScreen: 'SplashScreen' | 'LoginScreen' | 'SignUpScreen' | 'HomeScreen' | 'ForgotPasswordScreen' | 'LinkingAccountScreen' | 'TimeKeepingScreen' | 'CheckinScreen' | 'PerformedSuccessfullyScreen' | 'ScheduleScreen' | 'GoLateScreen' | 'LineLoginScreen' | 'SeeAllSendingHistoryScreen' | 'SendingDetailHistoryScreen' | 'LeaveEarlyScreen' | 'OverTimeScreen' | 'PlannedVacationScreen' | 'BusinessTripScreen' | 'PrivateOutingScreen' | 'OfficialOutingScreen' | 'SettingScreen' | 'FormBusinessScreen' | 'ScheduleDetailCalendarScreen' | 'BookingScreen' | 'VehicleReservationScreen' | 'MeetingRoomScreen' | 'ReservationHistoryScreen' | 'FaildRequestScreen' | 'SettingCalendarScreen' | 'SettingLinkedAccountScreen' | 'ApprovalScreen' | 'LocationScreen', desktopUri: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appScreen' is not null or undefined
            assertParamExists('lineControllerLaunchAppViaDeepLink', 'appScreen', appScreen)
            // verify required parameter 'desktopUri' is not null or undefined
            assertParamExists('lineControllerLaunchAppViaDeepLink', 'desktopUri', desktopUri)
            const localVarPath = `/line/launch-app-via-deeplink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appScreen !== undefined) {
                localVarQueryParameter['appScreen'] = appScreen;
            }

            if (desktopUri !== undefined) {
                localVarQueryParameter['desktopUri'] = desktopUri;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerLineLogin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/line/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PushMessageLineDto} pushMessageLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerPushMessage: async (pushMessageLineDto: PushMessageLineDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushMessageLineDto' is not null or undefined
            assertParamExists('lineControllerPushMessage', 'pushMessageLineDto', pushMessageLineDto)
            const localVarPath = `/line/push-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushMessageLineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerUnlinkLineAccount: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/line/unlink-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LineApi - functional programming interface
 * @export
 */
export const LineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LineApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GetAccessTokenLineDto} getAccessTokenLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineControllerGetAccessToken(getAccessTokenLineDto: GetAccessTokenLineDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineControllerGetAccessToken(getAccessTokenLineDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineControllerGetCallbackAccount(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineControllerGetCallbackAccount(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineControllerHandleLineWebhook(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineControllerHandleLineWebhook(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'SplashScreen' | 'LoginScreen' | 'SignUpScreen' | 'HomeScreen' | 'ForgotPasswordScreen' | 'LinkingAccountScreen' | 'TimeKeepingScreen' | 'CheckinScreen' | 'PerformedSuccessfullyScreen' | 'ScheduleScreen' | 'GoLateScreen' | 'LineLoginScreen' | 'SeeAllSendingHistoryScreen' | 'SendingDetailHistoryScreen' | 'LeaveEarlyScreen' | 'OverTimeScreen' | 'PlannedVacationScreen' | 'BusinessTripScreen' | 'PrivateOutingScreen' | 'OfficialOutingScreen' | 'SettingScreen' | 'FormBusinessScreen' | 'ScheduleDetailCalendarScreen' | 'BookingScreen' | 'VehicleReservationScreen' | 'MeetingRoomScreen' | 'ReservationHistoryScreen' | 'FaildRequestScreen' | 'SettingCalendarScreen' | 'SettingLinkedAccountScreen' | 'ApprovalScreen' | 'LocationScreen'} appScreen 
         * @param {string} desktopUri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineControllerLaunchAppViaDeepLink(appScreen: 'SplashScreen' | 'LoginScreen' | 'SignUpScreen' | 'HomeScreen' | 'ForgotPasswordScreen' | 'LinkingAccountScreen' | 'TimeKeepingScreen' | 'CheckinScreen' | 'PerformedSuccessfullyScreen' | 'ScheduleScreen' | 'GoLateScreen' | 'LineLoginScreen' | 'SeeAllSendingHistoryScreen' | 'SendingDetailHistoryScreen' | 'LeaveEarlyScreen' | 'OverTimeScreen' | 'PlannedVacationScreen' | 'BusinessTripScreen' | 'PrivateOutingScreen' | 'OfficialOutingScreen' | 'SettingScreen' | 'FormBusinessScreen' | 'ScheduleDetailCalendarScreen' | 'BookingScreen' | 'VehicleReservationScreen' | 'MeetingRoomScreen' | 'ReservationHistoryScreen' | 'FaildRequestScreen' | 'SettingCalendarScreen' | 'SettingLinkedAccountScreen' | 'ApprovalScreen' | 'LocationScreen', desktopUri: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineControllerLaunchAppViaDeepLink(appScreen, desktopUri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineControllerLineLogin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineControllerLineLogin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PushMessageLineDto} pushMessageLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineControllerPushMessage(pushMessageLineDto: PushMessageLineDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineControllerPushMessage(pushMessageLineDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lineControllerUnlinkLineAccount(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lineControllerUnlinkLineAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LineApi - factory interface
 * @export
 */
export const LineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LineApiFp(configuration)
    return {
        /**
         * 
         * @param {GetAccessTokenLineDto} getAccessTokenLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerGetAccessToken(getAccessTokenLineDto: GetAccessTokenLineDto, options?: any): AxiosPromise<object> {
            return localVarFp.lineControllerGetAccessToken(getAccessTokenLineDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerGetCallbackAccount(code: string, options?: any): AxiosPromise<string> {
            return localVarFp.lineControllerGetCallbackAccount(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerHandleLineWebhook(options?: any): AxiosPromise<void> {
            return localVarFp.lineControllerHandleLineWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'SplashScreen' | 'LoginScreen' | 'SignUpScreen' | 'HomeScreen' | 'ForgotPasswordScreen' | 'LinkingAccountScreen' | 'TimeKeepingScreen' | 'CheckinScreen' | 'PerformedSuccessfullyScreen' | 'ScheduleScreen' | 'GoLateScreen' | 'LineLoginScreen' | 'SeeAllSendingHistoryScreen' | 'SendingDetailHistoryScreen' | 'LeaveEarlyScreen' | 'OverTimeScreen' | 'PlannedVacationScreen' | 'BusinessTripScreen' | 'PrivateOutingScreen' | 'OfficialOutingScreen' | 'SettingScreen' | 'FormBusinessScreen' | 'ScheduleDetailCalendarScreen' | 'BookingScreen' | 'VehicleReservationScreen' | 'MeetingRoomScreen' | 'ReservationHistoryScreen' | 'FaildRequestScreen' | 'SettingCalendarScreen' | 'SettingLinkedAccountScreen' | 'ApprovalScreen' | 'LocationScreen'} appScreen 
         * @param {string} desktopUri 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerLaunchAppViaDeepLink(appScreen: 'SplashScreen' | 'LoginScreen' | 'SignUpScreen' | 'HomeScreen' | 'ForgotPasswordScreen' | 'LinkingAccountScreen' | 'TimeKeepingScreen' | 'CheckinScreen' | 'PerformedSuccessfullyScreen' | 'ScheduleScreen' | 'GoLateScreen' | 'LineLoginScreen' | 'SeeAllSendingHistoryScreen' | 'SendingDetailHistoryScreen' | 'LeaveEarlyScreen' | 'OverTimeScreen' | 'PlannedVacationScreen' | 'BusinessTripScreen' | 'PrivateOutingScreen' | 'OfficialOutingScreen' | 'SettingScreen' | 'FormBusinessScreen' | 'ScheduleDetailCalendarScreen' | 'BookingScreen' | 'VehicleReservationScreen' | 'MeetingRoomScreen' | 'ReservationHistoryScreen' | 'FaildRequestScreen' | 'SettingCalendarScreen' | 'SettingLinkedAccountScreen' | 'ApprovalScreen' | 'LocationScreen', desktopUri: string, options?: any): AxiosPromise<string> {
            return localVarFp.lineControllerLaunchAppViaDeepLink(appScreen, desktopUri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerLineLogin(options?: any): AxiosPromise<UrlDto> {
            return localVarFp.lineControllerLineLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PushMessageLineDto} pushMessageLineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerPushMessage(pushMessageLineDto: PushMessageLineDto, options?: any): AxiosPromise<void> {
            return localVarFp.lineControllerPushMessage(pushMessageLineDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lineControllerUnlinkLineAccount(options?: any): AxiosPromise<void> {
            return localVarFp.lineControllerUnlinkLineAccount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LineApi - object-oriented interface
 * @export
 * @class LineApi
 * @extends {BaseAPI}
 */
export class LineApi extends BaseAPI {
    /**
     * 
     * @param {GetAccessTokenLineDto} getAccessTokenLineDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineApi
     */
    public lineControllerGetAccessToken(getAccessTokenLineDto: GetAccessTokenLineDto, options?: AxiosRequestConfig) {
        return LineApiFp(this.configuration).lineControllerGetAccessToken(getAccessTokenLineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineApi
     */
    public lineControllerGetCallbackAccount(code: string, options?: AxiosRequestConfig) {
        return LineApiFp(this.configuration).lineControllerGetCallbackAccount(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineApi
     */
    public lineControllerHandleLineWebhook(options?: AxiosRequestConfig) {
        return LineApiFp(this.configuration).lineControllerHandleLineWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'SplashScreen' | 'LoginScreen' | 'SignUpScreen' | 'HomeScreen' | 'ForgotPasswordScreen' | 'LinkingAccountScreen' | 'TimeKeepingScreen' | 'CheckinScreen' | 'PerformedSuccessfullyScreen' | 'ScheduleScreen' | 'GoLateScreen' | 'LineLoginScreen' | 'SeeAllSendingHistoryScreen' | 'SendingDetailHistoryScreen' | 'LeaveEarlyScreen' | 'OverTimeScreen' | 'PlannedVacationScreen' | 'BusinessTripScreen' | 'PrivateOutingScreen' | 'OfficialOutingScreen' | 'SettingScreen' | 'FormBusinessScreen' | 'ScheduleDetailCalendarScreen' | 'BookingScreen' | 'VehicleReservationScreen' | 'MeetingRoomScreen' | 'ReservationHistoryScreen' | 'FaildRequestScreen' | 'SettingCalendarScreen' | 'SettingLinkedAccountScreen' | 'ApprovalScreen' | 'LocationScreen'} appScreen 
     * @param {string} desktopUri 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineApi
     */
    public lineControllerLaunchAppViaDeepLink(appScreen: 'SplashScreen' | 'LoginScreen' | 'SignUpScreen' | 'HomeScreen' | 'ForgotPasswordScreen' | 'LinkingAccountScreen' | 'TimeKeepingScreen' | 'CheckinScreen' | 'PerformedSuccessfullyScreen' | 'ScheduleScreen' | 'GoLateScreen' | 'LineLoginScreen' | 'SeeAllSendingHistoryScreen' | 'SendingDetailHistoryScreen' | 'LeaveEarlyScreen' | 'OverTimeScreen' | 'PlannedVacationScreen' | 'BusinessTripScreen' | 'PrivateOutingScreen' | 'OfficialOutingScreen' | 'SettingScreen' | 'FormBusinessScreen' | 'ScheduleDetailCalendarScreen' | 'BookingScreen' | 'VehicleReservationScreen' | 'MeetingRoomScreen' | 'ReservationHistoryScreen' | 'FaildRequestScreen' | 'SettingCalendarScreen' | 'SettingLinkedAccountScreen' | 'ApprovalScreen' | 'LocationScreen', desktopUri: string, options?: AxiosRequestConfig) {
        return LineApiFp(this.configuration).lineControllerLaunchAppViaDeepLink(appScreen, desktopUri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineApi
     */
    public lineControllerLineLogin(options?: AxiosRequestConfig) {
        return LineApiFp(this.configuration).lineControllerLineLogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PushMessageLineDto} pushMessageLineDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineApi
     */
    public lineControllerPushMessage(pushMessageLineDto: PushMessageLineDto, options?: AxiosRequestConfig) {
        return LineApiFp(this.configuration).lineControllerPushMessage(pushMessageLineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineApi
     */
    public lineControllerUnlinkLineAccount(options?: AxiosRequestConfig) {
        return LineApiFp(this.configuration).lineControllerUnlinkLineAccount(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateLocationDto} createLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerCreate: async (createLocationDto: CreateLocationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLocationDto' is not null or undefined
            assertParamExists('locationControllerCreate', 'createLocationDto', createLocationDto)
            const localVarPath = `/locations/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerDelete: async (id: string, updateLocationDto: UpdateLocationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationControllerDelete', 'id', id)
            // verify required parameter 'updateLocationDto' is not null or undefined
            assertParamExists('locationControllerDelete', 'updateLocationDto', updateLocationDto)
            const localVarPath = `/locations/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerGetAll: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('locationControllerGetAll', 'page', page)
            const localVarPath = `/locations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerGetUsersAbsenceNow: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('locationControllerGetUsersAbsenceNow', 'page', page)
            const localVarPath = `/locations/users/absence-now`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {string} [name] 
         * @param {string} [location] 
         * @param {string} [department] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerGetUsersLocation: async (page: number, size?: number, sort?: string, fullTextSearch?: string, name?: string, location?: string, department?: string, position?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('locationControllerGetUsersLocation', 'page', page)
            const localVarPath = `/locations/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerUpdate: async (id: string, updateLocationDto: UpdateLocationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('locationControllerUpdate', 'id', id)
            // verify required parameter 'updateLocationDto' is not null or undefined
            assertParamExists('locationControllerUpdate', 'updateLocationDto', updateLocationDto)
            const localVarPath = `/locations/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update location for user in App
         * @param {UserUpdateLocationDto} userUpdateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerUpdateUserLocation: async (userUpdateLocationDto: UserUpdateLocationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUpdateLocationDto' is not null or undefined
            assertParamExists('locationControllerUpdateUserLocation', 'userUpdateLocationDto', userUpdateLocationDto)
            const localVarPath = `/locations/user/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateLocationDto} createLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerCreate(createLocationDto: CreateLocationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationControllerCreate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerCreate(createLocationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerDelete(id: string, updateLocationDto: UpdateLocationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerDelete(id, updateLocationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerGetAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationControllerGetAll200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerGetAll(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerGetUsersAbsenceNow(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerGetEmployees200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerGetUsersAbsenceNow(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {string} [name] 
         * @param {string} [location] 
         * @param {string} [department] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerGetUsersLocation(page: number, size?: number, sort?: string, fullTextSearch?: string, name?: string, location?: string, department?: string, position?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerGetEmployees200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerGetUsersLocation(page, size, sort, fullTextSearch, name, location, department, position, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerUpdate(id: string, updateLocationDto: UpdateLocationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationControllerCreate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerUpdate(id, updateLocationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update location for user in App
         * @param {UserUpdateLocationDto} userUpdateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async locationControllerUpdateUserLocation(userUpdateLocationDto: UserUpdateLocationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.locationControllerUpdateUserLocation(userUpdateLocationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateLocationDto} createLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerCreate(createLocationDto: CreateLocationDto, options?: any): AxiosPromise<LocationControllerCreate200Response> {
            return localVarFp.locationControllerCreate(createLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerDelete(id: string, updateLocationDto: UpdateLocationDto, options?: any): AxiosPromise<void> {
            return localVarFp.locationControllerDelete(id, updateLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerGetAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<LocationControllerGetAll200Response> {
            return localVarFp.locationControllerGetAll(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerGetUsersAbsenceNow(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<GoogleAccountControllerGetEmployees200Response> {
            return localVarFp.locationControllerGetUsersAbsenceNow(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {string} [name] 
         * @param {string} [location] 
         * @param {string} [department] 
         * @param {string} [position] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerGetUsersLocation(page: number, size?: number, sort?: string, fullTextSearch?: string, name?: string, location?: string, department?: string, position?: string, options?: any): AxiosPromise<GoogleAccountControllerGetEmployees200Response> {
            return localVarFp.locationControllerGetUsersLocation(page, size, sort, fullTextSearch, name, location, department, position, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLocationDto} updateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerUpdate(id: string, updateLocationDto: UpdateLocationDto, options?: any): AxiosPromise<LocationControllerCreate200Response> {
            return localVarFp.locationControllerUpdate(id, updateLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update location for user in App
         * @param {UserUpdateLocationDto} userUpdateLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationControllerUpdateUserLocation(userUpdateLocationDto: UserUpdateLocationDto, options?: any): AxiosPromise<void> {
            return localVarFp.locationControllerUpdateUserLocation(userUpdateLocationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * 
     * @param {CreateLocationDto} createLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerCreate(createLocationDto: CreateLocationDto, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerCreate(createLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateLocationDto} updateLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerDelete(id: string, updateLocationDto: UpdateLocationDto, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerDelete(id, updateLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerGetAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerGetAll(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerGetUsersAbsenceNow(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerGetUsersAbsenceNow(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {string} [name] 
     * @param {string} [location] 
     * @param {string} [department] 
     * @param {string} [position] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerGetUsersLocation(page: number, size?: number, sort?: string, fullTextSearch?: string, name?: string, location?: string, department?: string, position?: string, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerGetUsersLocation(page, size, sort, fullTextSearch, name, location, department, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateLocationDto} updateLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerUpdate(id: string, updateLocationDto: UpdateLocationDto, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerUpdate(id, updateLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update location for user in App
     * @param {UserUpdateLocationDto} userUpdateLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public locationControllerUpdateUserLocation(userUpdateLocationDto: UserUpdateLocationDto, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).locationControllerUpdateUserLocation(userUpdateLocationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OvertimeApi - axios parameter creator
 * @export
 */
export const OvertimeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get statistic overtime
         * @param {number} year 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overtimeControllerStatisticsOvertime: async (year: number, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('overtimeControllerStatisticsOvertime', 'year', year)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('overtimeControllerStatisticsOvertime', 'userId', userId)
            const localVarPath = `/overtime/statistic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OvertimeApi - functional programming interface
 * @export
 */
export const OvertimeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OvertimeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get statistic overtime
         * @param {number} year 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overtimeControllerStatisticsOvertime(year: number, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OvertimeControllerStatisticsOvertime200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overtimeControllerStatisticsOvertime(year, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OvertimeApi - factory interface
 * @export
 */
export const OvertimeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OvertimeApiFp(configuration)
    return {
        /**
         * 
         * @summary Get statistic overtime
         * @param {number} year 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overtimeControllerStatisticsOvertime(year: number, userId: string, options?: any): AxiosPromise<OvertimeControllerStatisticsOvertime200Response> {
            return localVarFp.overtimeControllerStatisticsOvertime(year, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OvertimeApi - object-oriented interface
 * @export
 * @class OvertimeApi
 * @extends {BaseAPI}
 */
export class OvertimeApi extends BaseAPI {
    /**
     * 
     * @summary Get statistic overtime
     * @param {number} year 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OvertimeApi
     */
    public overtimeControllerStatisticsOvertime(year: number, userId: string, options?: AxiosRequestConfig) {
        return OvertimeApiFp(this.configuration).overtimeControllerStatisticsOvertime(year, userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PositionApi - axios parameter creator
 * @export
 */
export const PositionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreatePositionDto} createPositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerCreate: async (createPositionDto: CreatePositionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPositionDto' is not null or undefined
            assertParamExists('positionControllerCreate', 'createPositionDto', createPositionDto)
            const localVarPath = `/position/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPositionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerFindAll: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('positionControllerFindAll', 'page', page)
            const localVarPath = `/position/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('positionControllerFindOne', 'id', id)
            const localVarPath = `/position/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('positionControllerRemove', 'id', id)
            const localVarPath = `/position/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePositionDto} updatePositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerUpdate: async (id: string, updatePositionDto: UpdatePositionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('positionControllerUpdate', 'id', id)
            // verify required parameter 'updatePositionDto' is not null or undefined
            assertParamExists('positionControllerUpdate', 'updatePositionDto', updatePositionDto)
            const localVarPath = `/position/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePositionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PositionApi - functional programming interface
 * @export
 */
export const PositionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PositionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreatePositionDto} createPositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionControllerCreate(createPositionDto: CreatePositionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionControllerCreate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionControllerCreate(createPositionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionControllerFindAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionControllerFindAll200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionControllerFindAll(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionControllerCreate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionControllerFindOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionControllerRemove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePositionDto} updatePositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionControllerUpdate(id: string, updatePositionDto: UpdatePositionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionControllerUpdate(id, updatePositionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PositionApi - factory interface
 * @export
 */
export const PositionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PositionApiFp(configuration)
    return {
        /**
         * 
         * @param {CreatePositionDto} createPositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerCreate(createPositionDto: CreatePositionDto, options?: any): AxiosPromise<PositionControllerCreate200Response> {
            return localVarFp.positionControllerCreate(createPositionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerFindAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<PositionControllerFindAll200Response> {
            return localVarFp.positionControllerFindAll(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerFindOne(id: string, options?: any): AxiosPromise<PositionControllerCreate200Response> {
            return localVarFp.positionControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerRemove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.positionControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePositionDto} updatePositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionControllerUpdate(id: string, updatePositionDto: UpdatePositionDto, options?: any): AxiosPromise<void> {
            return localVarFp.positionControllerUpdate(id, updatePositionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PositionApi - object-oriented interface
 * @export
 * @class PositionApi
 * @extends {BaseAPI}
 */
export class PositionApi extends BaseAPI {
    /**
     * 
     * @param {CreatePositionDto} createPositionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionControllerCreate(createPositionDto: CreatePositionDto, options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionControllerCreate(createPositionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionControllerFindAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionControllerFindAll(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionControllerFindOne(id: string, options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionControllerRemove(id: string, options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdatePositionDto} updatePositionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionControllerUpdate(id: string, updatePositionDto: UpdatePositionDto, options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionControllerUpdate(id, updatePositionDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QueueApi - axios parameter creator
 * @export
 */
export const QueueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} jobName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueControllerGetListUsers: async (id: string, jobName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('queueControllerGetListUsers', 'id', id)
            // verify required parameter 'jobName' is not null or undefined
            assertParamExists('queueControllerGetListUsers', 'jobName', jobName)
            const localVarPath = `/queue/check-job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (jobName !== undefined) {
                localVarQueryParameter['jobName'] = jobName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueueApi - functional programming interface
 * @export
 */
export const QueueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueueApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} jobName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queueControllerGetListUsers(id: string, jobName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queueControllerGetListUsers(id, jobName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QueueApi - factory interface
 * @export
 */
export const QueueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueueApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} jobName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueControllerGetListUsers(id: string, jobName: string, options?: any): AxiosPromise<object> {
            return localVarFp.queueControllerGetListUsers(id, jobName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueueApi - object-oriented interface
 * @export
 * @class QueueApi
 * @extends {BaseAPI}
 */
export class QueueApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} jobName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    public queueControllerGetListUsers(id: string, jobName: string, options?: AxiosRequestConfig) {
        return QueueApiFp(this.configuration).queueControllerGetListUsers(id, jobName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RecruitmentTypeApi - axios parameter creator
 * @export
 */
export const RecruitmentTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRecruitmentTypeDto} createRecruitmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruitmentTypeControllerCreate: async (createRecruitmentTypeDto: CreateRecruitmentTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRecruitmentTypeDto' is not null or undefined
            assertParamExists('recruitmentTypeControllerCreate', 'createRecruitmentTypeDto', createRecruitmentTypeDto)
            const localVarPath = `/recruitment-type/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRecruitmentTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruitmentTypeControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('recruitmentTypeControllerDelete', 'id', id)
            const localVarPath = `/recruitment-type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruitmentTypeControllerGetAll: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('recruitmentTypeControllerGetAll', 'page', page)
            const localVarPath = `/recruitment-type/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateRecruitmentTypeDto} createRecruitmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruitmentTypeControllerUpdate: async (id: string, createRecruitmentTypeDto: CreateRecruitmentTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('recruitmentTypeControllerUpdate', 'id', id)
            // verify required parameter 'createRecruitmentTypeDto' is not null or undefined
            assertParamExists('recruitmentTypeControllerUpdate', 'createRecruitmentTypeDto', createRecruitmentTypeDto)
            const localVarPath = `/recruitment-type/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRecruitmentTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecruitmentTypeApi - functional programming interface
 * @export
 */
export const RecruitmentTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecruitmentTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRecruitmentTypeDto} createRecruitmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recruitmentTypeControllerCreate(createRecruitmentTypeDto: CreateRecruitmentTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecruitmentType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recruitmentTypeControllerCreate(createRecruitmentTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recruitmentTypeControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recruitmentTypeControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recruitmentTypeControllerGetAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecruitmentTypeControllerGetAll200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recruitmentTypeControllerGetAll(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateRecruitmentTypeDto} createRecruitmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recruitmentTypeControllerUpdate(id: string, createRecruitmentTypeDto: CreateRecruitmentTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecruitmentTypeControllerUpdate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recruitmentTypeControllerUpdate(id, createRecruitmentTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RecruitmentTypeApi - factory interface
 * @export
 */
export const RecruitmentTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecruitmentTypeApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateRecruitmentTypeDto} createRecruitmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruitmentTypeControllerCreate(createRecruitmentTypeDto: CreateRecruitmentTypeDto, options?: any): AxiosPromise<RecruitmentType> {
            return localVarFp.recruitmentTypeControllerCreate(createRecruitmentTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruitmentTypeControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.recruitmentTypeControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruitmentTypeControllerGetAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<RecruitmentTypeControllerGetAll200Response> {
            return localVarFp.recruitmentTypeControllerGetAll(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateRecruitmentTypeDto} createRecruitmentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruitmentTypeControllerUpdate(id: string, createRecruitmentTypeDto: CreateRecruitmentTypeDto, options?: any): AxiosPromise<RecruitmentTypeControllerUpdate200Response> {
            return localVarFp.recruitmentTypeControllerUpdate(id, createRecruitmentTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecruitmentTypeApi - object-oriented interface
 * @export
 * @class RecruitmentTypeApi
 * @extends {BaseAPI}
 */
export class RecruitmentTypeApi extends BaseAPI {
    /**
     * 
     * @param {CreateRecruitmentTypeDto} createRecruitmentTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentTypeApi
     */
    public recruitmentTypeControllerCreate(createRecruitmentTypeDto: CreateRecruitmentTypeDto, options?: AxiosRequestConfig) {
        return RecruitmentTypeApiFp(this.configuration).recruitmentTypeControllerCreate(createRecruitmentTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentTypeApi
     */
    public recruitmentTypeControllerDelete(id: string, options?: AxiosRequestConfig) {
        return RecruitmentTypeApiFp(this.configuration).recruitmentTypeControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentTypeApi
     */
    public recruitmentTypeControllerGetAll(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return RecruitmentTypeApiFp(this.configuration).recruitmentTypeControllerGetAll(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateRecruitmentTypeDto} createRecruitmentTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruitmentTypeApi
     */
    public recruitmentTypeControllerUpdate(id: string, createRecruitmentTypeDto: CreateRecruitmentTypeDto, options?: AxiosRequestConfig) {
        return RecruitmentTypeApiFp(this.configuration).recruitmentTypeControllerUpdate(id, createRecruitmentTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReminderTimeApi - axios parameter creator
 * @export
 */
export const ReminderTimeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderTimeControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reminder-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateReminderTimeDto} createReminderTimeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderTimeControllerSave: async (createReminderTimeDto: CreateReminderTimeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReminderTimeDto' is not null or undefined
            assertParamExists('reminderTimeControllerSave', 'createReminderTimeDto', createReminderTimeDto)
            const localVarPath = `/reminder-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReminderTimeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReminderTimeApi - functional programming interface
 * @export
 */
export const ReminderTimeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReminderTimeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reminderTimeControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReminderTimeControllerFindAll200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reminderTimeControllerFindAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateReminderTimeDto} createReminderTimeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reminderTimeControllerSave(createReminderTimeDto: CreateReminderTimeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReminderTimeControllerSave200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reminderTimeControllerSave(createReminderTimeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReminderTimeApi - factory interface
 * @export
 */
export const ReminderTimeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReminderTimeApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderTimeControllerFindAll(options?: any): AxiosPromise<ReminderTimeControllerFindAll200Response> {
            return localVarFp.reminderTimeControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateReminderTimeDto} createReminderTimeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderTimeControllerSave(createReminderTimeDto: CreateReminderTimeDto, options?: any): AxiosPromise<ReminderTimeControllerSave200Response> {
            return localVarFp.reminderTimeControllerSave(createReminderTimeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReminderTimeApi - object-oriented interface
 * @export
 * @class ReminderTimeApi
 * @extends {BaseAPI}
 */
export class ReminderTimeApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderTimeApi
     */
    public reminderTimeControllerFindAll(options?: AxiosRequestConfig) {
        return ReminderTimeApiFp(this.configuration).reminderTimeControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateReminderTimeDto} createReminderTimeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderTimeApi
     */
    public reminderTimeControllerSave(createReminderTimeDto: CreateReminderTimeDto, options?: AxiosRequestConfig) {
        return ReminderTimeApiFp(this.configuration).reminderTimeControllerSave(createReminderTimeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create report, like outside for private event or business
         * @param {CreateReportDto} createReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerCreate: async (createReportDto: CreateReportDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReportDto' is not null or undefined
            assertParamExists('reportControllerCreate', 'createReportDto', createReportDto)
            const localVarPath = `/report/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerDeleteReport: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reportControllerDeleteReport', 'id', id)
            const localVarPath = `/report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reports with filters for employee
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} page 
         * @param {string} [userId] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerGetListReport: async (startDate: string, endDate: string, page: number, userId?: string, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('reportControllerGetListReport', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('reportControllerGetListReport', 'endDate', endDate)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('reportControllerGetListReport', 'page', page)
            const localVarPath = `/report/employee/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReportDto} updateReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerUpdateReport: async (id: string, updateReportDto: UpdateReportDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reportControllerUpdateReport', 'id', id)
            // verify required parameter 'updateReportDto' is not null or undefined
            assertParamExists('reportControllerUpdateReport', 'updateReportDto', updateReportDto)
            const localVarPath = `/report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create report, like outside for private event or business
         * @param {CreateReportDto} createReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerCreate(createReportDto: CreateReportDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimekeepingReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerCreate(createReportDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerDeleteReport(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimekeepingReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerDeleteReport(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get reports with filters for employee
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} page 
         * @param {string} [userId] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerGetListReport(startDate: string, endDate: string, page: number, userId?: string, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportControllerGetListReport200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerGetListReport(startDate, endDate, page, userId, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReportDto} updateReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportControllerUpdateReport(id: string, updateReportDto: UpdateReportDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimekeepingReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerUpdateReport(id, updateReportDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)
    return {
        /**
         * 
         * @summary Create report, like outside for private event or business
         * @param {CreateReportDto} createReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerCreate(createReportDto: CreateReportDto, options?: any): AxiosPromise<TimekeepingReport> {
            return localVarFp.reportControllerCreate(createReportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerDeleteReport(id: string, options?: any): AxiosPromise<TimekeepingReport> {
            return localVarFp.reportControllerDeleteReport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reports with filters for employee
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} page 
         * @param {string} [userId] 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerGetListReport(startDate: string, endDate: string, page: number, userId?: string, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<ReportControllerGetListReport200Response> {
            return localVarFp.reportControllerGetListReport(startDate, endDate, page, userId, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateReportDto} updateReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportControllerUpdateReport(id: string, updateReportDto: UpdateReportDto, options?: any): AxiosPromise<TimekeepingReport> {
            return localVarFp.reportControllerUpdateReport(id, updateReportDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * 
     * @summary Create report, like outside for private event or business
     * @param {CreateReportDto} createReportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerCreate(createReportDto: CreateReportDto, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerCreate(createReportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerDeleteReport(id: string, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerDeleteReport(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reports with filters for employee
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {number} page 
     * @param {string} [userId] 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerGetListReport(startDate: string, endDate: string, page: number, userId?: string, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerGetListReport(startDate, endDate, page, userId, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateReportDto} updateReportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public reportControllerUpdateReport(id: string, updateReportDto: UpdateReportDto, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).reportControllerUpdateReport(id, updateReportDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ScheduleSettingsApi - axios parameter creator
 * @export
 */
export const ScheduleSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSettingControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduleSettingControllerDelete', 'id', id)
            const localVarPath = `/schedule-settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSettingControllerGetById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduleSettingControllerGetById', 'id', id)
            const localVarPath = `/schedule-settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSettingControllerGetList: async (date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/schedule-settings/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateScheduleSettingDto} createScheduleSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSettingControllerUpdate: async (id: string, createScheduleSettingDto: CreateScheduleSettingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduleSettingControllerUpdate', 'id', id)
            // verify required parameter 'createScheduleSettingDto' is not null or undefined
            assertParamExists('scheduleSettingControllerUpdate', 'createScheduleSettingDto', createScheduleSettingDto)
            const localVarPath = `/schedule-settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createScheduleSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScheduleSettingsApi - functional programming interface
 * @export
 */
export const ScheduleSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScheduleSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleSettingControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleSettingControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleSettingControllerGetById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleSettingControllerGetById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleSettingControllerGetById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleSettingControllerGetList(date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleSettingControllerGetList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleSettingControllerGetList(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateScheduleSettingDto} createScheduleSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleSettingControllerUpdate(id: string, createScheduleSettingDto: CreateScheduleSettingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleSettingControllerUpdate(id, createScheduleSettingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ScheduleSettingsApi - factory interface
 * @export
 */
export const ScheduleSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScheduleSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSettingControllerDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.scheduleSettingControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSettingControllerGetById(id: string, options?: any): AxiosPromise<ScheduleSettingControllerGetById200Response> {
            return localVarFp.scheduleSettingControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSettingControllerGetList(date?: string, options?: any): AxiosPromise<ScheduleSettingControllerGetList200Response> {
            return localVarFp.scheduleSettingControllerGetList(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateScheduleSettingDto} createScheduleSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSettingControllerUpdate(id: string, createScheduleSettingDto: CreateScheduleSettingDto, options?: any): AxiosPromise<ScheduleSetting> {
            return localVarFp.scheduleSettingControllerUpdate(id, createScheduleSettingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScheduleSettingsApi - object-oriented interface
 * @export
 * @class ScheduleSettingsApi
 * @extends {BaseAPI}
 */
export class ScheduleSettingsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleSettingsApi
     */
    public scheduleSettingControllerDelete(id: string, options?: AxiosRequestConfig) {
        return ScheduleSettingsApiFp(this.configuration).scheduleSettingControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleSettingsApi
     */
    public scheduleSettingControllerGetById(id: string, options?: AxiosRequestConfig) {
        return ScheduleSettingsApiFp(this.configuration).scheduleSettingControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleSettingsApi
     */
    public scheduleSettingControllerGetList(date?: string, options?: AxiosRequestConfig) {
        return ScheduleSettingsApiFp(this.configuration).scheduleSettingControllerGetList(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateScheduleSettingDto} createScheduleSettingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleSettingsApi
     */
    public scheduleSettingControllerUpdate(id: string, createScheduleSettingDto: CreateScheduleSettingDto, options?: AxiosRequestConfig) {
        return ScheduleSettingsApiFp(this.configuration).scheduleSettingControllerUpdate(id, createScheduleSettingDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SchedulesApi - axios parameter creator
 * @export
 */
export const SchedulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateScheduleDto} createScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerCreate: async (createScheduleDto: CreateScheduleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createScheduleDto' is not null or undefined
            assertParamExists('scheduleControllerCreate', 'createScheduleDto', createScheduleDto)
            const localVarPath = `/schedules/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createScheduleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerDeleteBooking: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduleControllerDeleteBooking', 'id', id)
            const localVarPath = `/schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerGetAll: async (page: number, size?: number, sort?: string, fullTextSearch?: string, startDate?: string, endDate?: string, userId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('scheduleControllerGetAll', 'page', page)
            const localVarPath = `/schedules/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerGetById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduleControllerGetById', 'id', id)
            const localVarPath = `/schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerGetListScheduleByUserId: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/schedules/list-schedule-by-user-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerGetListSelect: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/schedules/select`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateScheduleDto} createScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerUpdate: async (id: string, createScheduleDto: CreateScheduleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduleControllerUpdate', 'id', id)
            // verify required parameter 'createScheduleDto' is not null or undefined
            assertParamExists('scheduleControllerUpdate', 'createScheduleDto', createScheduleDto)
            const localVarPath = `/schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createScheduleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerUploadFile: async (id: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduleControllerUploadFile', 'id', id)
            const localVarPath = `/schedules/upload/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulesApi - functional programming interface
 * @export
 */
export const SchedulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateScheduleDto} createScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleControllerCreate(createScheduleDto: CreateScheduleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Schedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleControllerCreate(createScheduleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleControllerDeleteBooking(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleControllerDeleteBooking(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleControllerGetAll(page: number, size?: number, sort?: string, fullTextSearch?: string, startDate?: string, endDate?: string, userId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleControllerGetAll200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleControllerGetAll(page, size, sort, fullTextSearch, startDate, endDate, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleControllerGetById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Schedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleControllerGetById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleControllerGetListScheduleByUserId(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleControllerGetListScheduleByUserId(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleControllerGetListSelect(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleControllerGetListSelect200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleControllerGetListSelect(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateScheduleDto} createScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleControllerUpdate(id: string, createScheduleDto: CreateScheduleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Schedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleControllerUpdate(id, createScheduleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleControllerUploadFile(id: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Schedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleControllerUploadFile(id, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchedulesApi - factory interface
 * @export
 */
export const SchedulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateScheduleDto} createScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerCreate(createScheduleDto: CreateScheduleDto, options?: any): AxiosPromise<Schedule> {
            return localVarFp.scheduleControllerCreate(createScheduleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerDeleteBooking(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.scheduleControllerDeleteBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerGetAll(page: number, size?: number, sort?: string, fullTextSearch?: string, startDate?: string, endDate?: string, userId?: string, options?: any): AxiosPromise<ScheduleControllerGetAll200Response> {
            return localVarFp.scheduleControllerGetAll(page, size, sort, fullTextSearch, startDate, endDate, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerGetById(id: string, options?: any): AxiosPromise<Schedule> {
            return localVarFp.scheduleControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerGetListScheduleByUserId(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.scheduleControllerGetListScheduleByUserId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerGetListSelect(options?: any): AxiosPromise<ScheduleControllerGetListSelect200Response> {
            return localVarFp.scheduleControllerGetListSelect(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateScheduleDto} createScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerUpdate(id: string, createScheduleDto: CreateScheduleDto, options?: any): AxiosPromise<Schedule> {
            return localVarFp.scheduleControllerUpdate(id, createScheduleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleControllerUploadFile(id: string, file?: File, options?: any): AxiosPromise<Schedule> {
            return localVarFp.scheduleControllerUploadFile(id, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulesApi - object-oriented interface
 * @export
 * @class SchedulesApi
 * @extends {BaseAPI}
 */
export class SchedulesApi extends BaseAPI {
    /**
     * 
     * @param {CreateScheduleDto} createScheduleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public scheduleControllerCreate(createScheduleDto: CreateScheduleDto, options?: AxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).scheduleControllerCreate(createScheduleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public scheduleControllerDeleteBooking(id: string, options?: AxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).scheduleControllerDeleteBooking(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public scheduleControllerGetAll(page: number, size?: number, sort?: string, fullTextSearch?: string, startDate?: string, endDate?: string, userId?: string, options?: AxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).scheduleControllerGetAll(page, size, sort, fullTextSearch, startDate, endDate, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public scheduleControllerGetById(id: string, options?: AxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).scheduleControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public scheduleControllerGetListScheduleByUserId(options?: AxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).scheduleControllerGetListScheduleByUserId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public scheduleControllerGetListSelect(options?: AxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).scheduleControllerGetListSelect(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateScheduleDto} createScheduleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public scheduleControllerUpdate(id: string, createScheduleDto: CreateScheduleDto, options?: AxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).scheduleControllerUpdate(id, createScheduleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public scheduleControllerUploadFile(id: string, file?: File, options?: AxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).scheduleControllerUploadFile(id, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TimekeepingApi - axios parameter creator
 * @export
 */
export const TimekeepingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} employeeId 
         * @param {string} month 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerExportTimekeepingToCsv: async (employeeId: string, month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('timekeepingControllerExportTimekeepingToCsv', 'employeeId', employeeId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('timekeepingControllerExportTimekeepingToCsv', 'month', month)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('timekeepingControllerExportTimekeepingToCsv', 'page', page)
            const localVarPath = `/timekeeping/historyCSV/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} month 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerExportTimekeepingToCsvAll: async (month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('timekeepingControllerExportTimekeepingToCsvAll', 'month', month)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('timekeepingControllerExportTimekeepingToCsvAll', 'page', page)
            const localVarPath = `/timekeeping/historyCSV/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} month 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetEmployeeTimekeepingHistory: async (employeeId: string, month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('timekeepingControllerGetEmployeeTimekeepingHistory', 'employeeId', employeeId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('timekeepingControllerGetEmployeeTimekeepingHistory', 'month', month)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('timekeepingControllerGetEmployeeTimekeepingHistory', 'page', page)
            const localVarPath = `/timekeeping/history/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetEmployeeTimekeepingHistoryStatistic: async (employeeId: string, month: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('timekeepingControllerGetEmployeeTimekeepingHistoryStatistic', 'employeeId', employeeId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('timekeepingControllerGetEmployeeTimekeepingHistoryStatistic', 'month', month)
            const localVarPath = `/timekeeping/history/{employeeId}/statistic`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {string} [date] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetListTimekeeping: async (page: number, size?: number, sort?: string, fullTextSearch?: string, date?: string, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('timekeepingControllerGetListTimekeeping', 'page', page)
            const localVarPath = `/timekeeping/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetListUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/timekeeping/today`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/timekeeping/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerTest: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/timekeeping/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {UpdateEmployeeTimekeeping} updateEmployeeTimekeeping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerUpdateEmployeeTimekeeping: async (employeeId: string, updateEmployeeTimekeeping: UpdateEmployeeTimekeeping, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('timekeepingControllerUpdateEmployeeTimekeeping', 'employeeId', employeeId)
            // verify required parameter 'updateEmployeeTimekeeping' is not null or undefined
            assertParamExists('timekeepingControllerUpdateEmployeeTimekeeping', 'updateEmployeeTimekeeping', updateEmployeeTimekeeping)
            const localVarPath = `/timekeeping/history/{employeeId}/update`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeTimekeeping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimekeepingApi - functional programming interface
 * @export
 */
export const TimekeepingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimekeepingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} employeeId 
         * @param {string} month 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timekeepingControllerExportTimekeepingToCsv(employeeId: string, month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimekeepingControllerGetEmployeeTimekeepingHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timekeepingControllerExportTimekeepingToCsv(employeeId, month, page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} month 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timekeepingControllerExportTimekeepingToCsvAll(month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimekeepingControllerGetEmployeeTimekeepingHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timekeepingControllerExportTimekeepingToCsvAll(month, page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} month 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timekeepingControllerGetEmployeeTimekeepingHistory(employeeId: string, month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimekeepingControllerGetEmployeeTimekeepingHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timekeepingControllerGetEmployeeTimekeepingHistory(employeeId, month, page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timekeepingControllerGetEmployeeTimekeepingHistoryStatistic(employeeId: string, month: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timekeepingControllerGetEmployeeTimekeepingHistoryStatistic(employeeId, month, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {string} [date] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timekeepingControllerGetListTimekeeping(page: number, size?: number, sort?: string, fullTextSearch?: string, date?: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timekeepingControllerGetListTimekeeping(page, size, sort, fullTextSearch, date, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timekeepingControllerGetListUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timekeepingControllerGetListUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timekeepingControllerGetStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timekeepingControllerGetStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timekeepingControllerTest(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timekeepingControllerTest(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {UpdateEmployeeTimekeeping} updateEmployeeTimekeeping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timekeepingControllerUpdateEmployeeTimekeeping(employeeId: string, updateEmployeeTimekeeping: UpdateEmployeeTimekeeping, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimekeepingControllerUpdateEmployeeTimekeeping200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timekeepingControllerUpdateEmployeeTimekeeping(employeeId, updateEmployeeTimekeeping, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TimekeepingApi - factory interface
 * @export
 */
export const TimekeepingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimekeepingApiFp(configuration)
    return {
        /**
         * 
         * @param {string} employeeId 
         * @param {string} month 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerExportTimekeepingToCsv(employeeId: string, month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<TimekeepingControllerGetEmployeeTimekeepingHistory200Response> {
            return localVarFp.timekeepingControllerExportTimekeepingToCsv(employeeId, month, page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} month 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerExportTimekeepingToCsvAll(month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<TimekeepingControllerGetEmployeeTimekeepingHistory200Response> {
            return localVarFp.timekeepingControllerExportTimekeepingToCsvAll(month, page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} month 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetEmployeeTimekeepingHistory(employeeId: string, month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<TimekeepingControllerGetEmployeeTimekeepingHistory200Response> {
            return localVarFp.timekeepingControllerGetEmployeeTimekeepingHistory(employeeId, month, page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetEmployeeTimekeepingHistoryStatistic(employeeId: string, month: string, options?: any): AxiosPromise<TimekeepingControllerGetEmployeeTimekeepingHistoryStatistic200Response> {
            return localVarFp.timekeepingControllerGetEmployeeTimekeepingHistoryStatistic(employeeId, month, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {string} [date] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetListTimekeeping(page: number, size?: number, sort?: string, fullTextSearch?: string, date?: string, startDate?: string, endDate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.timekeepingControllerGetListTimekeeping(page, size, sort, fullTextSearch, date, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetListUsers(options?: any): AxiosPromise<object> {
            return localVarFp.timekeepingControllerGetListUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerGetStatistics(options?: any): AxiosPromise<void> {
            return localVarFp.timekeepingControllerGetStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerTest(options?: any): AxiosPromise<object> {
            return localVarFp.timekeepingControllerTest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {UpdateEmployeeTimekeeping} updateEmployeeTimekeeping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timekeepingControllerUpdateEmployeeTimekeeping(employeeId: string, updateEmployeeTimekeeping: UpdateEmployeeTimekeeping, options?: any): AxiosPromise<TimekeepingControllerUpdateEmployeeTimekeeping200Response> {
            return localVarFp.timekeepingControllerUpdateEmployeeTimekeeping(employeeId, updateEmployeeTimekeeping, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimekeepingApi - object-oriented interface
 * @export
 * @class TimekeepingApi
 * @extends {BaseAPI}
 */
export class TimekeepingApi extends BaseAPI {
    /**
     * 
     * @param {string} employeeId 
     * @param {string} month 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimekeepingApi
     */
    public timekeepingControllerExportTimekeepingToCsv(employeeId: string, month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return TimekeepingApiFp(this.configuration).timekeepingControllerExportTimekeepingToCsv(employeeId, month, page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} month 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimekeepingApi
     */
    public timekeepingControllerExportTimekeepingToCsvAll(month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return TimekeepingApiFp(this.configuration).timekeepingControllerExportTimekeepingToCsvAll(month, page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {string} month 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimekeepingApi
     */
    public timekeepingControllerGetEmployeeTimekeepingHistory(employeeId: string, month: string, page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return TimekeepingApiFp(this.configuration).timekeepingControllerGetEmployeeTimekeepingHistory(employeeId, month, page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {string} month 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimekeepingApi
     */
    public timekeepingControllerGetEmployeeTimekeepingHistoryStatistic(employeeId: string, month: string, options?: AxiosRequestConfig) {
        return TimekeepingApiFp(this.configuration).timekeepingControllerGetEmployeeTimekeepingHistoryStatistic(employeeId, month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {string} [date] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimekeepingApi
     */
    public timekeepingControllerGetListTimekeeping(page: number, size?: number, sort?: string, fullTextSearch?: string, date?: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return TimekeepingApiFp(this.configuration).timekeepingControllerGetListTimekeeping(page, size, sort, fullTextSearch, date, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimekeepingApi
     */
    public timekeepingControllerGetListUsers(options?: AxiosRequestConfig) {
        return TimekeepingApiFp(this.configuration).timekeepingControllerGetListUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimekeepingApi
     */
    public timekeepingControllerGetStatistics(options?: AxiosRequestConfig) {
        return TimekeepingApiFp(this.configuration).timekeepingControllerGetStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimekeepingApi
     */
    public timekeepingControllerTest(options?: AxiosRequestConfig) {
        return TimekeepingApiFp(this.configuration).timekeepingControllerTest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {UpdateEmployeeTimekeeping} updateEmployeeTimekeeping 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimekeepingApi
     */
    public timekeepingControllerUpdateEmployeeTimekeeping(employeeId: string, updateEmployeeTimekeeping: UpdateEmployeeTimekeeping, options?: AxiosRequestConfig) {
        return TimekeepingApiFp(this.configuration).timekeepingControllerUpdateEmployeeTimekeeping(employeeId, updateEmployeeTimekeeping, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} imgpath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerDeleteImage: async (imgpath: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imgpath' is not null or undefined
            assertParamExists('uploadControllerDeleteImage', 'imgpath', imgpath)
            const localVarPath = `/upload/{imgpath}`
                .replace(`{${"imgpath"}}`, encodeURIComponent(String(imgpath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} imgpath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerGetReceipt: async (imgpath: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imgpath' is not null or undefined
            assertParamExists('uploadControllerGetReceipt', 'imgpath', imgpath)
            const localVarPath = `/upload/receipt/{imgpath}`
                .replace(`{${"imgpath"}}`, encodeURIComponent(String(imgpath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} imgpath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerSeeUploadedFile: async (imgpath: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imgpath' is not null or undefined
            assertParamExists('uploadControllerSeeUploadedFile', 'imgpath', imgpath)
            const localVarPath = `/upload/{imgpath}`
                .replace(`{${"imgpath"}}`, encodeURIComponent(String(imgpath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload multiple images
         * @param {Array<File>} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadMultipleFiles: async (image?: Array<File>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/upload/multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (image) {
                image.forEach((element) => {
                    localVarFormParams.append('image', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadedFile: async (image?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} imgpath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadControllerDeleteImage(imgpath: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadControllerDeleteImage(imgpath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} imgpath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadControllerGetReceipt(imgpath: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadControllerGetReceipt(imgpath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} imgpath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadControllerSeeUploadedFile(imgpath: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadControllerSeeUploadedFile(imgpath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload multiple images
         * @param {Array<File>} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadControllerUploadMultipleFiles(image?: Array<File>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadControllerUploadMultipleFiles(image, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadControllerUploadedFile(image?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadControllerUploadedFile(image, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)
    return {
        /**
         * 
         * @param {string} imgpath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerDeleteImage(imgpath: string, options?: any): AxiosPromise<void> {
            return localVarFp.uploadControllerDeleteImage(imgpath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} imgpath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerGetReceipt(imgpath: string, options?: any): AxiosPromise<object> {
            return localVarFp.uploadControllerGetReceipt(imgpath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} imgpath 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerSeeUploadedFile(imgpath: string, options?: any): AxiosPromise<object> {
            return localVarFp.uploadControllerSeeUploadedFile(imgpath, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload multiple images
         * @param {Array<File>} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadMultipleFiles(image?: Array<File>, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.uploadControllerUploadMultipleFiles(image, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [image] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadedFile(image?: File, options?: any): AxiosPromise<void> {
            return localVarFp.uploadControllerUploadedFile(image, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
    /**
     * 
     * @param {string} imgpath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public uploadControllerDeleteImage(imgpath: string, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).uploadControllerDeleteImage(imgpath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} imgpath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public uploadControllerGetReceipt(imgpath: string, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).uploadControllerGetReceipt(imgpath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} imgpath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public uploadControllerSeeUploadedFile(imgpath: string, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).uploadControllerSeeUploadedFile(imgpath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload multiple images
     * @param {Array<File>} [image] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public uploadControllerUploadMultipleFiles(image?: Array<File>, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).uploadControllerUploadMultipleFiles(image, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [image] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public uploadControllerUploadedFile(image?: File, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).uploadControllerUploadedFile(image, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateManyUserDto} createManyUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateManyUser: async (createManyUserDto: CreateManyUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyUserDto' is not null or undefined
            assertParamExists('userControllerCreateManyUser', 'createManyUserDto', createManyUserDto)
            const localVarPath = `/users/create-many`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateUser: async (createUserDto: CreateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('userControllerCreateUser', 'createUserDto', createUserDto)
            const localVarPath = `/users/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteUserById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerDeleteUserById', 'id', id)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export csv user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerExportUserToCsv: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/export-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAllEmployeesByManager: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('userControllerGetAllEmployeesByManager', 'page', page)
            const localVarPath = `/users/list/by-manager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetEmployeeRelatedInformation: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/employee-related-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetListManager: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/list/manager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetListUsers: async (page: number, size?: number, sort?: string, fullTextSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('userControllerGetListUsers', 'page', page)
            const localVarPath = `/users/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerGetUserById', 'id', id)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdatePersonalSettingsCalendarDto} updatePersonalSettingsCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdatePersonalSettingsCalendar: async (updatePersonalSettingsCalendarDto: UpdatePersonalSettingsCalendarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePersonalSettingsCalendarDto' is not null or undefined
            assertParamExists('userControllerUpdatePersonalSettingsCalendar', 'updatePersonalSettingsCalendarDto', updatePersonalSettingsCalendarDto)
            const localVarPath = `/users/settings/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePersonalSettingsCalendarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateUser: async (id: string, updateUserDto: UpdateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerUpdateUser', 'id', id)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('userControllerUpdateUser', 'updateUserDto', updateUserDto)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateManyUserDto} createManyUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerCreateManyUser(createManyUserDto: CreateManyUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerCreateManyUser(createManyUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerCreateUser(createUserDto: CreateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerCreateUser(createUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerDeleteUserById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerDeleteUserById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export csv user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerExportUserToCsv(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserControllerExportUserToCsv200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerExportUserToCsv(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetAllEmployeesByManager(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerGetEmployees200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAllEmployeesByManager(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetEmployeeRelatedInformation(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserControllerGetEmployeeRelatedInformation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetEmployeeRelatedInformation(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetListManager(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserControllerGetListManager200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetListManager(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetListUsers(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoogleAccountControllerGetEmployees200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetListUsers(page, size, sort, fullTextSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetUserById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserControllerGetUserById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetUserById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdatePersonalSettingsCalendarDto} updatePersonalSettingsCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdatePersonalSettingsCalendar(updatePersonalSettingsCalendarDto: UpdatePersonalSettingsCalendarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdatePersonalSettingsCalendar(updatePersonalSettingsCalendarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdateUser(id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateUser(id, updateUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateManyUserDto} createManyUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateManyUser(createManyUserDto: CreateManyUserDto, options?: any): AxiosPromise<object> {
            return localVarFp.userControllerCreateManyUser(createManyUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateUser(createUserDto: CreateUserDto, options?: any): AxiosPromise<User> {
            return localVarFp.userControllerCreateUser(createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteUserById(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.userControllerDeleteUserById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export csv user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerExportUserToCsv(options?: any): AxiosPromise<UserControllerExportUserToCsv200Response> {
            return localVarFp.userControllerExportUserToCsv(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAllEmployeesByManager(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<GoogleAccountControllerGetEmployees200Response> {
            return localVarFp.userControllerGetAllEmployeesByManager(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetEmployeeRelatedInformation(options?: any): AxiosPromise<UserControllerGetEmployeeRelatedInformation200Response> {
            return localVarFp.userControllerGetEmployeeRelatedInformation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetListManager(options?: any): AxiosPromise<UserControllerGetListManager200Response> {
            return localVarFp.userControllerGetListManager(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} [size] 
         * @param {string} [sort] 
         * @param {string} [fullTextSearch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetListUsers(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: any): AxiosPromise<GoogleAccountControllerGetEmployees200Response> {
            return localVarFp.userControllerGetListUsers(page, size, sort, fullTextSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserById(id: string, options?: any): AxiosPromise<UserControllerGetUserById200Response> {
            return localVarFp.userControllerGetUserById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdatePersonalSettingsCalendarDto} updatePersonalSettingsCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdatePersonalSettingsCalendar(updatePersonalSettingsCalendarDto: UpdatePersonalSettingsCalendarDto, options?: any): AxiosPromise<object> {
            return localVarFp.userControllerUpdatePersonalSettingsCalendar(updatePersonalSettingsCalendarDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdateUser(id: string, updateUserDto: UpdateUserDto, options?: any): AxiosPromise<User> {
            return localVarFp.userControllerUpdateUser(id, updateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {CreateManyUserDto} createManyUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerCreateManyUser(createManyUserDto: CreateManyUserDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerCreateManyUser(createManyUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateUserDto} createUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerCreateUser(createUserDto: CreateUserDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerCreateUser(createUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerDeleteUserById(id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerDeleteUserById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export csv user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerExportUserToCsv(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerExportUserToCsv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerGetAllEmployeesByManager(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerGetAllEmployeesByManager(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerGetEmployeeRelatedInformation(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerGetEmployeeRelatedInformation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerGetListManager(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerGetListManager(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} [size] 
     * @param {string} [sort] 
     * @param {string} [fullTextSearch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerGetListUsers(page: number, size?: number, sort?: string, fullTextSearch?: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerGetListUsers(page, size, sort, fullTextSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerGetUserById(id: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerGetUserById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdatePersonalSettingsCalendarDto} updatePersonalSettingsCalendarDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerUpdatePersonalSettingsCalendar(updatePersonalSettingsCalendarDto: UpdatePersonalSettingsCalendarDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerUpdatePersonalSettingsCalendar(updatePersonalSettingsCalendarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateUserDto} updateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userControllerUpdateUser(id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userControllerUpdateUser(id, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}


